window.IDPSystemRecipes={
  "systems": [
    {
      "id": "idp-floor-ep-mortar-15",
      "name": "IDP Mortero epoxi industrial de 15 mm",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-floor-ep-mortar-15-es.pdf",
      "systemUrl": "/products/idp-floor-ep-mortar-15",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "imprimacion-epoxi-bicomponente-de-baja-viscosidad-y-altos-solidos",
          "name": "Imprimación epoxi bicomponente de baja viscosidad y altos sólidos",
          "sourceName": "IDP Imprimación Epoxi Baja Viscosidad",
          "consumption": 0.3,
          "officialConsumption": 0.3,
          "officialLabel": "0,300 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-007.pdf",
          "commercialName": "IDP Imprimación Epoxi Baja Viscosidad",
          "technicalName": "Imprimación epoxi bicomponente de baja viscosidad y altos sólidos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-bicomponente-de-baja-viscosidad-y-altos-solidos"
        },
        {
          "phase": "Ligante del mortero",
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "name": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "sourceName": "IDP MasterCoat 100",
          "consumption": 4.5,
          "officialConsumption": 4.5,
          "officialLabel": "4,5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-030.pdf",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        },
        {
          "phase": "Árido del mortero",
          "productId": "arido-de-cuarzo-idp",
          "name": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "sourceName": "Árido de cuarzo IDP",
          "consumption": 30,
          "officialConsumption": 30,
          "officialLabel": "30 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f07-092.pdf",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Saturación y acabado",
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "name": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "sourceName": "IDP MasterCoat 100 pigmentado",
          "consumption": 0.8,
          "officialConsumption": 0.8,
          "officialLabel": "0,50-0,80 kg/m²",
          "coats": 2,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-030.pdf",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "commercialName": "IDP Mortero epoxi industrial de 15 mm",
      "technicalName": "Sistema técnico de mortero epoxi industrial de 15 mm",
      "description": "Sistema de mortero epoxi industrial de 15 mm para la ejecución y reparación de pavimentos continuos de elevado espesor sobre soportes preparados.",
      "applications": "Industria general, mantenimiento, logística, almacenes, talleres y zonas que requieran un recrecido industrial de 15 mm.",
      "keywords": "IDP Imprimación Epoxi Baja Viscosidad | Imprimación epoxi bicomponente de baja viscosidad y altos sólidos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos"
    },
    {
      "id": "idp-proof-pua-basic",
      "name": "IDP Poliurea pura proyectada en caliente",
      "note": "Configuración seca de cubierta: imprimación epoxi independiente 0,50 kg/m² TOTAL (2 × 0,25) y poliurea PURA proyectada 2,00 kg/m². Total 2,50 kg/m²; para 100 m² + 5 %: 262,50 kg, antes de redondear envases. No multiplicar de nuevo el total por las manos. Membrana A poliamina / B isocianato aromático, A:B 1:1 en VOLUMEN o 1:1,17 en PESO; no híbrida ni formulación ignifugada distinta. Sin cuarzo ni acabado adicional por defecto. Aproximadamente 2 mm de membrana de origen, verificar espesor real; no convertir kilos de todo el sistema en mm. Contacto potable solo con formulación, pigmento azul, curado de ficha13/09/2022 y aplicador autorizados conforme al alcance WRAS2208579; no certificación automática del sistema IDP o imprimación. La selección no incluye dilución; variante de primera mano con10% de diluyente específico requiere confirmación y medición aparte.",
      "sheet": "IDP_Poliurea_pura_proyectada_en_caliente_9e37cc47-fee9-4d30-b60f-950a4eea1664.pdf",
      "systemUrl": "/products/idp-proof-pua-basic",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "idp-epoxy-100",
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana PURA por proyección caliente",
          "productId": "idp-membrana-de-poliurea-pura-proyectada-en-caliente",
          "name": "IDP Membrana de poliurea pura proyectada en caliente",
          "commercialName": "IDP Membrana de poliurea pura proyectada en caliente",
          "technicalName": "IDP Membrana de poliurea pura proyectada en caliente",
          "sourceName": "IDP Membrana de poliurea pura proyectada en caliente",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2,00 kg/m² de A+B; no duplicar por ser bicomponente",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_pura_proyectada_en_caliente.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-membrana-de-poliurea-pura-proyectada-en-caliente"
        }
      ],
      "commercialName": "IDP Poliurea pura proyectada en caliente",
      "technicalName": "Sistema técnico de poliurea pura proyectada en caliente",
      "description": "Impermeabilización de cubierta de hormigón mediante imprimación epoxi independiente y membrana de poliurea pura aromática proyectada en caliente.",
      "applications": "El sistema proof PUA BASIC es una opción ideal para la impermeabilización de cubiertas de gran tamaño que requieran de altas propiedades de resistencia química y mecánica, y que estén en búsqueda de durabilidad en el tiempo y no de un acabado estético.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de poliurea pura proyectada en caliente"
    },
    {
      "id": "idp-proof-pua-h-aluminium",
      "name": "IDP Impermeabilización de poliurea proyectada con acabado aluminio",
      "note": "Resumen 13/06/2025: primer 0,30–0,50 desarrollado 2×0,25, se elige 0,50. Membrana exacta 07/09/2026 actualiza dureza 90 A/40 D y todos los datos. Guía 12 p: variante primer 0,20+0,30, dilución opcional 10–15 % y árido 0,3–0,8 SIN cantidad: fuera de selección inicial seca del resumen, no sumar 1 kgdePARK. Detalles locales con áridos/reparadores/bandas/sellantes/activadores requieren referencias, dosis y diseño antes de ejecución, no incorporados por analogía. Aluminio es acabado, no obliga soporte aluminio. No alifático para estabilidad estética de ESTAvariante; no transferir a otras poliureas. COV A>40 g/L/>4 %, desgarro 69 N/m y 69 N/mm y referenciaEN1305-1 conservados. Identificadores de evaluación/DOP discrepantes entre ficha, catálogo, guía y documento de puentes 2,7 mm: no certificado automático de cubierta, garantía deaños, clase 3, ESD, potable o tráfico. Todos los datos y límites en 11 p, dos anexos completos.",
      "sheet": "IDP_Impermeabilizacion_de_poliurea_proyectada_con_acabado_aluminio.pdf",
      "systemUrl": "/products/idp-proof-pua-h-aluminium",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "poliurea-flexible-proyectada-caliente-aluminio",
          "phase": "Membrana flexible de acabado aluminio",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio",
          "commercialName": "IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio",
          "technicalName": "IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio",
          "sourceName": "IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_flexible_proyectada_en_caliente_con_acabado_aluminio.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/poliurea-flexible-proyectada-caliente-aluminio"
        }
      ],
      "commercialName": "IDP Poliurea proyectada estable a los rayos UV",
      "technicalName": "Sistema técnico de poliurea proyectada estable a los rayos uv",
      "description": "Impermeabilización de cubierta de hormigón seco con imprimación epoxi independiente y membrana flexible de poliurea proyectada en caliente de acabado aluminio metalizado, expuesta sin capa alifática. Aluminio identifica el color de la resina, no soporte obligatorio. Dos anexos técnicos completos.",
      "applications": "El sistema IDP Proof PUA H ALUMINIUM es una opción ideal para la impermeabilización de cubiertas con poco o ningún tránsito peatonal en todo tipo de edificios, proporcionando una mejora en el ahorro energético debido a la reflexión solar del sistema.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio"
    },
    {
      "id": "idp-proof-pua-h-basic",
      "name": "IDP Impermeabilización de poliurea híbrida proyectada para cubiertas",
      "note": "Prescripción 27/03/2025, primer 03/12/2025 y membrana híbrida 14/09/2026 contrastados. Primera imprimación opcional 10 %disolvente compatible del resumen no activada sin referencia/procedimiento. Membrana híbrida específica, no pura, H-Flex o poliurea lenta. Evaluación ETE11/0062 de 01/03/2024 del kit original, no certificado IDP automático: W2 estimada 10 años sin alifático, no garantía. W3 exige acabado pigmentado específico 0,25–0,35 que no está en receta inicial. ETE limita BROOF(t 2) a soporte incombustible, combustibles sin evaluar pese a afirmación más amplia de ficha general; no extender a cualquier cubierta. Reacción fuego E del kit, no Cfl-s 1/Bfl-s 1, clase de deslizamiento, agua potable o tráfico rodado. Datos de mezcla/envases y norma estática discrepantes expresos en anexos. La guía sobre metal no ferroso prescribe H-Flex y otro primer: excluida de esta receta de hormigón. Consultar 12 páginas y dos anexos íntegros.",
      "sheet": "IDP_Impermeabilizacion_de_poliurea_hibrida_proyectada_para_cubiertas.pdf",
      "systemUrl": "/products/idp-proof-pua-h-basic",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-membrana-de-poliurea-hibrida-proyectada-en-caliente-para-impermeabilizacion",
          "phase": "Membrana de poliurea híbrida caliente",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "commercialName": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "technicalName": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "sourceName": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_hibrida_proyectada_en_caliente_para_impermeabilizacion.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-membrana-de-poliurea-hibrida-proyectada-en-caliente-para-impermeabilizacion"
        }
      ],
      "commercialName": "IDP Poliurea proyectada en caliente con puenteo de fisuras",
      "technicalName": "Sistema técnico de poliurea proyectada en caliente con puenteo de fisuras",
      "description": "Impermeabilización de cubierta de hormigón seco con imprimación epoxi independiente y membrana de poliurea híbrida bicomponente proyectada en caliente, expuesta sin acabado alifático. Ficha completa con dos anexos íntegros y condiciones de evaluación diferenciadas.",
      "applications": "El sistema IDP proof PUA H BASIC es una opción ideal para la impermeabilización de cubiertas de gran tamaño que requieran de altas propiedades de resistencia mecánica, y que estén en búsqueda de durabilidad en el tiempo y no de un acabado estético.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización"
    },
    {
      "id": "idp-proof-pua-h-bridge",
      "name": "IDP Poliurea para impermeabilización de tableros de puente",
      "note": "Configuración de referencia sobre HORMIGÓN: imprimación 0,50 + cuarzo de base 0,70 + membrana ≥2,00 + puente SUPERIOR 0,50 + cuarzo superior 2,50 = 6,20 kg/m² iniciales; 651,00 kg para 100 m² + 5 %. Resinas 3,00 y áridos 3,20 kg/m². Cuarzo superior rango 2–3 kg/m², fuera del cual no sustituir por otro árido. Controlar espesor mínimo de conjunto ≥2,7 mm de la evaluación, sin convertir kg/m² a mm ni incluir el espesor vial. La membrana no recibe tráfico vehicular directo. Solapes: activador 0,10 kg/m² de su zona propia, fuera del cálculo general. Capa vial y solapes se miden aparte. Formatos de membrana a granel/según suministro: no se deduce un kit predosificado sumando bidones. La evaluación de origen se identifica con EOTA 21/0740; no es un certificado nuevo de IDP ni se extiende a metal o lastre.",
      "sheet": "IDP_Poliurea_para_impermeabilizacion_de_tableros_de_puente_b2668777-1cb1-4f0e-9e8c-1ad6936ef301.pdf",
      "systemUrl": "/products/idp-proof-pua-h-bridge",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,40–0,50 kg/m² TOTAL; cálculo 0,50",
          "coats": 1,
          "packages": [
            15
          ],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Anclaje sobre imprimación fresca",
          "productId": "arido-de-cuarzo-idp",
          "name": "Árido de cuarzo lavado y seco, 0,3–0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "Árido de cuarzo lavado y seco, 0,3–0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "consumption": 0.7,
          "officialConsumption": 0.7,
          "officialLabel": "0,70 kg/m²; cuarzo 0,3–0,8 mm",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Membrana proyectada",
          "productId": "membrana-poliurea-flexible-proyectada-caliente",
          "name": "Membrana de poliurea híbrida flexible proyectada en caliente",
          "commercialName": "IDP Poliurea Proyectada Flexible",
          "technicalName": "Membrana de poliurea híbrida flexible proyectada en caliente",
          "sourceName": "IDP Poliurea Proyectada Flexible",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "≥2,00 kg/m²; comprobar espesor real",
          "coats": 1,
          "packages": [
            "A granel"
          ],
          "sheet": "IDP_Poliurea_Proyectada_Flexible_9086bcae-54ff-41b9-8205-9fe5e0ca22a8.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-poliurea-flexible-proyectada-caliente"
        },
        {
          "phase": "Puente superior bajo capa vial",
          "productId": "imprimacion-flexible-para-sistemas-de-poliuretano",
          "name": "Imprimación flexible monocomponente de poliuretano al disolvente",
          "commercialName": "IDP Imprimación Flexible de Poliuretano",
          "technicalName": "Imprimación flexible monocomponente de poliuretano al disolvente",
          "sourceName": "IDP Imprimación Flexible de Poliuretano",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,50 kg/m²; una capa sobre membrana",
          "coats": 1,
          "packages": [
            20,
            4
          ],
          "sheet": "IDP_Imprimacion_Flexible_de_Poliuretano.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-flexible-para-sistemas-de-poliuretano"
        },
        {
          "phase": "Cuarzo del puente fresco",
          "productId": "arido-de-cuarzo-idp",
          "name": "Árido de cuarzo lavado y seco, 0,3–0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "Árido de cuarzo lavado y seco, 0,3–0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "consumption": 2.5,
          "officialConsumption": 2.5,
          "officialLabel": "2–3 kg/m² a saturación; cálculo 2,50",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        }
      ],
      "commercialName": "IDP Poliurea para impermeabilización de tableros de puente",
      "technicalName": "Sistema técnico de poliurea para impermeabilización de tableros de puente",
      "description": "Sistema de impermeabilización líquida de tableros de puente de aplicación en caliente a base de resinas de poliurea 100% solidos aromática sin disolventes con gran capacidad al puenteo de fisuras. ETE (evaluación técnica europea) para la impermeabilización de tableros de puente según EAD 030675- 00-0107 y ETAG 033 (certificado número 16/149).",
      "applications": "El sistema IDP Proof PUA H BRIDGE es una opción ideal para la impermeabilización de tableros de puente con soporte de hormigón y metálico.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliurea Proyectada Flexible | IDP Imprimación Flexible de Poliuretano | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Imprimación Activadora"
    },
    {
      "id": "idp-proof-pua-h-foam-aluminium",
      "name": "IDP Impermeabilización con espuma de poliuretano y poliurea aluminizada",
      "note": "La prescripción propia de 04/04/2025 enumera espuma 50 W y membrana aluminizada sobre hormigón. No equivale al poliuretano de inyección en frío. Sus opciones de espuma de 0,50 / 1 / 2 kg/m² son alternativas: a 50 kg/m³ equivalen teóricamente a 1 / 2 / 4 cm, frente al 1 / 2 / 3 cm impreso en el resumen. La selección inicial es 0,50 kg/m², con espesor y densidad reales comprobados. Las fuentes actuales de espuma, 02/06/2026, y membrana, 07/09/2026, se incluyen completas. La clase E de la espuma no certifica la cubierta; los identificadores de evaluación de la membrana son discrepantes y una DOP de puentes de 2,7 mm no acredita esta combinación. Conservación: espuma 10–25 °C y 6 meses; membrana 10–30 °C y 12 meses. Consultar HDS y etiquetas del suministro y aplicar control profesional de isocianatos, proyección, temperatura y presión.",
      "sheet": "IDP_Impermeabilizacion_con_espuma_de_poliuretano_y_poliurea_aluminizada.pdf",
      "systemUrl": "/products/idp-proof-pua-h-foam-aluminium",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-espuma-rigida-de-poliuretano-proyectado-con-expansion-por-agua",
          "phase": "Espuma rígida proyectada, expansión por agua",
          "consumption": 0.5,
          "coats": 1,
          "name": "IDP Espuma rígida de poliuretano proyectado con expansión por agua",
          "commercialName": "IDP Espuma rígida de poliuretano proyectado con expansión por agua",
          "technicalName": "IDP Espuma rígida de poliuretano proyectado con expansión por agua",
          "sourceName": "IDP Espuma rígida de poliuretano proyectado con expansión por agua",
          "officialConsumption": 0.5,
          "packages": [],
          "sheet": "IDP_Espuma_rigida_de_poliuretano_proyectado_con_expansion_por_agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-espuma-rigida-de-poliuretano-proyectado-con-expansion-por-agua"
        },
        {
          "productId": "poliurea-flexible-proyectada-caliente-aluminio",
          "phase": "Membrana de poliurea aluminizada",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio",
          "commercialName": "IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio",
          "technicalName": "IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio",
          "sourceName": "IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_flexible_proyectada_en_caliente_con_acabado_aluminio.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/poliurea-flexible-proyectada-caliente-aluminio"
        }
      ],
      "commercialName": "IDP Poliurea para encapsulado de amianto y aislamiento",
      "technicalName": "Sistema técnico de poliurea para encapsulado de amianto y aislamiento",
      "description": "Impermeabilización de cubierta sobre hormigón con espuma rígida de poliuretano proyectada, expandida por agua, y poliurea flexible caliente con acabado aluminio. Configuración inicial: espuma 0,50 y membrana 2,00 kg/m². Ficha completa con dos anexos técnicos.",
      "applications": "El sistema IDP Proof PUA H FOAM ALUMINIUM es una opción ideal para la impermeabilización y encapsulamiento de cubiertas de gran tamaño con soportes irregulares o de uralita. Con este sistema aseguramos la durabilidad en el tiempo de cubiertas poco transitadas.",
      "keywords": "IDP Espuma rígida de poliuretano proyectado con expansión por agua | IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio"
    },
    {
      "id": "idp-proof-pua-h-plus",
      "name": "IDP Impermeabilización de poliurea híbrida con sellado alifático",
      "note": "Selección lisa autorizada por pliego oficial 2.1.3 del mismo sistema;0,50 epoxiindependiente+2,00 híbridaestándar+0,50 alifáticoPIGMENTADO=3,00. Resumen 12/06/2025 tiene dos manos 0,25–0,35 y árido 0,3–0,8 entre ellasSINmasa; no se presenta el liso como resolución de esa rama. Pliego 0,30–0,50 sellado, selección 0,50 dos 0,25 compatiblecon ficha actual 0,40–0,60. No trasladar 1–2 kgdeguíaMETAL/H-Flex/PUALPrimeral hormigón. AlternativasSupreme/H-FlexNOsumadas ni equivalentes por nombre: SupremeHR<70 %,70/75/70,1:1,05 peso,650 %y 17 MPa, requiere acabadoELÁSTICOespecífico; H-Flex 70/70/65,1:1,08 peso,400 %y 15 MPa, reaplicación inmediata. Sus anexos íntegros y acabado elástico se incluyen sin activar cambios de receta. BlancoColodurSRI105/84,7 %/0,82 soloensayo blanco; Impertransblanco 103, no 105. No certificado global IDP, W3 garantizado, clase antideslizante, potable o tráfico intenso por analogía. Consultar 29 p/siete anexos.",
      "sheet": "IDP_Impermeabilizacion_de_poliurea_hibrida_con_sellado_alifatico.pdf",
      "systemUrl": "/products/idp-proof-pua-h-plus",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-membrana-de-poliurea-hibrida-proyectada-en-caliente-para-impermeabilizacion",
          "phase": "Membrana híbrida estándar caliente",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "commercialName": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "technicalName": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "sourceName": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_hibrida_proyectada_en_caliente_para_impermeabilizacion.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-membrana-de-poliurea-hibrida-proyectada-en-caliente-para-impermeabilizacion"
        },
        {
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "phase": "Sellado alifático pigmentado LISO",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Revestimiento alifático monocomponente para membranas",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        }
      ],
      "commercialName": "IDP Poliurea híbrida proyectada con sellado alifático",
      "technicalName": "Sistema técnico de poliurea híbrida proyectada con sellado alifático",
      "description": "Impermeabilización de cubierta de hormigón seco con epoxi independiente, poliurea HÍBRIDA estándar proyectada en caliente y sellado alifático monocomponente PIGMENTADO. Selección LISA del pliego propio:0,50+2,00+0,50=3,00 kg/m², sin árido inicial. Siete anexos íntegros y alternativas diferenciadas, sin equivalencias químicas o certificados globales por analogía.",
      "applications": "típicas: El sistema IDP Proof PUA H PLUS es una opción ideal para la impermeabilización de cubiertas industriales, aeropuertos, residencias privadas, gradas campos deportivos, terrazas y aceras con tránsito peatonal intenso.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización | IDP Revestimiento alifático monocomponente para membranas | IDP Membrana de poliurea híbrida proyectada de alta elongación | IDP Poliurea Proyectada Flexible | IDP Acabado elástico alifático monocomponente para membranas | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-proof-pua-h-plus-s",
      "name": "IDP Impermeabilización de poliurea híbrida de alta elongación con acabado elástico",
      "note": "Fuentes resumen 27/03/2025, guía 14 p, primer 03/12/2025, membrana 30/04/2026 y acabado 23/06/2025. Receta lisa de resumen selecciona primer 0,50 dos 0,25 sin diluir y sin árido; guía ofrece variante 0,20+0,30 con dilución opcional y árido de anclaje SIN DOSIS, no activado ni suplido por gramaje del acabado. Cuarzo de acabado exacto 0,3–0,8 a 1–2 kg/m² documentado, alternativa rugosa fuera de calculadora lisa. No otras granulometrías ni árido conductivo. Temperatura mínima común 15°C y HR<70 %, no límite 85 deotraspoliureas. Membrana híbrida 650 %/17 MPa/90 A40 D, acabadoelástico 380 %/11,7 MPa/85–90 A, no datos del protector rígido. SRI103 soloBLANCO, no 105, gris o ahorro garantizado. Referencias ETE22/0118 yDOP25-751 ETA16/0148/BROOFt 1 t 4 soloA1–A2 pendiente<20°no se fusionan con t 2 sobrecombustible. Sin certificado global IDP, W3 garantizada, claseantideslizante, potable o ESDautomáticos. Alternativas metal/acuosas y materiales de juntas requieren su procedimiento exacto, no activados por semejanza de nombre. Consultar 17 p/cuatroanexos.",
      "sheet": "IDP_Impermeabilizacion_de_poliurea_hibrida_de_alta_elongacion_con_acabado_elastico.pdf",
      "systemUrl": "/products/idp-proof-pua-h-plus-s",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-membrana-de-poliurea-hibrida-proyectada-de-alta-elongacion",
          "phase": "Membrana híbrida de alta elongación",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Membrana de poliurea híbrida proyectada de alta elongación",
          "commercialName": "IDP Membrana de poliurea híbrida proyectada de alta elongación",
          "technicalName": "IDP Membrana de poliurea híbrida proyectada de alta elongación",
          "sourceName": "IDP Membrana de poliurea híbrida proyectada de alta elongación",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_hibrida_proyectada_de_alta_elongacion.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-membrana-de-poliurea-hibrida-proyectada-de-alta-elongacion"
        },
        {
          "productId": "idp-acabado-elastico-alifatico-monocomponente-para-membranas",
          "phase": "Acabado alifático elástico pigmentado",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Acabado elástico alifático monocomponente para membranas",
          "commercialName": "IDP Acabado elástico alifático monocomponente para membranas",
          "technicalName": "IDP Acabado elástico alifático monocomponente para membranas",
          "sourceName": "IDP Acabado elástico alifático monocomponente para membranas",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Acabado_elastico_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-acabado-elastico-alifatico-monocomponente-para-membranas"
        }
      ],
      "commercialName": "IDP Poliurea proyectada de alta elongación",
      "technicalName": "Sistema técnico de poliurea proyectada de alta elongación",
      "description": "Impermeabilización de hormigón seco con epoxi independiente, poliurea híbrida de alta elongación proyectada en caliente y acabado alifático elástico pigmentado. Selección lisa gris; alternativa rugosa de cuarzo documentada por separado. Cuatro anexos técnicos completos.",
      "applications": "El sistema IDP Proof PUA H PLUS S es una opción ideal para la impermeabilización de estructuras con altos movimientos como cubiertas industriales, aeropuertos, residencias privadas, gradas de campos deportivos y terrazas con tránsito peatonal intenso.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de poliurea híbrida proyectada de alta elongación | IDP Acabado elástico alifático monocomponente para membranas | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-proof-pua-h-stadium",
      "name": "IDP Impermeabilización de poliurea híbrida proyectada para gradas",
      "note": "Se selecciona OPCIÓNCONÁRIDOdel pliego 2.2.2 del MISMO sistema:0,50 epoxiindependiente+2,00 HFlex+0,50 protectorPIGMENTADO+0,25 cuarzoNATURAL0,3–0,8=3,25. Guía 14 pofrece OTRArama 0,4–0,8 a 1,00 y resina adicional sin cantidad para clase 3: documentada pero NOequivalente ni resuelta por esta selección. No convertir 0,25 del pliego en 1,00 ni anunciar clase 3. La recepción exige fricción y proyecto; si no cumple, se prescribe otra configuración. Acabado 0,50 dos 0,25 acreditado porpliego/guía, compatible revisiónPIG0,40–0,60; no mantener ambigüedad 0,25–0,35 de resumen 04/04/2025. ReferenciaHFlexexacta 1:1,08 PESO/1:1 VOLUMEN70/70/65, NOHestándar/Supreme/pura. Primera protección≤1 hDESDEAPLICACIÓNdeHFlexy aptitudcomprobada; mismaF≤24 hDESDEAPLICACIÓN. Activadorlocal>24 hsegún guía, ventanaactual 1–2 h, NOprimergeneral. ETEactual 21/0740/ATG3247 puentesno certificado globaldegradas; guía 16/149 y«B Floor t 2»delpliegosonincidencias, no inventarBfl. SRI105 soloBLANCOdelprotector, no gris. Sin 100 %sólidosdelconjunto, potable, clase 3, garantíaW3 automáticaorodado.",
      "sheet": "IDP_Impermeabilizacion_de_poliurea_hibrida_proyectada_para_gradas.pdf",
      "systemUrl": "/products/idp-proof-pua-h-stadium",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "membrana-poliurea-flexible-proyectada-caliente",
          "phase": "Membrana HÍBRIDA FLEXIBLE caliente",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Poliurea Proyectada Flexible",
          "commercialName": "IDP Poliurea Proyectada Flexible",
          "technicalName": "IDP Poliurea Proyectada Flexible",
          "sourceName": "IDP Poliurea Proyectada Flexible",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Poliurea_Proyectada_Flexible_9086bcae-54ff-41b9-8205-9fe5e0ca22a8.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-poliurea-flexible-proyectada-caliente"
        },
        {
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "phase": "Protección alifática PIGMENTADA; cuarzo entre manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Revestimiento alifático monocomponente para membranas",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Cuarzo NATURAL en primera protección FRESCA; opción del pliego propio",
          "consumption": 0.25,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        }
      ],
      "commercialName": "IDP Poliurea proyectada para gradas de alto tránsito",
      "technicalName": "Sistema técnico de poliurea proyectada para gradas de alto tránsito",
      "description": "Impermeabilización de gradas de hormigón con imprimación epoxi independiente, poliurea HÍBRIDA FLEXIBLE de proyección en caliente y protector alifático PIGMENTADO. Selección con cuarzo NATURAL0,3–0,8 mm a 0,25 kg/m²del pliego propio 2.2.2; cinco anexos completos, incluido activador local de solapes no sumado al paño.",
      "applications": "Impermeabilización de gradas en estadios, campos deportivos, plazas de toros y otras superficies sometidas a elevado tráfico peatonal.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliurea Proyectada Flexible | IDP Revestimiento alifático monocomponente para membranas | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Imprimación Activadora"
    },
    {
      "id": "idp-proof-pua-impermax-strat",
      "name": "IDP Poliurea con aislamiento PIR",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-proof-pua-hyperseal-strat-es.pdf",
      "systemUrl": "/products/idp-proof-pua-impermax-strat",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Membrana",
          "productId": "membrana-poliurea-flexible-proyectada-caliente",
          "name": "Membrana de poliurea flexible proyectada en caliente",
          "sourceName": "IDP Polyurea H Supreme",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f03-043.pdf",
          "commercialName": "IDP Poliurea Proyectada Flexible",
          "technicalName": "Membrana de poliurea flexible proyectada en caliente",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-poliurea-flexible-proyectada-caliente"
        },
        {
          "phase": "Acabado",
          "productId": "acabado-de-poliuretano-alifatico-monocomponente-de-altas-prestaciones",
          "name": "Acabado de poliuretano alifático monocomponente de altas prestaciones",
          "sourceName": "IDP Pigmentado",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,25 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f05-074.pdf",
          "commercialName": "IDP Acabado Alifático de Poliuretano 1K",
          "technicalName": "Acabado de poliuretano alifático monocomponente de altas prestaciones",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/acabado-de-poliuretano-alifatico-monocomponente-de-altas-prestaciones"
        }
      ],
      "commercialName": "IDP Poliurea con aislamiento PIR",
      "technicalName": "Sistema técnico de poliurea con aislamiento pir",
      "description": "Sistema que combina la impermeabilización con el aislamiento térmico y acústico con paneles PIR. Acepta tránsito peatonal intermedio.",
      "applications": "Cubiertas de naves industriales, centros comerciales, estadios, plazas de toros y mercados.",
      "keywords": "IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    {
      "id": "idp-proof-pua-inverted",
      "name": "IDP Impermeabilización para cubiertas protegidas",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-proof-pua-inverted-es.pdf",
      "systemUrl": "/products/idp-proof-pua-inverted",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "name": "Imprimación epoxi para sistemas de impermeabilización",
          "sourceName": "Imprimación IDP H",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0.5 kg/m²",
          "coats": 2,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-009.pdf",
          "commercialName": "IDP Imprimación Epoxi para Impermeabilización",
          "technicalName": "Imprimación epoxi para sistemas de impermeabilización",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        }
      ],
      "commercialName": "IDP Impermeabilización para cubiertas protegidas",
      "technicalName": "Sistema técnico de impermeabilización para cubiertas protegidas",
      "description": "Sistema impermeabilizante de gran elasticidad a base de resinas de poliuretano monocomponente aromático en base disolvente con capacidad de puenteo de fisuras con acabado protegido.",
      "applications": "El sistema IDP Impermeabilización para cubiertas protegidas es una opción ideal para la impermeabilización de cubiertas protegidas, especialmente diseñadas para zonas sin trafico o limitadas al mantenimiento.",
      "keywords": "IDP Imprimación Epoxi para Impermeabilización | Imprimación epoxi para sistemas de impermeabilización"
    },
    {
      "id": "idp-proof-pua-m-basic",
      "name": "IDP Poliurea bicomponente al disolvente",
      "note": "Configuración manual horizontal: imprimación 0,50 kg/m² total en dos manos y membrana 2,00 kg/m² en una capa. Total resinas 2,50 kg/m², sin mermas ni diluyente. Soporte 15–40 °C; humedad <4 % y HR <85 %. Ver ficha completa.",
      "sheet": "ficha-sistema-idp-proof-pua-m-basic-es.pdf",
      "systemUrl": "/products/idp-proof-pua-m-basic",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,25 kg/m² por mano · 0,50 kg/m² total",
          "coats": 2,
          "packages": [
            15
          ],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100",
          "prescriptionNote": "Dos manos de 0,25 kg/m². No añadir una tercera fila de imprimación. La posible dilución de primera mano no es otra capa."
        },
        {
          "phase": "Membrana manual horizontal",
          "productId": "membrana-de-poliurea-autonivelante-de-aplicacion-en-frio-para-impermeabilizacion",
          "name": "Membrana de poliurea bicomponente de aplicación en frío para impermeabilización",
          "sourceName": "Poliurea bicomponente al disolvente",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2,00 kg/m² total · una capa horizontal",
          "coats": 1,
          "packages": [
            26.5
          ],
          "sheet": "ficha-tecnica-ft-idp-f03-041.pdf",
          "commercialName": "IDP Poliurea Cold",
          "technicalName": "Membrana de poliurea bicomponente de aplicación en frío para impermeabilización",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliurea-autonivelante-de-aplicacion-en-frio-para-impermeabilizacion",
          "prescriptionNote": "Aplicación manual horizontal. Airless es una modalidad distinta: mínimo tres capas de 0,5–0,7 kg/m² según ficha, sin sumar ambos métodos."
        }
      ],
      "commercialName": "IDP Poliurea bicomponente al disolvente",
      "technicalName": "Sistema técnico de poliurea bicomponente al disolvente",
      "description": "Sistema a base de resinas de poliurea aromática bicomponente en base disolvente.",
      "applications": "El sistema IDP Poliurea bicomponente al disolvente es una opción ideal para la impermeabilización de cubiertas sin tráfico peatonal.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliurea Cold | Membrana de poliurea bicomponente de aplicación en frío para impermeabilización"
    },
    {
      "id": "idp-proof-pua-m-plus",
      "name": "IDP Poliurea al disolvente con acabado alifático",
      "note": "Configuración horizontal inicial sobre soporte SECO: H F01-009 0,50 total en 2 × 0,25 + Cold F03-041 2,00 en UNA mano manual horizontal + F05-075 variante PIGMENTADA 0,50 total en 2 × 0,25 = 3,00 kg/m² de resinas. Para 100 m² + 5 %: 315,00 kg. No incorporar fibra general ni otra mano de Cold por defecto. Primera mano de acabado debe respetar la ventana propia de Cold, antes de 2 h una vez que permita continuar; si el ambiente/estado impide cumplirla, resolver preparación compatible antes de seguir. La epoxi 100 % sólidos 0,50 total es alternativa solo para soporte <4 %, sustituye a H, no se suma. Acabado monocomponente al disolvente F05-075, NO ECO 2K; el nombre comercial Transparente conserva una variante pigmentada existente IDP-CRYSTAL-25-PIG. No convertir kg/m² en mm ni atribuir SRI blanco a otro color. Se selecciona extremo superior documentado: imprimación 2 × 0,25 y acabado 2 × 0,25. No multiplicar el total 0,50 por el número de manos.",
      "sheet": "IDP_Poliurea_al_disolvente_con_acabado_alifatico_2de50c5a-7132-4e41-8f65-eec6d0ebaab0.pdf",
      "systemUrl": "/products/idp-proof-pua-m-plus",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación epoxi independiente",
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "phase": "Membrana Cold manual horizontal",
          "productId": "membrana-de-poliurea-autonivelante-de-aplicacion-en-frio-para-impermeabilizacion",
          "name": "IDP Poliurea en Frío",
          "commercialName": "IDP Poliurea en Frío",
          "technicalName": "IDP Poliurea en Frío",
          "sourceName": "IDP Poliurea en Frío",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2,00 kg/m² TOTAL; UNA mano manual horizontal",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Poliurea_Cold.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliurea-autonivelante-de-aplicacion-en-frio-para-impermeabilizacion"
        },
        {
          "phase": "Acabado alifático 1K PIGMENTADO F05-075",
          "productId": "resina-monocomponente-de-poliuretano-alifatico",
          "name": "IDP Impermeabilizante Transparente · variante pigmentada",
          "commercialName": "IDP Impermeabilizante Transparente",
          "technicalName": "IDP Impermeabilizante Transparente · alifático 1K pigmentado F05-075",
          "sourceName": "IDP Impermeabilizante Transparente",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Impermeabilizante_Transparente_bccc5ca7-e097-4def-bc16-4e5d18a3569c.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-monocomponente-de-poliuretano-alifatico"
        }
      ],
      "commercialName": "IDP Poliurea al disolvente con acabado alifático",
      "technicalName": "Sistema técnico de poliurea al disolvente con acabado alifático",
      "description": "Impermeabilización horizontal sobre soporte seco con imprimación H independiente, poliurea Cold manual y acabado alifático monocomponente F05-075 pigmentado.",
      "applications": "El sistema IDP Proof PUA M PLUS es una opción ideal para la impermeabilización de cubiertas con o sin tránsito peatonal.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Poliurea en Frío | IDP Impermeabilizante Transparente | IDP Imprimación Epoxi Universal"
    },
    {
      "id": "idp-proof-pua-m-supreme",
      "name": "IDP Poliurea manual 100 % sólidos con acabado alifático",
      "note": "Configuración mineral SECA: imprimación independiente 0,50 TOTAL (2 × 0,25), membrana manual F03-040 2,00 en UNA mano, acabado alifático exacto PIGMENTADO 0,50 TOTAL (2 × 0,25), cuarzo 0,3–0,8 mm 1,00 en primera mano fresca, selección del intervalo 1–2. Total 4,00 kg/m² (resinas 3,00 y cuarzo 1,00); para 100 m² + 5 %: 420,00 kg. Con cuarzo 2,00, total 5,00 y 525,00 kg: alternativa, no se suman. No poliaspártico, no sustitución por F05-075 por parecido, no kilos=milímetros, no clase 3 automática de otro grano ensayado. Referencia exacta del acabado documentada desde prescripción específica 03/04/2025 y ficha primaria 20/04/2026; las recomendaciones generales de membrana no convierten otros acabados en intercambiables.",
      "sheet": "IDP_Poliurea_manual_100_solidos_con_acabado_alifatico_27da24ed-083e-421d-a14a-78a131a34f04.pdf",
      "systemUrl": "/products/idp-proof-pua-m-supreme",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación epoxi independiente",
          "productId": "idp-epoxy-100",
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana manual en frío F03-040",
          "productId": "poliurea-bicomponente-frio-altas-prestaciones",
          "name": "IDP Poliurea en Frío de Altas Prestaciones",
          "commercialName": "IDP Poliurea en Frío de Altas Prestaciones",
          "technicalName": "IDP Poliurea en Frío de Altas Prestaciones",
          "sourceName": "IDP Poliurea en Frío de Altas Prestaciones",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2,00 kg/m² TOTAL; UNA mano horizontal",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Poliurea_en_Frio_de_Altas_Prestaciones_24565a22-a426-4fc3-b55d-7da414e2bd4d.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/poliurea-bicomponente-frio-altas-prestaciones"
        },
        {
          "phase": "Primera mano de acabado PIGMENTADO",
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "name": "IDP Revestimiento alifático monocomponente para membranas · PIGMENTADO",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas · PIGMENTADO",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,25 kg/m²; parte de total 0,50",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        },
        {
          "phase": "Árido en primera mano fresca",
          "productId": "arido-de-cuarzo-idp",
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "consumption": 1,
          "officialConsumption": 1,
          "officialLabel": "1,00 kg/m², selección del intervalo 1–2; retirar exceso tras curado",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Segunda mano de acabado PIGMENTADO",
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "name": "IDP Revestimiento alifático monocomponente para membranas · PIGMENTADO",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas · PIGMENTADO",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,25 kg/m²; acabado TOTAL 0,50",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        }
      ],
      "commercialName": "IDP Poliurea manual 100 % sólidos con acabado alifático",
      "technicalName": "Sistema técnico de poliurea manual 100 % sólidos con acabado alifático",
      "description": "Sistema basado en resinas de poliurea aromáticas de dos componentes y 100% de sólidos aplicadas a mano, con una capa de acabado de poliuretano alifático de un solo componente a base de disolventes..",
      "applications": "El sistema IDP Proof PUA M SUPREME es una opción ideal para la impermeabilización de cubiertas con tráfico peatonal intenso.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliurea en Frío de Altas Prestaciones | IDP Revestimiento alifático monocomponente para membranas | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-proof-pua-nmdc-geo-lake",
      "name": "IDP Membrana flotante para lagos y estanques",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-proof-pua-nmdc-geo-lake-es.pdf",
      "systemUrl": "/products/idp-proof-pua-nmdc-geo-lake",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Geotextil",
          "productId": "geotextil-de-polipropileno-para-membranas-de-poliurea-proyectada",
          "name": "Geotextil de polipropileno para membranas de poliurea proyectada",
          "sourceName": "Geomax Spray NMDC",
          "consumption": 0.2,
          "officialConsumption": 0.2,
          "officialLabel": "200g/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f03-035.pdf",
          "commercialName": "IDP Refuerzo Geotextil para Poliurea Proyectada",
          "technicalName": "Geotextil de polipropileno para membranas de poliurea proyectada",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/geotextil-de-polipropileno-para-membranas-de-poliurea-proyectada"
        },
        {
          "phase": "Membrana Proyectada",
          "productId": "membrana-poliurea-flexible-proyectada-caliente",
          "name": "Membrana de poliurea flexible proyectada en caliente",
          "sourceName": "Polyurea",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f03-043.pdf",
          "commercialName": "IDP Poliurea Proyectada Flexible",
          "technicalName": "Membrana de poliurea flexible proyectada en caliente",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-poliurea-flexible-proyectada-caliente"
        }
      ],
      "commercialName": "IDP Membrana flotante para lagos y estanques",
      "technicalName": "Sistema técnico de membrana flotante para lagos y estanques",
      "description": "Solución de impermeabilización flotante totalmente continua, fácil y rápida de instalar. Es una forma económica de conseguir una estanqueidad adecuada y evita la infiltración de agua a largo plazo.",
      "applications": "El sistema IDP PUA NMDC GEO LAKE es una opción ideal para impermeabilizar lagos, estanques, canales de agua, cubiertas con grandes irregularidades.",
      "keywords": "IDP Refuerzo Geotextil para Poliurea Proyectada | Geotextil de polipropileno para membranas de poliurea proyectada | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente"
    },
    {
      "id": "idp-proof-pua-plus",
      "name": "IDP Impermeabilización de poliurea pura proyectada con protección alifática",
      "note": "Fuentes resumen 27/03/2025, primer 03/12/2025, pura 07/09/2026 yprotector 20/04/2026. Elegidos primer 0,50 yacabado 0,50 como TOTALES de dosmanos 0,25, membrana 2,00; total 3,00. No acabado acuoso, transparenteF05-075 oformulaciónF05-074 poranalogía. Sistema completo contiene disolvente. Árido opcional de resumen sin dosis no activado; ensayo clase 3 del protector con grano 0,4–0,9 y 1 kg/m²no se traslada a 0,3–0,8 o selección lisa. SRI105, reflectancia 84,7 %yemisividad 0,82 soloBLANCOensayado, no gris o ahorro cuantificado. Pureza química y equipo 65/75/65 propios; unidad tracción 16,2 ausente/CBR4000 kNconservados, noinventados. DeclaracionesCE/ETA/BBAdeorigen requieren suministro/configuración, no garantía o certificadoglobal IDP. WRASazulcon ficha 13/09/2022 no acredita cubierta con protector al disolvente; sin uso potable. Consultar 18 pytresanexos.",
      "sheet": "IDP_Impermeabilizacion_de_poliurea_pura_proyectada_con_proteccion_alifatica.pdf",
      "systemUrl": "/products/idp-proof-pua-plus",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-membrana-de-poliurea-pura-proyectada-en-caliente",
          "phase": "Membrana de poliurea pura caliente",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Membrana de poliurea pura proyectada en caliente",
          "commercialName": "IDP Membrana de poliurea pura proyectada en caliente",
          "technicalName": "IDP Membrana de poliurea pura proyectada en caliente",
          "sourceName": "IDP Membrana de poliurea pura proyectada en caliente",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_pura_proyectada_en_caliente.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-membrana-de-poliurea-pura-proyectada-en-caliente"
        },
        {
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "phase": "Protección alifática monocomponente pigmentada",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Revestimiento alifático monocomponente para membranas",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        }
      ],
      "commercialName": "IDP Poliurea proyectada con acabado alifático",
      "technicalName": "Sistema técnico de poliurea proyectada con acabado alifático",
      "description": "Impermeabilización continua de hormigón seco con imprimación epoxi independiente, poliurea PURA de proyección caliente y protección alifática monocomponente PIGMENTADA al disolvente. Selección inicial lisa gris con tres anexos completos; no cubierta potable ni acabado antideslizante certificado por analogía.",
      "applications": "El sistema IDP Proof PUA PLUS es una opción ideal para la impermeabilización de cubiertas industriales, aeropuertos, residencias privadas, gradas, helipuertos, campos deportivos y terrazas con alto tránsito peatonal.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de poliurea pura proyectada en caliente | IDP Revestimiento alifático monocomponente para membranas"
    },
    {
      "id": "idp-proof-pua-protec-1",
      "name": "IDP Poliurea impermeabilizante bajo baldosas o grava",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-proof-pua-protec-1-es.pdf",
      "systemUrl": "/products/idp-proof-pua-protec-1",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 0.4,
          "officialConsumption": 0.4,
          "officialLabel": "0.3-0.5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana",
          "productId": "membrana-poliurea-flexible-proyectada-caliente",
          "name": "Membrana de poliurea flexible proyectada en caliente",
          "sourceName": "Impermax IDP Polyurea H FLEX / Polyurea IDP Pura",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f03-043.pdf",
          "commercialName": "IDP Poliurea Proyectada Flexible",
          "technicalName": "Membrana de poliurea flexible proyectada en caliente",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-poliurea-flexible-proyectada-caliente"
        },
        {
          "phase": "Capa De",
          "productId": "imprimacion-flexible-para-sistemas-de-poliuretano",
          "name": "Imprimación flexible para sistemas de poliuretano",
          "sourceName": "Imprimación IDP Imprimación Flexible de Poliuretano / Imprimación IDP Polyurea",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0.5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-013.pdf",
          "commercialName": "IDP Imprimación Flexible de Poliuretano",
          "technicalName": "Imprimación flexible para sistemas de poliuretano",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-flexible-para-sistemas-de-poliuretano"
        }
      ],
      "commercialName": "IDP Poliurea impermeabilizante bajo baldosas o grava",
      "technicalName": "Sistema técnico de poliurea impermeabilizante bajo baldosas o grava",
      "description": "Sistema a base de resinas de poliurea híbrida/ pura aromática bicomponente, sellado con baldosas, piedra o grava.",
      "applications": "El sistema IDP Poliurea impermeabilizante bajo baldosas o grava es una opción ideal para la impermeabilización no expuesta de balcones, terrazas, plazas, cubiertas con tráfico peatonal o tráfico vehicular ligero.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente | IDP Imprimación Flexible de Poliuretano | Imprimación flexible para sistemas de poliuretano"
    },
    {
      "id": "idp-proof-pua-protec-2",
      "name": "IDP Poliurea impermeabilizante protegida con mortero",
      "note": "Configuración híbrida H-Flex: imprimación 0,50 + membrana 2,00 + puente flexible SOBRE membrana 0,50 = 3,00 kg/m² de resinas; 315,00 kg para 100 m² + 5 %. DOS espolvoreos de cuarzo 0,3–0,8 mm: sobre segunda imprimación fresca y sobre puente fresco hasta saturación. La fuente no cuantifica ambas dotaciones: definir y medir aparte; no tomar cifras de otros sistemas. Mortero de proyecto fuera del cálculo, sin espesor o consumo inventado. Fuente nominal de impermeabilización 1,8 mm, sin conversión kg/m²=mm. Alternativa de puente F01-014 identificada y anexada, sin sumar ambos puentes. La alternativa de membrana pura requiere su propia referencia y documentación; no se equipara a híbrida ni FR, ni se incorpora a esta configuración calculada.",
      "sheet": "IDP_Poliurea_impermeabilizante_protegida_con_mortero_415db4f7-8fad-4062-9659-ae14c05ef586.pdf",
      "systemUrl": "/products/idp-proof-pua-protec-2",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; dos manos de 0,25",
          "coats": 2,
          "packages": [
            15
          ],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana híbrida proyectada",
          "productId": "membrana-poliurea-flexible-proyectada-caliente",
          "name": "Membrana de poliurea híbrida flexible proyectada en caliente",
          "commercialName": "IDP Poliurea Proyectada Flexible",
          "technicalName": "Membrana de poliurea híbrida flexible proyectada en caliente",
          "sourceName": "IDP Poliurea Proyectada Flexible",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2,00 kg/m²; controlar espesor real",
          "coats": 1,
          "packages": [
            "A granel"
          ],
          "sheet": "IDP_Poliurea_Proyectada_Flexible_9086bcae-54ff-41b9-8205-9fe5e0ca22a8.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-poliurea-flexible-proyectada-caliente"
        },
        {
          "phase": "Puente SUPERIOR bajo mortero",
          "productId": "imprimacion-flexible-para-sistemas-de-poliuretano",
          "name": "Imprimación flexible monocomponente de poliuretano al disolvente",
          "commercialName": "IDP Imprimación Flexible de Poliuretano",
          "technicalName": "Imprimación flexible monocomponente de poliuretano al disolvente",
          "sourceName": "IDP Imprimación Flexible de Poliuretano",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,50 kg/m² sobre membrana",
          "coats": 1,
          "packages": [
            20,
            4
          ],
          "sheet": "IDP_Imprimacion_Flexible_de_Poliuretano.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-flexible-para-sistemas-de-poliuretano"
        }
      ],
      "commercialName": "IDP Poliurea impermeabilizante protegida con mortero",
      "technicalName": "Sistema técnico de poliurea impermeabilizante protegida con mortero",
      "description": "Sistema a base de resinas de poliurea híbrida/ pura aromática bicomponente con un acabado de mortero.",
      "applications": "El sistema IDP Poliurea impermeabilizante protegida con mortero es una opción ideal para la impermeabilización no expuesta de contrapisos.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliurea Proyectada Flexible | IDP Imprimación Flexible de Poliuretano | IDP Imprimación para Poliurea | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-proof-pua-shield",
      "name": "IDP Poliurea pura para contención secundaria",
      "note": "Contención SECUNDARIA para vertidos ocasionales, con selección según sustancia, concentración, duración, temperatura y espesor. No resistencia química universal ni contención primaria automática. No sustituir por poliurea híbrida, pura menos dura o FR de pavimentos. No relación A:B de otra formulación. GC no autoriza charcos ni 98 % de agua en masa; Gel requiere seco y no acredita presión negativa. Reacción E, raíces, CE y coeficientes de gases son del alcance de material, no certificación de cubeto/edificio ni potabilidad. Aromática puede cambiar de color; su alta reticulación exige procedimiento exacto si se incorpora acabado. Verificar espesor mínimo2 mm separado del consumo. Consultar las16 páginas y cuatro anexos.",
      "sheet": "IDP_Poliurea_pura_para_contencion_secundaria.pdf",
      "systemUrl": "/products/idp-proof-pua-shield",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación horizontal seca",
          "consumption": 0.5,
          "coats": 1,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.5,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-membrana-de-poliurea-pura-para-contencion-quimica-y-barrera-de-gases",
          "phase": "Membrana pura de contención",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Membrana de poliurea pura para contención química y barrera de gases",
          "commercialName": "IDP Membrana de poliurea pura para contención química y barrera de gases",
          "technicalName": "IDP Membrana de poliurea pura para contención química y barrera de gases",
          "sourceName": "IDP Membrana de poliurea pura para contención química y barrera de gases",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_pura_para_contencion_quimica_y_barrera_de_gases.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-membrana-de-poliurea-pura-para-contencion-quimica-y-barrera-de-gases"
        }
      ],
      "commercialName": "IDP Poliurea proyectada para contención secundaria",
      "technicalName": "Sistema técnico de poliurea proyectada para contención secundaria",
      "description": "Contención secundaria sobre hormigón mediante imprimación epoxi independiente y poliurea pura de alta resistencia química proyectada en caliente. Cuatro fichas completas incluyen alternativas de imprimación, sin acumularlas.",
      "applications": "El sistema IDP Proof PUA SHIELD es una opción ideal para la impermeabilización y protección del hormigón en proyectos con fugas que contengan agresiones químicas.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de poliurea pura para contención química y barrera de gases | IDP Imprimación Epoxi para Hormigón Húmedo | IDP Imprimación Epoxi Universal Gel"
    },
    {
      "id": "idp-proof-pua-x5",
      "name": "IDP Poliurea expandible para impermeabilización de cubiertas",
      "note": "Cinco componentes incluyen alternativas: no cinco capas acumuladas. Soporte seco inicial sin epoxi general; no extender por analogía imprimación de otros sistemas. Acabado pigmentado0,50UNAaplicación; no imponer dos0,25 de otros sistemas. Variante alifática2,00 requiere reparto y procedimiento antes de activación, no calculadora inicial. Reflectancia blanca ySRI dependen del acabado: protector105 propio y membrana alternativa100, sin garantía>100 para todo color/sistema. No transferir CE/BROOF(t1), encapsulamiento, aislamiento ni prestaciones ensayadas a la obra completa sin alcance y comprobación. Consultar ficha21p/anexos y proyecto de detalles antes de ejecutar.",
      "sheet": "IDP_Poliurea_expandible_para_impermeabilizacion_de_cubiertas.pdf",
      "systemUrl": "/products/idp-proof-pua-x5",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "membrana-de-poliurea-expandible-proyectada-en-caliente-para-impermeabilizacion",
          "phase": "Base expandible TOTAL dos pasadas",
          "consumption": 1.25,
          "coats": 1,
          "name": "IDP Membrana de poliurea expandible proyectada en caliente para impermeabilización",
          "commercialName": "IDP Membrana de poliurea expandible proyectada en caliente para impermeabilización",
          "technicalName": "IDP Membrana de poliurea expandible proyectada en caliente para impermeabilización",
          "sourceName": "IDP Membrana de poliurea expandible proyectada en caliente para impermeabilización",
          "officialConsumption": 1.25,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_expandible_proyectada_en_caliente_para_impermeabilizacion.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliurea-expandible-proyectada-en-caliente-para-impermeabilizacion"
        },
        {
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "phase": "Protector pigmentado, una aplicación",
          "consumption": 0.5,
          "coats": 1,
          "name": "IDP Revestimiento alifático monocomponente para membranas",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "officialConsumption": 0.5,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        }
      ],
      "commercialName": "IDP Poliurea expansiva para rellenar irregularidades",
      "technicalName": "Sistema técnico de poliurea expansiva para rellenar irregularidades",
      "description": "Impermeabilización de cubiertas con base expandible proyectada caliente y protector alifático pigmentado. Selección seca directa; preparaciones húmedas y membrana alifática alternativa se documentan por separado.",
      "applications": "típicas: El sistema IDP Poliurea expansiva para rellenar irregularidades es una opción ideal para la impermeabilización y encapsulamiento de cubiertas no visitables o con poco tráfico peatonal que cuentan con un soporte irregular en el cual un tratamiento de soporte aumenta considerablemente los costos del proyecto.",
      "keywords": "IDP Membrana de poliurea expandible proyectada en caliente para impermeabilización | IDP Revestimiento alifático monocomponente para membranas | IDP Membrana impermeabilizante alifática monocomponente de poliuretano | IDP Imprimación Epoxi Base Agua | IDP Imprimación Epoxi para Hormigón Húmedo"
    },
    {
      "id": "idp-proof-pua-h-park",
      "name": "IDP Impermeabilización de poliurea híbrida para aparcamientos",
      "note": "Selección documental explícita del MISMO H PARK: pliego 2.2.1 prescribe primer H AL AGUA 0,40–0,50, protector PIGMENTADO 0,50 y cuarzo NATURAL 0,3–0,8 a 0,25; se selecciona primer 0,50 dos 0,25 y membrana H Flex 2,00 documentada en resumen 04/04/2025/guía. No atribuir al pliego una masa de membrana que omite. Otra ejecución de guía: primer UNIVERSAL 0,20+0,30, primera disolvente 10–15 %, anclaje sin masa, cuarzo 0,4–0,8 a 1,00 y más resina SIN cantidad para clase 3; no activada, ni mezclada con opción acuosa. Rampas/tres manos no cuantificadas fuera de selección horizontal. Fricción real debe cumplir proyecto: 0,25 no acredita clase 3 ni saturación de 1,00. No copiar árido de PU PARK/STADIUM, activador local/solape 15 cm o dosis de otro sistema. Mezclas de primers distintas; agua del acuoso y disolvente del universal no intercambiables. Primera F ≤1 h DESDE H Flex y apta; misma F ≤24 h DESDE aplicación. Juntas, reparaciones, bandas, masillas, adhesivos y perfiles son detalles definidos y medidos por proyecto antes de ejecución, no capas generales sin referencia. ETE 21/0740/ATG3247 de membrana no certificado global de aparcamiento; antigua 16/149 y «B Floor t 2» son incidencias, sin Bfl inventado. SRI105 solo BLANCO ensayado del protector, no gris. Sin 100 % sólidos/cero COV de conjunto, potable, raíces, radón o conductividad por analogía.",
      "sheet": "IDP_Impermeabilizacion_de_poliurea_hibrida_para_aparcamientos.pdf",
      "systemUrl": "/products/idp-proof-pua-h-park",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "phase": "Imprimación epoxi AL AGUA independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "productId": "membrana-poliurea-flexible-proyectada-caliente",
          "phase": "Membrana HÍBRIDA FLEXIBLE caliente",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Poliurea Proyectada Flexible",
          "commercialName": "IDP Poliurea Proyectada Flexible",
          "technicalName": "IDP Poliurea Proyectada Flexible",
          "sourceName": "IDP Poliurea Proyectada Flexible",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Poliurea_Proyectada_Flexible_9086bcae-54ff-41b9-8205-9fe5e0ca22a8.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-poliurea-flexible-proyectada-caliente"
        },
        {
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "phase": "Protección alifática PIGMENTADA; cuarzo entre manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Revestimiento alifático monocomponente para membranas",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Cuarzo NATURAL en primera protección FRESCA; opción del pliego propio",
          "consumption": 0.25,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        }
      ],
      "commercialName": "IDP Poliurea proyectada para tráfico rodado",
      "technicalName": "Sistema técnico de poliurea proyectada para tráfico rodado",
      "description": "Impermeabilización horizontal de aparcamientos con tráfico moderado de automóviles: imprimación epoxi AL AGUA independiente, poliurea HÍBRIDA FLEXIBLE proyectada en caliente y protector alifático PIGMENTADO con cuarzo NATURAL. Selección con árido del pliego propio 2.2.1; 22 páginas y cinco anexos íntegros.",
      "applications": "Aparcamientos residenciales y comerciales con tráfico moderado de vehículos.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Poliurea Proyectada Flexible | IDP Revestimiento alifático monocomponente para membranas | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Imprimación Epoxi Universal"
    },
    {
      "id": "idp-proof-pua-m-park",
      "name": "IDP Poliurea al disolvente para tráfico rodado",
      "note": "MEDICIÓN DE PROYECTO: imprimación 0,50 TOTAL (2 × 0,25), Cold 2,00 en UNA mano con fibra 150 g/m² medida en m² y solapes aparte, rodadura Manual2K 1,00 + su cuarzo 0,3–0,8 mm 1,00, acabado alifático exacto PIGMENTADO 0,50 TOTAL (2 × 0,25) con OTRO espolvoreo entre manos cuya dosis no declara la fuente. Base cuantificada 5,00 kg/m² (4,00 resinas + 1,00 cuarzo de rodadura), NO total del sistema: faltan árido final y medición de fibra. Completar la fila de árido final según textura de proyecto antes de obtener total o PDF de cálculo; no copiar 1,00 de rodadura ni una dosis de otro sistema. Fuente 13/05/2026. No kilos=milímetros ni clase antideslizante automática.",
      "sheet": "IDP_Poliurea_al_disolvente_para_trafico_rodado_e6ae6d55-0edd-4bed-ad2a-afb5d2823fbc.pdf",
      "systemUrl": "/products/idp-proof-pua-m-park",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación epoxi independiente",
          "productId": "idp-epoxy-100",
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana Cold reforzada con fibra 150 medida aparte",
          "productId": "membrana-de-poliurea-autonivelante-de-aplicacion-en-frio-para-impermeabilizacion",
          "name": "IDP Poliurea en Frío",
          "commercialName": "IDP Poliurea en Frío",
          "technicalName": "IDP Poliurea en Frío",
          "sourceName": "IDP Poliurea en Frío",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2,00 kg/m² TOTAL; UNA mano horizontal; fibra en m² y solapes aparte",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Poliurea_Cold.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliurea-autonivelante-de-aplicacion-en-frio-para-impermeabilizacion"
        },
        {
          "phase": "Rodadura Manual 2K",
          "productId": "membrana-liquida-de-poliuretano-biocomponente-de-aplicacion-manual",
          "name": "IDP Membrana de Poliuretano Manual 2K",
          "commercialName": "IDP Membrana de Poliuretano Manual 2K",
          "technicalName": "IDP Membrana de Poliuretano Manual 2K",
          "sourceName": "IDP Membrana de Poliuretano Manual 2K",
          "consumption": 1,
          "officialConsumption": 1,
          "officialLabel": "1,00 kg/m² de resina",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_Manual_2K_03edec94-c9a7-473d-b218-a058d38801e7.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-biocomponente-de-aplicacion-manual"
        },
        {
          "phase": "Espolvoreo de rodadura",
          "productId": "arido-de-cuarzo-idp",
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "consumption": 1,
          "officialConsumption": 1,
          "officialLabel": "1,00 kg/m²; independiente del espolvoreo final",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Primera mano de acabado PIGMENTADO",
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "name": "IDP Revestimiento alifático monocomponente para membranas · PIGMENTADO",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas · PIGMENTADO",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,25 kg/m²; parte de total 0,50",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        },
        {
          "phase": "COMPLETAR: espolvoreo propio entre manos del acabado",
          "productId": "arido-de-cuarzo-idp",
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "consumption": 0,
          "officialConsumption": 0,
          "officialLabel": "DOSIS NO DECLARADA EN FUENTE: definir según textura del proyecto; cero inicial indica pendiente, no consumo real",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Segunda mano de acabado PIGMENTADO",
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "name": "IDP Revestimiento alifático monocomponente para membranas · PIGMENTADO",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas · PIGMENTADO",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,25 kg/m²; acabado TOTAL 0,50",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        }
      ],
      "commercialName": "IDP Poliurea al disolvente para tráfico rodado",
      "technicalName": "Sistema técnico de poliurea al disolvente para tráfico rodado",
      "description": "Sistema a base de resinas de polyurea aromática bicomponente en base disolvente, con capa de rodadura base poliuretano bicomponente y sellado con una capa final de poliuretano alifático monocomponente en base disolvente.",
      "applications": "El sistema IDPProof PUA M PARK es una opción ideal para la impermeabilización de cubiertas parking con tráfico vehicular ligero.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliurea en Frío | IDP Malla de Fibra de Vidrio | IDP Membrana de Poliuretano Manual 2K | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Revestimiento alifático monocomponente para membranas"
    },
    {
      "id": "idp-proof-pua-park",
      "name": "IDP Poliurea pura proyectada para tráfico rodado",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-proof-pua-park-es.pdf",
      "systemUrl": "/products/idp-proof-pua-park",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 4,
          "officialConsumption": 4,
          "officialLabel": "0-8 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana Proyectada",
          "productId": "membrana-poliurea-flexible-proyectada-caliente",
          "name": "Membrana de poliurea flexible proyectada en caliente",
          "sourceName": "Polyurea",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f03-043.pdf",
          "commercialName": "IDP Poliurea Proyectada Flexible",
          "technicalName": "Membrana de poliurea flexible proyectada en caliente",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-poliurea-flexible-proyectada-caliente"
        },
        {
          "phase": "Acabado",
          "productId": "acabado-de-poliuretano-alifatico-monocomponente-de-altas-prestaciones",
          "name": "Acabado de poliuretano alifático monocomponente de altas prestaciones",
          "sourceName": "Colodur Pigmentado",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0.5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f05-074.pdf",
          "commercialName": "IDP Acabado Alifático de Poliuretano 1K",
          "technicalName": "Acabado de poliuretano alifático monocomponente de altas prestaciones",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/acabado-de-poliuretano-alifatico-monocomponente-de-altas-prestaciones"
        }
      ],
      "commercialName": "IDP Poliurea pura proyectada para tráfico rodado",
      "technicalName": "Sistema técnico de poliurea pura proyectada para tráfico rodado",
      "description": "Sistema bicomponente de aplicación en caliente fabricado con resinas de poliurea 100% puras a base de sólidos y sin disolventes, con gran capacidad de puenteo de grietas y sellado alifático que proporciona estabilidad de color a la membrana junto con una gran resistencia al desgaste.",
      "applications": "El sistema IDP Proof PUA PARK es una opción ideal para impermeabilizar cubiertas de aparcamientos residenciales y comerciales con tráfico vehicular ligero de automóviles.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    {
      "id": "idp-proof-pua-h-green-roof",
      "name": "IDP Poliurea proyectada para cubierta ajardinada",
      "note": "Drenaje y referencia de geotextil protector identificados y enlazados. La ficha integral de cubierta sigue pendiente de fijar la configuración de protección y filtración, versión y colocación de drenaje, encuentros y mediciones del proyecto. No es una configuración completa aprobada para ejecutar. Dos capas distintas de geotextil de protección, una bajo y otra sobre el drenaje, de 200–500 g/m² según la prescripción de origen. El gramaje no es cantidad de resina ni superficie útil instalada. Acreditar referencia y aptitud de protección/filtración, solapes y superficie neta antes de medir. No sustituir automáticamente por un refuerzo de 80 g/m². Lámina HDPE drenante y acumuladora de agua. Seleccionar versión perforada o no perforada, orientación, disposición, drenajes y superficie en m² conforme al proyecto; considerar recortes y solapes. La masa superficial de 1 kg/m² no equivale a un consumo universal de 1 kg/m² de cubierta ni define su área útil. Ficha completa disponible; no se atribuyen caudal de ensayo, solape o certificado antirraíces no aportados. El resultado de resinas es un subtotal, no una medición completa; no presupuestar la cubierta como 2,50 kg/m² totales.",
      "sheet": "ficha-sistema-idp-proof-pua-h-green-roof-es.pdf",
      "systemUrl": "/products/idp-proof-pua-h-green-roof",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "idp-epoxy-100",
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100",
          "officialLabel": "0.25 kg/m² por mano"
        },
        {
          "phase": "Membrana",
          "productId": "idp-membrana-de-poliurea-hibrida-proyectada-en-caliente-para-impermeabilizacion",
          "name": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "commercialName": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "technicalName": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "sourceName": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
          "consumption": 2,
          "officialConsumption": 2,
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_hibrida_proyectada_en_caliente_para_impermeabilizacion.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-membrana-de-poliurea-hibrida-proyectada-en-caliente-para-impermeabilizacion",
          "officialLabel": "2 kg/m² por mano"
        },
        {
          "phase": "Drenaje: medir superficie en m² según proyecto",
          "productId": "idp-lamina-drenante-y-acumuladora-de-agua-para-cubiertas-vegetales",
          "name": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "commercialName": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "technicalName": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "sourceName": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "consumption": 0,
          "officialConsumption": 0,
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Lamina_drenante_y_acumuladora_de_agua_para_cubiertas_vegetales.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-lamina-drenante-y-acumuladora-de-agua-para-cubiertas-vegetales",
          "officialLabel": "Medición pendiente en m²; cero no es ausencia de material"
        }
      ],
      "commercialName": "IDP Poliurea proyectada para cubierta ajardinada",
      "technicalName": "Sistema técnico de poliurea proyectada para cubierta ajardinada",
      "description": "Sistema sostenible basado en resinas de poliurea aplicadas en caliente. Aporta diseño a la cubierta, valor a la propiedad y mejor calidad del aire.",
      "applications": "El sistema IDP PUA H GREEN ROOF es una opción ideal para impermeabilizar cubiertas de hormigón en residencias privadas, edificios públicos y obras en general.",
      "keywords": "IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente | IDP Refuerzo Geotextil | Geotextil de refuerzo para sistemas de poliurea proyectada"
    },
    {
      "id": "idp-proof-pua-cool-roof",
      "name": "IDP Impermeabilización reflectante de poliurea proyectada para cubiertas",
      "note": "Fuentes resumen 28/05/2025, pura 07/09/2026, híbrida estándar 14/09/2026, altaelongación 30/04/2026, protector 20/04/2026 y primers documentados. Actualizado protector 0,25–0,35 a 0,50 TOTALpor rango vigente pigmentado 0,40–0,60. Total 3,00, no 100 %sólidos/libre de disolventes por protector. Seis anexos completos incluyenalternativas sin duplicar capas. Soporte común 15–30°C, humedad<4 %pese a 8 %deprimer; HR<85 %pura/estándar y<70 %altaelongación. SRI105/84,7 %/0,82 soloblanco específico, no 103 delacabadoelástico,99,55 deacuoso, otrosRALoahorro garantizado. Cada membrana conserva química, dosificación, equipo, curado y certificados propios; no W3/BROOF/raíces/certificado global IDPautomáticos. Protectorpigmentado 60 D/70 %/15 MPa, noincoloro. Sin árido o clase 3 automática; ensayo 0,4–0,9 mm 1 kg/m²no equivale a 0,3–0,8. No potable: WRAS2208579 azulA+B+C/ficha 13/09/2022 no acredita este kit blanco con protector al disolvente. Alternativas no conviertenmembranasen equivalentes comerciales ni alteranSKU/URL. La membrana de ALTA ELONGACIÓN NO está activada como sustitución con el protector rígido blanco de esta receta: requiere acabado alifático ELÁSTICO específico, dosis e interfaz propias y verificación solar de esa variante. El blanco elástico documentado tiene SRI103, no 105. Su anexo se conserva como comparación técnica, sin habilitar su ejecución con este protector.",
      "sheet": "IDP_Impermeabilizacion_reflectante_de_poliurea_proyectada_para_cubiertas_74dafb8c-9ce7-4eaa-b182-3a5071e175a2.pdf",
      "systemUrl": "/products/idp-proof-pua-cool-roof",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "phase": "Imprimación epoxi acuosa independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "productId": "idp-membrana-de-poliurea-pura-proyectada-en-caliente",
          "phase": "Membrana de poliurea pura caliente",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Membrana de poliurea pura proyectada en caliente",
          "commercialName": "IDP Membrana de poliurea pura proyectada en caliente",
          "technicalName": "IDP Membrana de poliurea pura proyectada en caliente",
          "sourceName": "IDP Membrana de poliurea pura proyectada en caliente",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_pura_proyectada_en_caliente.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-membrana-de-poliurea-pura-proyectada-en-caliente"
        },
        {
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "phase": "Protección alifática monocomponente blanca",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Revestimiento alifático monocomponente para membranas",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        }
      ],
      "commercialName": "IDP Cubierta reflectante de poliurea con acabado blanco",
      "technicalName": "Sistema técnico de cubierta reflectante de poliurea con acabado blanco",
      "description": "Impermeabilización reflectante de cubierta con imprimación epoxi acuosa independiente, poliurea PURA caliente y protector alifático monocomponente PIGMENTADO BLANCO específico. Seis anexos completos: primer universal e híbrida estándar como alternativas; alta elongación solo comparación, NO activada con este protector rígido, requiere acabado ELÁSTICO específico y variante propia sin heredar SRI105.",
      "applications": "El sistema IDP Proof PUA COOL ROOF es una opción ideal para la impermeabilización de cubiertas.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Membrana de poliurea pura proyectada en caliente | IDP Revestimiento alifático monocomponente para membranas | IDP Imprimación Epoxi Universal | IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización | IDP Membrana de poliurea híbrida proyectada de alta elongación"
    },
    {
      "id": "idp-proof-pua-water-tank",
      "name": "IDP Poliurea proyectada para depósitos de agua potable",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-proof-pua-water-tank-es.pdf",
      "systemUrl": "/products/idp-proof-pua-water-tank",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100 (Soporte seco)",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0.5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Imprimación",
          "productId": "imprimacion-epoxi-bicomponente-para-hormigon-humedo",
          "name": "Imprimación epoxi bicomponente para hormigón húmedo",
          "sourceName": "Primer IDP GC (Soporte Húmedo)",
          "consumption": 0.55,
          "officialConsumption": 0.55,
          "officialLabel": "0.5-0.6 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-008.pdf",
          "commercialName": "IDP Imprimación Epoxi para Hormigón Húmedo",
          "technicalName": "Imprimación epoxi bicomponente para hormigón húmedo",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-bicomponente-para-hormigon-humedo"
        },
        {
          "phase": "Membrana Proyectada",
          "productId": "membrana-poliurea-flexible-proyectada-caliente",
          "name": "Membrana de poliurea flexible proyectada en caliente",
          "sourceName": "Polyurea IDP",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f03-043.pdf",
          "commercialName": "IDP Poliurea Proyectada Flexible",
          "technicalName": "Membrana de poliurea flexible proyectada en caliente",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-poliurea-flexible-proyectada-caliente"
        }
      ],
      "commercialName": "IDP Poliurea proyectada para depósitos de agua potable",
      "technicalName": "Sistema técnico de poliurea proyectada para depósitos de agua potable",
      "description": "Sistema de impermeabilización en caliente de tanques de agua potable aplicado en forma líquida. El sistema puede ser utilizado en tanques nuevos y en tanques en rehabilitación con pérdidas de agua debido a fisuras en el hormigón. epoxídico de 3 componentes con cemento osmótico para sustratos con humedad ocluida.",
      "applications": "El sistema IDP PUA WATER TANK es una opción ideal para impermeabilización de tanques cerrados y abiertos conteniendo agua contra incendios, agua clorada, aguas residuales entre otras.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Imprimación Epoxi para Hormigón Húmedo | Imprimación epoxi bicomponente para hormigón húmedo | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente"
    },
    {
      "id": "idp-proof-pua-pool",
      "name": "IDP Poliurea pura proyectada para piscinas",
      "note": "Selección inicial horizontal expuesta sobre hormigón seco; vertical reparte 0,50 kg/m² en dos manos. Los siete componentes incluyen alternativas, no siete capas superpuestas. GC no habilita 98 % de agua en masa ni anula el límite de humedad de la membrana. Gel requiere seco y no acredita presión negativa. Las variantes húmeda y frente a presión negativa necesitan configuración propia antes de obra. Bajo cerámica se sustituye el acabado expuesto por puente y árido. Los certificados del material no certifican la piscina entera ni aptitud potable del acabado. No aplicar cloro sólido directamente al fondo. Respetar control químico, mantenimiento y curados; consultar ficha completa de 25 páginas y anexos.",
      "sheet": "IDP_Poliurea_pura_proyectada_para_piscinas.pdf",
      "systemUrl": "/products/idp-proof-pua-pool",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación horizontal seca",
          "consumption": 0.5,
          "coats": 1,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.5,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-membrana-de-poliurea-pura-proyectada-en-caliente",
          "phase": "Membrana pura proyectada",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Membrana de poliurea pura proyectada en caliente",
          "commercialName": "IDP Membrana de poliurea pura proyectada en caliente",
          "technicalName": "IDP Membrana de poliurea pura proyectada en caliente",
          "sourceName": "IDP Membrana de poliurea pura proyectada en caliente",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_pura_proyectada_en_caliente.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-membrana-de-poliurea-pura-proyectada-en-caliente"
        },
        {
          "productId": "acabado-de-poliuretano-alifatico-bicomponente-para-piscinas",
          "phase": "Acabado expuesto para piscinas",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Acabado Alifático para Piscinas",
          "commercialName": "IDP Acabado Alifático para Piscinas",
          "technicalName": "IDP Acabado Alifático para Piscinas",
          "sourceName": "IDP Acabado Alifático para Piscinas",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Acabado_Alifatico_para_Piscinas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/acabado-de-poliuretano-alifatico-bicomponente-para-piscinas"
        }
      ],
      "commercialName": "IDP Poliurea proyectada para piscinas",
      "technicalName": "Sistema técnico de poliurea proyectada para piscinas",
      "description": "Impermeabilización de piscinas de hormigón con poliurea pura proyectada en caliente y acabado alifático bicomponente expuesto; alternativa bajo gresite con puente flexible y cuarzo, sin sumar las dos terminaciones.",
      "applications": "El sistema IDP PUA POOL es una opción ideal para la impermeabilización de piscinas deportivas, públicas y privadas, ya que su resistencia química permite el contacto con agua clorada y salada.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de poliurea pura proyectada en caliente | IDP Acabado Alifático para Piscinas | IDP Imprimación Epoxi para Hormigón Húmedo | IDP Imprimación Epoxi Universal Gel | IDP Imprimación Flexible de Poliuretano | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-proof-pua-radon-gas-shield",
      "name": "IDP Barrera de poliurea pura frente al gas radón",
      "note": "Tres componentes incluyen el soporte alternativo flotante, no tres capas acumuladas. No sustituir por fibra de vidrio150 ni geotextil genérico. El resumen imprime<1,5N/mm²: esta revisión IDP adopta explícitamente un control conservador>1,5, contrastado con la prescripción30/01/2026 del mismo par de materiales. No se afirma corrección del emisor ni resultado ensayado de obra: comprobar antes de aplicar. DB HS6 oficial consultado01/11/2026: separar ensayo de material de espesor, continuidad y eficacia de todo el edificio; no certificado IDP automático ni concentración interior garantizada. Sin potabilidad, claseBfl-s1 o acabado alifático genérico transferidos. Consultar ficha completa de14páginas y anexos.",
      "sheet": "IDP_Barrera_de_poliurea_pura_frente_al_gas_radon.pdf",
      "systemUrl": "/products/idp-proof-pua-radon-gas-shield",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación horizontal seca",
          "consumption": 0.5,
          "coats": 1,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.5,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-membrana-de-poliurea-pura-para-contencion-quimica-y-barrera-de-gases",
          "phase": "Barrera pura proyectada",
          "consumption": 2.5,
          "coats": 1,
          "name": "IDP Membrana de poliurea pura para contención química y barrera de gases",
          "commercialName": "IDP Membrana de poliurea pura para contención química y barrera de gases",
          "technicalName": "IDP Membrana de poliurea pura para contención química y barrera de gases",
          "sourceName": "IDP Membrana de poliurea pura para contención química y barrera de gases",
          "officialConsumption": 2.5,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliurea_pura_para_contencion_quimica_y_barrera_de_gases.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-membrana-de-poliurea-pura-para-contencion-quimica-y-barrera-de-gases"
        }
      ],
      "commercialName": "IDP Barrera líquida de poliurea contra radón",
      "technicalName": "Sistema técnico de barrera líquida de poliurea contra radón",
      "description": "Barrera continua de poliurea pura proyectada frente a gases del terreno. Configuración inicial adherida sobre hormigón seco; alternativa flotante sobre tejido especial de polipropileno, sin sumar ambas secuencias.",
      "applications": "El sistema IDP PROOF PUA RADON GAS SHIELD es una opción ideal para lograr una barrera capaz de contener la entrada del radón cumpliendo con la normativa del CTE DB-HS-6. Punto 3.1 - Características de barreras.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de poliurea pura para contención química y barrera de gases | IDP Refuerzo Geotextil para Poliurea Proyectada"
    },
    {
      "id": "idp-proof-pu-basic",
      "name": "IDP Impermeabilización elástica monocomponente con puenteo de fisuras",
      "note": "Configuración inicial: imprimación 0,50 kg/m² total (2 × 0,25) y membrana 2,00 kg/m² total (2 × 1,00); total 2,50 kg/m². Para 100 m² y 5 % de merma: 262,50 kg. No duplicar consumos por mano. Espesor aproximado declarado 1,6 mm, sin conversión genérica de kg/m² a mm. Imagen: variante protegida; geotextil ≥200 g/m² y losa, mortero u hormigón son materiales de proyecto y se miden aparte. Variante cerámica: puente adicional de la misma membrana 0,20 kg/m², cuarzo 0,3–0,8 mm hasta saturación con dotación por definir y adhesivo/baldosa de proyecto; no sumar todas las terminaciones. La configuración expuesta solo admite mantenimiento. No se atribuyen automáticamente ETE, BBA o BROOF al conjunto.",
      "sheet": "IDP_Impermeabilizacion_elastica_monocomponente_con_puenteo_de_fisuras_1709eefc-0a73-44a3-9b94-6401c91eb509.pdf",
      "systemUrl": "/products/idp-proof-pu-basic",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "name": "Imprimación epoxi bicomponente en base agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "Imprimación epoxi bicomponente en base agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; dos manos de 0,25",
          "coats": 2,
          "packages": [
            18,
            5
          ],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "phase": "Membrana impermeabilizante",
          "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
          "name": "Membrana de poliuretano aromático monocomponente al disolvente",
          "commercialName": "IDP Membrana de Poliuretano 1K",
          "technicalName": "Membrana de poliuretano aromático monocomponente al disolvente",
          "sourceName": "IDP Membrana de Poliuretano 1K",
          "consumption": 1,
          "officialConsumption": 1,
          "officialLabel": "2,00 kg/m² TOTAL; dos manos de 1,00",
          "coats": 2,
          "packages": [
            25,
            6
          ],
          "sheet": "IDP_Membrana_de_Poliuretano_1K_1265e98a-8534-4093-a852-f38e18916844.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion"
        }
      ],
      "commercialName": "IDP Impermeabilización elástica monocomponente con puenteo de fisuras",
      "technicalName": "Sistema técnico de impermeabilización elástica monocomponente con puenteo de fisuras",
      "description": "Sistema impermeabilizante de gran elasticidad a base de resinas de poliuretano monocomponente aromático en base disolvente con capacidad de puenteo de fisuras.",
      "applications": "El sistema IDP Proof Basic es una opción ideal para la impermeabilización de cubiertas protegidas o expuestas con transito único de mantenimiento.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Membrana de Poliuretano 1K | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-proof-pu-impermax-strat",
      "name": "IDP Impermeabilización de poliuretano con aislamiento PIR",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-proof-pu-hyperseal-strat-es.pdf",
      "systemUrl": "/products/idp-proof-pu-impermax-strat",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Capa",
          "productId": "adhesivo-de-poliuretano-bicomponente-para-paneles-y-laminas-tecnicas",
          "name": "Adhesivo de poliuretano bicomponente para paneles y láminas técnicas",
          "sourceName": "Fijado con Adhesivo PU 2K",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f07-081.pdf",
          "commercialName": "IDP Adhesivo de Poliuretano 2K",
          "technicalName": "Adhesivo de poliuretano bicomponente para paneles y láminas técnicas",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/adhesivo-de-poliuretano-bicomponente-para-paneles-y-laminas-tecnicas"
        },
        {
          "phase": "Acabado",
          "productId": "acabado-de-poliuretano-alifatico-monocomponente-de-altas-prestaciones",
          "name": "Acabado de poliuretano alifático monocomponente de altas prestaciones",
          "sourceName": "Colodur Pigmentado",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f05-074.pdf",
          "commercialName": "IDP Acabado Alifático de Poliuretano 1K",
          "technicalName": "Acabado de poliuretano alifático monocomponente de altas prestaciones",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/acabado-de-poliuretano-alifatico-monocomponente-de-altas-prestaciones"
        }
      ],
      "commercialName": "IDP Impermeabilización de poliuretano con aislamiento PIR",
      "technicalName": "Sistema técnico de impermeabilización de poliuretano con aislamiento pir",
      "description": "Sistema que combina la impermeabilización con el aislamiento térmico y acústico con paneles PIR. Acepta tránsito peatonal intermedio.",
      "applications": "Cubiertas de naves industriales, centros comerciales, estadios, plazas de toros y mercados.",
      "keywords": "IDP Adhesivo de Poliuretano 2K | Adhesivo de poliuretano bicomponente para paneles y láminas técnicas | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    {
      "id": "idp-proof-pu-inverted",
      "name": "IDP Impermeabilización elástica con acabado protegido",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-proof-pu-inverted-es.pdf",
      "systemUrl": "/products/idp-proof-pu-inverted",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "name": "Imprimación epoxi para sistemas de impermeabilización",
          "sourceName": "Imprimación IDP",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-009.pdf",
          "commercialName": "IDP Imprimación Epoxi para Impermeabilización",
          "technicalName": "Imprimación epoxi para sistemas de impermeabilización",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "phase": "Imprimación",
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "name": "Imprimación epoxi para sistemas de impermeabilización",
          "sourceName": "Imprimación IDP",
          "consumption": 0.4,
          "officialConsumption": 0.4,
          "officialLabel": "0,3-0,5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-009.pdf",
          "commercialName": "IDP Imprimación Epoxi para Impermeabilización",
          "technicalName": "Imprimación epoxi para sistemas de impermeabilización",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "phase": "Membrana",
          "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
          "name": "Membrana líquida de poliuretano monocomponente para impermeabilización",
          "sourceName": "IDP Impermax / ST / QC",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f03-056.pdf",
          "commercialName": "IDP Membrana de Poliuretano 1K",
          "technicalName": "Membrana líquida de poliuretano monocomponente para impermeabilización",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion"
        }
      ],
      "commercialName": "IDP Impermeabilización elástica con acabado protegido",
      "technicalName": "Sistema técnico de impermeabilización elástica con acabado protegido",
      "description": "Sistema impermeabilizante de alta elasticidad a base de resinas de poliuretano aromático monocomponente en base disolvente con capacidad de puenteo de fisuras y acabado protegido.",
      "applications": "El sistema IDP Impermeabilización elástica con acabado protegido es una opción ideal para la impermeabilización de cubiertas protegidas, especialmente diseñado para zonas sin tránsito o con mantenimiento limitado.",
      "keywords": "IDP Imprimación Epoxi para Impermeabilización | Imprimación epoxi para sistemas de impermeabilización | IDP Membrana de Poliuretano 1K | Membrana líquida de poliuretano monocomponente para impermeabilización"
    },
    {
      "id": "idp-proof-pu-plus",
      "name": "IDP Impermeabilización de poliuretano con acabado alifático",
      "note": "Configuración horizontal inicial sobre soporte SECO: H F01-009 0,50 total en 2 × 0,25 + PU1K 2,00 total en 2 × 1,00 con fibra 150 en primera mano fresca + F05-075 variante PIGMENTADA 0,50 total en 2 × 0,25 = 3,00 kg/m² de resinas. Para 100 m² + 5 %: 315,00 kg. Fibra medida aparte en m² más solapes y recortes; no es kg de resina. ST/QC son alternativas documentadas, no capas adicionales. La epoxi 100 % sólidos 0,50 total es alternativa solo para soporte <4 %, sustituye a H, no se suma. Acabado monocomponente al disolvente F05-075, NO ECO 2K; el nombre comercial Transparente conserva una variante pigmentada existente IDP-CRYSTAL-25-PIG. No convertir kg/m² en mm ni atribuir SRI blanco a otro color. La cifra 0,25–0,30 del sistema es ambigua por mano/total; se selecciona 0,25 por mano en dos manos conforme a la ficha completa del acabado, total 0,50.",
      "sheet": "IDP_Impermeabilizacion_de_poliuretano_con_acabado_alifatico_32333cc0-6445-4035-bce1-d839171872df.pdf",
      "systemUrl": "/products/idp-proof-pu-plus",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación epoxi independiente",
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "phase": "Membrana PU1K reforzada",
          "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
          "name": "IDP Membrana de Poliuretano 1K",
          "commercialName": "IDP Membrana de Poliuretano 1K",
          "technicalName": "IDP Membrana de Poliuretano 1K",
          "sourceName": "IDP Membrana de Poliuretano 1K",
          "consumption": 1,
          "officialConsumption": 1,
          "officialLabel": "2,00 kg/m² TOTAL; 2 × 1,00, fibra 150 en primera fresca medida aparte",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_1K_1265e98a-8534-4093-a852-f38e18916844.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion"
        },
        {
          "phase": "Acabado alifático 1K PIGMENTADO F05-075",
          "productId": "resina-monocomponente-de-poliuretano-alifatico",
          "name": "IDP Impermeabilizante Transparente · variante pigmentada",
          "commercialName": "IDP Impermeabilizante Transparente",
          "technicalName": "IDP Impermeabilizante Transparente · alifático 1K pigmentado F05-075",
          "sourceName": "IDP Impermeabilizante Transparente",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Impermeabilizante_Transparente_bccc5ca7-e097-4def-bc16-4e5d18a3569c.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-monocomponente-de-poliuretano-alifatico"
        }
      ],
      "commercialName": "IDP Impermeabilización de poliuretano con acabado alifático",
      "technicalName": "Sistema técnico de impermeabilización de poliuretano con acabado alifático",
      "description": "Impermeabilización horizontal sobre soporte seco con imprimación H independiente, PU1K reforzada y acabado alifático monocomponente F05-075 pigmentado.",
      "applications": "El sistema Proof PU PLUS es una opción ideal para la impermeabilización de cubiertas con tráfico peatonal.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Membrana de Poliuretano 1K | IDP Impermeabilizante Transparente | IDP Malla de Fibra de Vidrio | IDP Imprimación Epoxi Universal | IDP Membrana de Poliuretano 1K ST | IDP Membrana de Poliuretano de Secado Rápido"
    },
    {
      "id": "idp-proof-pu-protec-1",
      "name": "IDP Impermeabilización bajo baldosas o grava",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-proof-pu-protec-1-es.pdf",
      "systemUrl": "/products/idp-proof-pu-protec-1",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 0.4,
          "officialConsumption": 0.4,
          "officialLabel": "0.3-0.5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana",
          "productId": "",
          "name": "Impermax / Impermax Cold PUA",
          "sourceName": "Impermax / Impermax Cold PUA",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "",
          "commercialName": "",
          "technicalName": "",
          "documentStatus": "alternativas_documentadas",
          "productUrl": "",
          "selectionRequired": true,
          "productOptions": [
            {
              "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
              "commercialName": "IDP Membrana de Poliuretano 1K",
              "technicalName": "Membrana líquida de poliuretano monocomponente para impermeabilización",
              "technicalSheet": "ficha-tecnica-ft-idp-f03-056.pdf",
              "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion",
              "documentStatus": "validada",
              "configurationCondition": "Membrana de poliuretano 1K"
            },
            {
              "productId": "poliurea-bicomponente-frio-altas-prestaciones",
              "commercialName": "IDP Poliurea en Frío de Altas Prestaciones",
              "technicalName": "Membrana de poliurea bicomponente de aplicación en frío de altas prestaciones",
              "technicalSheet": "ficha-tecnica-ft-idp-f03-040.pdf",
              "productUrl": "https://idpproductos.com/products/poliurea-bicomponente-frio-altas-prestaciones",
              "documentStatus": "validada",
              "configurationCondition": "Membrana de poliurea de aplicación en frío"
            }
          ],
          "prescriptionNote": "Elegir una sola membrana en función del soporte y las condiciones de obra."
        },
        {
          "phase": "Capa de adherencia",
          "productId": "",
          "name": "M. Principal / Imprimación TP Flex / Imprimación Polyurea",
          "sourceName": "M. Principal / Imprimación TP Flex / Imprimación Polyurea",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0.5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "",
          "commercialName": "",
          "technicalName": "",
          "documentStatus": "alternativas_documentadas",
          "productUrl": "",
          "selectionRequired": true,
          "productOptions": [
            {
              "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
              "commercialName": "IDP Membrana de Poliuretano 1K",
              "technicalName": "Membrana líquida de poliuretano monocomponente para impermeabilización",
              "technicalSheet": "ficha-tecnica-ft-idp-f03-056.pdf",
              "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion",
              "documentStatus": "validada",
              "configurationCondition": "Capa fina del mismo producto cuando se emplea la membrana de poliuretano"
            },
            {
              "productId": "imprimacion-flexible-para-sistemas-de-poliuretano",
              "commercialName": "IDP Imprimación Flexible de Poliuretano",
              "technicalName": "Imprimación flexible para sistemas de poliuretano",
              "technicalSheet": "ficha-tecnica-ft-idp-f01-013.pdf",
              "productUrl": "https://idpproductos.com/products/imprimacion-flexible-para-sistemas-de-poliuretano",
              "documentStatus": "validada",
              "configurationCondition": "Puente flexible compatible"
            },
            {
              "productId": "imprimacion-para-sistemas-de-poliurea",
              "commercialName": "IDP Imprimación para Poliurea",
              "technicalName": "Imprimación para sistemas de poliurea",
              "technicalSheet": "ficha-tecnica-ft-idp-f01-014.pdf",
              "productUrl": "https://idpproductos.com/products/imprimacion-para-sistemas-de-poliurea",
              "documentStatus": "validada",
              "configurationCondition": "Puente compatible cuando se emplea poliurea"
            }
          ],
          "prescriptionNote": "Aplicar únicamente la alternativa compatible con la membrana principal y espolvorear árido de cuarzo en fresco."
        }
      ],
      "commercialName": "IDP Impermeabilización bajo baldosas o grava",
      "technicalName": "Sistema técnico de impermeabilización bajo baldosas o grava",
      "description": "Sistema a base de resinas de poliuretano aromático monocomponente en base disolvente, sellado con baldosas o grava.",
      "applications": "El sistema IDP Impermeabilización bajo baldosas o grava es una opción ideal para la impermeabilización de balcones, terrazas, cubiertas no expuestas con tráfico peatonal, o tráfico vehicular ligero.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Membrana de Poliuretano 1K | Membrana líquida de poliuretano monocomponente para impermeabilización | IDP Poliurea en Frío de Altas Prestaciones | Membrana de poliurea bicomponente de aplicación en frío de altas prestaciones | IDP Imprimación Flexible de Poliuretano | Imprimación flexible para sistemas de poliuretano | IDP Imprimación para Poliurea | Imprimación para sistemas de poliurea"
    },
    {
      "id": "idp-proof-pu-protec-2",
      "name": "IDP Impermeabilización protegida con mortero",
      "note": "Configuración inicial PU: imprimación 0,50 + membrana 2,00 + puente SUPERIOR 0,50 = 3,00 kg/m² de resinas; 315,00 kg para 100 m² + 5 %. El puente va encima de la membrana y bajo mortero, no bajo la impermeabilización. Cuarzo 0,3–0,8 mm en segunda mano fresca de imprimación y, separadamente, hasta saturación en puente fresco: dotaciones no cuantificadas, medir aparte. Mortero: producto, espesor, dotación, prestaciones, juntas y curado de proyecto. Alternativa Cold: 2,00 en una capa manual horizontal, A:B 100:6 en peso, planificar reaplicación antes de 2 h según su ficha. Puentes alternativos F01-013 o F01-014 a 0,50 por uso específico del sistema; no sumar ni sustituir automáticamente. Ficha completa incluye seis anexos y condiciones de todas las alternativas. Espesor aproximado de impermeabilización 1,8 mm; no incluye espesor de mortero.",
      "sheet": "IDP_Impermeabilizacion_protegida_con_mortero_c6ec39bb-6119-4b81-bd37-6de43b71cbd5.pdf",
      "systemUrl": "/products/idp-proof-pu-protec-2",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; dos manos de 0,25",
          "coats": 2,
          "packages": [
            15
          ],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana impermeabilizante PU",
          "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
          "name": "Membrana de poliuretano aromático monocomponente al disolvente",
          "commercialName": "IDP Membrana de Poliuretano 1K",
          "technicalName": "Membrana de poliuretano aromático monocomponente al disolvente",
          "sourceName": "IDP Membrana de Poliuretano 1K",
          "consumption": 1,
          "officialConsumption": 1,
          "officialLabel": "2,00 kg/m² TOTAL; dos manos de 1,00",
          "coats": 2,
          "packages": [
            25,
            6
          ],
          "sheet": "IDP_Membrana_de_Poliuretano_1K_1265e98a-8534-4093-a852-f38e18916844.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion"
        },
        {
          "phase": "Puente superior bajo mortero",
          "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
          "name": "Membrana de poliuretano aromático monocomponente al disolvente",
          "commercialName": "IDP Membrana de Poliuretano 1K",
          "technicalName": "Membrana de poliuretano aromático monocomponente al disolvente",
          "sourceName": "IDP Membrana de Poliuretano 1K",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,50 kg/m² ADICIONAL sobre la membrana; una capa fina",
          "coats": 1,
          "packages": [
            25,
            6
          ],
          "sheet": "IDP_Membrana_de_Poliuretano_1K_1265e98a-8534-4093-a852-f38e18916844.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion"
        }
      ],
      "commercialName": "IDP Impermeabilización protegida con mortero",
      "technicalName": "Sistema técnico de impermeabilización protegida con mortero",
      "description": "Sistema a base de resinas de poliuretano aromático monocomponente en base disolvente, protegido con mortero.",
      "applications": "El sistema IDP Impermeabilización protegida con mortero es una opción ideal para la impermeabilización no expuesta de contrapisos.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de Poliuretano 1K | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Poliurea Cold | IDP Imprimación Flexible de Poliuretano | IDP Imprimación para Poliurea"
    },
    {
      "id": "idp-proof-pu-spray",
      "name": "IDP Impermeabilización de poliuretano proyectado en caliente para cubiertas",
      "note": "Seis anexos incluyen variante antideslizante y epoxi de humedad, no seis capas acumuladas. Configuración inicial SIN ESPUMA: no promesa de aislamiento ni espesor de centímetros. Cuarzo fino 1,50 de anclaje recuperado de guía íntegra; no otra dosis de epoxi, ni cuarzo grueso del acabado. Membrana es PU calienteF03-051, no manual 2 K ni poliurea pura. Acabado 0,50 dos 0,25 de guía, no sumar dosis general de otra aplicación. Solapes>2 h necesitan procedimiento de limpieza/activación exacto comprobado, no permiso universal. Variantes de espuma 50/150 kg/m³, químicos, encapsulamiento y presión negativa no se activan por parecido. ETE2017 incluye acabado específico distinto: no certificadoIDP automático de selección ni garantía 25 años. Fuego y cargas dependen de soporte/configuración; SRI105 solo blanco del protector ensayado, no todo color o cubierta. Consultar ficha 24 p/anexos.",
      "sheet": "IDP_Impermeabilizacion_de_poliuretano_proyectado_en_caliente_para_cubiertas.pdf",
      "systemUrl": "/products/idp-proof-pu-spray",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi, dos manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-arido-de-cuarzo-0-1-0-3-mm",
          "phase": "Anclaje fino sobre primera epoxi fresca",
          "consumption": 1.5,
          "coats": 1,
          "name": "IDP Árido de cuarzo 0,1–0,3 mm",
          "commercialName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "technicalName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "sourceName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "officialConsumption": 1.5,
          "packages": [],
          "sheet": "IDP_Arido_de_cuarzo_0_1_0_3_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-0-1-0-3-mm"
        },
        {
          "productId": "membrana-liquida-de-poliuretano-biocomponente-para-impermeabilizacion",
          "phase": "Membrana PU de proyección caliente",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Membrana de poliuretano bicomponente de proyección en caliente",
          "commercialName": "IDP Membrana de poliuretano bicomponente de proyección en caliente",
          "technicalName": "IDP Membrana de poliuretano bicomponente de proyección en caliente",
          "sourceName": "IDP Membrana de poliuretano bicomponente de proyección en caliente",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliuretano_bicomponente_de_proyeccion_en_caliente.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-biocomponente-para-impermeabilizacion"
        },
        {
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "phase": "Protector pigmentado, dos manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Revestimiento alifático monocomponente para membranas",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        }
      ],
      "commercialName": "IDP Poliuretano proyectado para impermeabilización y amianto",
      "technicalName": "Sistema técnico de poliuretano proyectado para impermeabilización y amianto",
      "description": "Impermeabilización de cubierta sobre soporte mineral seco con epoxi independiente, anclaje de cuarzo fino, poliuretano bicomponente de proyección caliente y protector alifático pigmentado. Sin espuma en selección inicial.",
      "applications": "El sistema IDP Poliuretano proyectado para impermeabilización y amianto es una opción ideal para la impermeabilización y encapsulación de amianto de grandes cubiertas con sustratos irregulares.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de poliuretano bicomponente de proyección en caliente | IDP Revestimiento alifático monocomponente para membranas | IDP Árido de cuarzo 0,1–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Imprimación Epoxi para Hormigón Húmedo"
    },
    {
      "id": "idp-proof-pu-w",
      "name": "IDP Impermeabilización de poliuretano híbrido al agua con refuerzo de fibra",
      "note": "Resumen 08/04/2025, membrana 16/04/2026 y fibra 09/10/2026. Corrección visible de nominal membrana 2,50 a selección común 2,20(1,20+1), resina con sellado 2,50; con fibra 150 g, total 2,65. No atribuir cifra 2,20 al nominal original ni garantizar 2 mm: producto aproxima 1 mm, control real y proyecto. Sellado con propio producto acreditado; imprimación epoxi independiente del piloto 100 %sólidos no se extrapola. Dilución opcional 10 %de resumen frente 20 %actualpara sellado documentada, NO activada, manos sin diluir. Refuerzo 150 exacto, no 30/velo 80/geotextilPPporanalogía. Quince agentes químicos de contactoPERMANENTE completos, sin falso superficial 24 h. AcabadoMATE/envase metálico corregidos. Sin HR máxima numérica inventada, clase 3, potable, garantíaaños o certificado automático. Protección elástica acuosa 2 K0,20–0,30 paraotra selección transitable no añadida aquí. Consultar 8 pydosanexos.",
      "sheet": "IDP_Impermeabilizacion_de_poliuretano_hibrido_al_agua_con_refuerzo_de_fibra.pdf",
      "systemUrl": "/products/idp-proof-pu-w",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "membrana-liquida-de-poliuretano-al-agua-monocomponente",
          "phase": "Sellado del soporte con el propio PU acuoso",
          "consumption": 0.3,
          "coats": 1,
          "name": "IDP Membrana de Poliuretano Híbrido al Agua",
          "commercialName": "IDP Membrana de Poliuretano Híbrido al Agua",
          "technicalName": "IDP Membrana de Poliuretano Híbrido al Agua",
          "sourceName": "IDP Membrana de Poliuretano Híbrido al Agua",
          "officialConsumption": 0.3,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_Hibrido_al_Agua_ae6e048c-b9a2-4319-abea-62daa580d29c.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-al-agua-monocomponente"
        },
        {
          "productId": "membrana-liquida-de-poliuretano-al-agua-monocomponente",
          "phase": "Primera mano de membrana acuosa",
          "consumption": 1.2,
          "coats": 1,
          "name": "IDP Membrana de Poliuretano Híbrido al Agua",
          "commercialName": "IDP Membrana de Poliuretano Híbrido al Agua",
          "technicalName": "IDP Membrana de Poliuretano Híbrido al Agua",
          "sourceName": "IDP Membrana de Poliuretano Híbrido al Agua",
          "officialConsumption": 1.2,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_Hibrido_al_Agua_ae6e048c-b9a2-4319-abea-62daa580d29c.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-al-agua-monocomponente"
        },
        {
          "productId": "malla-de-fibra-de-vidrio-para-refuerzo-de-impermeabilizacion-liquida",
          "phase": "Refuerzo de fibra de vidrio150g/m²",
          "consumption": 0.15,
          "coats": 1,
          "name": "IDP Malla de Fibra de Vidrio",
          "commercialName": "IDP Malla de Fibra de Vidrio",
          "technicalName": "IDP Malla de Fibra de Vidrio",
          "sourceName": "IDP Malla de Fibra de Vidrio",
          "officialConsumption": 0.15,
          "packages": [],
          "sheet": "IDP_Malla_de_Fibra_de_Vidrio_aca10b7b-f44d-4b6f-ab71-d1ecaf88d74a.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/malla-de-fibra-de-vidrio-para-refuerzo-de-impermeabilizacion-liquida"
        },
        {
          "productId": "membrana-liquida-de-poliuretano-al-agua-monocomponente",
          "phase": "Segunda mano de membrana acuosa",
          "consumption": 1,
          "coats": 1,
          "name": "IDP Membrana de Poliuretano Híbrido al Agua",
          "commercialName": "IDP Membrana de Poliuretano Híbrido al Agua",
          "technicalName": "IDP Membrana de Poliuretano Híbrido al Agua",
          "sourceName": "IDP Membrana de Poliuretano Híbrido al Agua",
          "officialConsumption": 1,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_Hibrido_al_Agua_ae6e048c-b9a2-4319-abea-62daa580d29c.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-al-agua-monocomponente"
        }
      ],
      "commercialName": "IDP Impermeabilización híbrida de poliuretano al agua",
      "technicalName": "Sistema técnico de impermeabilización híbrida de poliuretano al agua",
      "description": "Impermeabilización de cubierta expuesta no transitable con pendiente superior al 1 %, membrana de PU híbrido alifático monocomponente al agua y refuerzo de fibra de vidrio 150 g/m². Sellado con la propia resina acreditado. Dotación revisada expresamente dentro de las manos vigentes; dos anexos completos.",
      "applications": "El sistema IDP Impermeabilización híbrida de poliuretano al agua es una opción ideal para la impermeabilización de cubiertas con pendiente superior al 1% sin tránsito peatonal.",
      "keywords": "IDP Membrana de Poliuretano Híbrido al Agua | IDP Malla de Fibra de Vidrio"
    },
    {
      "id": "idp-proof-pu-2k-m-plus",
      "name": "IDP Impermeabilización de poliuretano bicomponente con acabado al agua",
      "note": "Configuración IDP CORREGIDA: imprimación H independiente 0,50 TOTAL (2 × 0,25), membrana PU Manual2K 2,00 TOTAL (2 × 1,00 para respetar máximo 1,50 por capa), acabado ECO bicomponente al agua PIGMENTADO 0,50 TOTAL (2 × 0,25). Total resinas 3,00 kg/m²; para 100 m² + 5 %: 315,00 kg. Se corrige expresamente la pasada única de 2,00 del resumen 31/03/2025 y su descripción monocomponente al disolvente. Uso NO TRANSITABLE o LIMITADO AL MANTENIMIENTO por ficha específica del acabado: no tránsito peatonal regular ni rodado. Acabado curado 10–15 días antes de mantenimiento, no por tacto. Sin árido/refuerzo general/dilución/aditivos por defecto. No 100 % sólidos del conjunto ni certificado nuevo de otra configuración.",
      "sheet": "IDP_Impermeabilizacion_de_poliuretano_bicomponente_con_acabado_al_agua.pdf",
      "systemUrl": "/products/idp-proof-pu-2k-m-plus",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación epoxi al agua independiente",
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "phase": "Membrana PU Manual2K: reparto corregido",
          "productId": "membrana-liquida-de-poliuretano-biocomponente-de-aplicacion-manual",
          "name": "IDP Membrana de Poliuretano Manual 2K",
          "commercialName": "IDP Membrana de Poliuretano Manual 2K",
          "technicalName": "IDP Membrana de Poliuretano Manual 2K",
          "sourceName": "IDP Membrana de Poliuretano Manual 2K",
          "consumption": 1,
          "officialConsumption": 1,
          "officialLabel": "2,00 kg/m² TOTAL; 2 × 1,00; máximo de producto 1,50 por capa",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_Manual_2K_03edec94-c9a7-473d-b218-a058d38801e7.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-biocomponente-de-aplicacion-manual"
        },
        {
          "phase": "Acabado ECO al agua PIGMENTADO",
          "productId": "recubrimiento-de-poliuretano-alifatico-al-agua",
          "name": "IDP Acabado Alifático de Poliuretano al Agua · PIGMENTADO",
          "commercialName": "IDP Acabado Alifático de Poliuretano al Agua",
          "technicalName": "IDP Acabado Alifático de Poliuretano al Agua · PIGMENTADO",
          "sourceName": "IDP Acabado Alifático de Poliuretano al Agua",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25; uso limitado a mantenimiento",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Acabado_Alifatico_de_Poliuretano_al_Agua_32368c64-b59e-4482-b3b5-c4daf0ace1a6.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-de-poliuretano-alifatico-al-agua"
        }
      ],
      "commercialName": "IDP Impermeabilización bicomponente para cubierta peatonal",
      "technicalName": "Sistema técnico de impermeabilización bicomponente para cubierta peatonal",
      "description": "Cubierta con imprimación epoxi al agua, membrana PU bicomponente en dos manos y acabado alifático acuoso bicomponente, acceso limitado al mantenimiento.",
      "applications": "El sistema IDP Proof PU 2K M PLUS es una opción ideal para la impermeabilización de cubiertas con tráfico peatonal.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Membrana de Poliuretano Manual 2K | IDP Acabado Alifático de Poliuretano al Agua"
    },
    {
      "id": "idp-proof-pu-2k-m-green-roof",
      "name": "IDP Impermeabilización bicomponente para cubierta ajardinada",
      "note": "Drenaje y referencia de geotextil protector identificados y enlazados. La ficha integral de cubierta sigue pendiente de fijar la configuración de protección y filtración, versión y colocación de drenaje, encuentros y mediciones del proyecto. No es una configuración completa aprobada para ejecutar. Dos capas distintas de geotextil de protección, una bajo y otra sobre el drenaje, de 200–500 g/m² según la prescripción de origen. El gramaje no es cantidad de resina ni superficie útil instalada. Acreditar referencia y aptitud de protección/filtración, solapes y superficie neta antes de medir. No sustituir automáticamente por un refuerzo de 80 g/m². Lámina HDPE drenante y acumuladora de agua. Seleccionar versión perforada o no perforada, orientación, disposición, drenajes y superficie en m² conforme al proyecto; considerar recortes y solapes. La masa superficial de 1 kg/m² no equivale a un consumo universal de 1 kg/m² de cubierta ni define su área útil. Ficha completa disponible; no se atribuyen caudal de ensayo, solape o certificado antirraíces no aportados. El resultado de resinas es un subtotal, no una medición completa; no presupuestar la cubierta como 2,50 kg/m² totales.",
      "sheet": "ficha-sistema-idp-proof-pu-2k-m-green-roof-es.pdf",
      "systemUrl": "/products/idp-proof-pu-2k-m-green-roof",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "idp-epoxy-100",
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100",
          "officialLabel": "0.25 kg/m² por mano"
        },
        {
          "phase": "Membrana",
          "productId": "membrana-liquida-de-poliuretano-biocomponente-de-aplicacion-manual",
          "name": "IDP Membrana de Poliuretano Manual 2K",
          "commercialName": "IDP Membrana de Poliuretano Manual 2K",
          "technicalName": "IDP Membrana de Poliuretano Manual 2K",
          "sourceName": "IDP Membrana de Poliuretano Manual 2K",
          "consumption": 1,
          "officialConsumption": 1,
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_Manual_2K_03edec94-c9a7-473d-b218-a058d38801e7.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-biocomponente-de-aplicacion-manual",
          "officialLabel": "1 kg/m² por mano"
        },
        {
          "phase": "Drenaje: medir superficie en m² según proyecto",
          "productId": "idp-lamina-drenante-y-acumuladora-de-agua-para-cubiertas-vegetales",
          "name": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "commercialName": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "technicalName": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "sourceName": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "consumption": 0,
          "officialConsumption": 0,
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Lamina_drenante_y_acumuladora_de_agua_para_cubiertas_vegetales.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-lamina-drenante-y-acumuladora-de-agua-para-cubiertas-vegetales",
          "officialLabel": "Medición pendiente en m²; cero no es ausencia de material"
        }
      ],
      "commercialName": "IDP Impermeabilización bicomponente para cubierta ajardinada",
      "technicalName": "Sistema técnico de impermeabilización bicomponente para cubierta ajardinada",
      "description": "Sistema sostenible a base de resinas de poliuretano. Añade diseño al tejado, valor a la propiedad y mejora la calidad del aire.",
      "applications": "El sistema IDP PROOF PU 2K M GREEN ROOF es una opción ideal para impermeabilizar cubiertas de hormigón en residencias privadas, edificios públicos, etc.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Membrana de Poliuretano Manual 2K | Membrana líquida de poliuretano bicomponente de aplicación manual"
    },
    {
      "id": "idp-proof-pu-2k-m-radon-gas-shield",
      "name": "IDP Barrera líquida de poliuretano bicomponente frente al radón",
      "note": "Fuentes resumen 26/05/2026, guíaoficial 12 p, membrana 03/11/2025, primer 03/12/2025 ygeotextil 26/08/2025. Inicial horizontal SIN refuerzo general 0,50+3,00=3,50 kg/m². Una mano primerhorizontal/dosverticalesporresumen, guíaotrasdos 0,20+0,30 con áridoSINdotaciónnoactivado. Variante reforzada: resumenespañolcolumna 3/texto 1+1=2 yresumeninglésanterior 2; guíaactual 1,50×2=3,00 seleccionadoexplícitamente, no corrección silenciosa. Coeficiente difusiónsinrefuerzo 1,4×10⁻¹²/conrefuerzoorigen 1,5×10⁻¹²m²/sISO/DTS11665-13, ensayo 2 mmreferidoenguía; noBq/m³interiorgarantizado. CTEportaloficialconsultado 01/11/2026, criteriolámina<10⁻¹¹m²/symin 2 mmnoelimina continuidad/sellos/durabilidad ni justificación deproyecto yotrasmedidas. Sin certificado global IDP, cumplimiento automático, proteccióncontratodosgases, potable o ausencia absolutademetales. No porcentajebiobasadoinventado. Manual 2 KnoPUA; guíatienepárrafopoliurea/bandaque no se trasladacomo dato. Detalles/refuerzos/protecciónposteriorse midenporproyecto, no en el paño inicial. Consultar 14 p/tresanexos.",
      "sheet": "IDP_Barrera_liquida_de_poliuretano_bicomponente_frente_al_radon.pdf",
      "systemUrl": "/products/idp-proof-pu-2k-m-radon-gas-shield",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente horizontal",
          "consumption": 0.5,
          "coats": 1,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.5,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "membrana-liquida-de-poliuretano-biocomponente-de-aplicacion-manual",
          "phase": "Membrana PU bicomponente manual",
          "consumption": 1.5,
          "coats": 2,
          "name": "IDP Membrana de Poliuretano Manual 2K",
          "commercialName": "IDP Membrana de Poliuretano Manual 2K",
          "technicalName": "IDP Membrana de Poliuretano Manual 2K",
          "sourceName": "IDP Membrana de Poliuretano Manual 2K",
          "officialConsumption": 1.5,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_Manual_2K_03edec94-c9a7-473d-b218-a058d38801e7.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-biocomponente-de-aplicacion-manual"
        }
      ],
      "commercialName": "IDP Barrera líquida de poliuretano contra radón",
      "technicalName": "Sistema técnico de barrera líquida de poliuretano contra radón",
      "description": "Barrera continua frente al radón de aplicación manual en frío con epoxi independiente y poliuretano bicomponente específico. Selección horizontal sin refuerzo general: primer 0,50 y membrana 3,00 TOTAL en dos 1,50. Tres anexos completos y alternativa reforzada documentada por guía; espesor mínimo 2 mm medido, justificación de proyecto sin cumplimiento automático del edificio.",
      "applications": "El sistema IDP PROOF PU 2K M RADON GAS SHIELD es una opción ideal para conseguir una barrera capaz de contener la entrada de radón de conformidad con CTE DB-HS-6. Punto 3.1 - Características de las barreras.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de Poliuretano Manual 2K | IDP Geotextil de poliéster y poliamida de 80 g por m²"
    },
    {
      "id": "idp-proof-pu-deco",
      "name": "IDP Impermeabilización decorativa con cuarzo color",
      "note": "Fuente 10/06/2025: pigmentado 0,30 kg/m². Se actualiza explícitamente a 0,40, mínimo del rango actual 0,40–0,60 del protector 20/04/2026; no se conserva total antiguo 5,75. Total nuevo 5,85; comprobar cobertura, textura y adherencia. Cuarzo color 2,50 kg/m² acreditado para este sistema; selección de catálogo FC03-08 0,3–0,8 mm, sin importar el erróneo 3 kg/m³ de otro decorativo. No cuarzo natural, fino o conductor. Protector pigmentado e incoloro son formulaciones y fases distintas de la misma referencia. Alternativas ST/QC no sumadas: ST 421 %/3,4 MPa, QC 617 %/4,1 MPa, estándar 450–600 %/2,5–4,3 MPa; no transferir viscosidad, curado, ensayos ni máximos entre ellas. No 100 % sólidos del conjunto. SRI 105 solo BLANCO ensayado del protector; no color de cuarzo, transparente ni cubierta completa. Sin clase 3 por granulometría, potabilidad, inmersión indefinida, tráfico de vehículos o garantía global de 25 años por analogía. Seis anexos íntegros enlazados y productos por separado.",
      "sheet": "IDP_Impermeabilizacion_decorativa_con_cuarzo_color_debb1eb6-a725-477c-9060-663c93da533c.pdf",
      "systemUrl": "/products/idp-proof-pu-deco",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "phase": "Imprimación epoxi acuosa independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
          "phase": "Membrana PU monocomponente en frío",
          "consumption": 1,
          "coats": 2,
          "name": "IDP Membrana de Poliuretano 1K",
          "commercialName": "IDP Membrana de Poliuretano 1K",
          "technicalName": "IDP Membrana de Poliuretano 1K",
          "sourceName": "IDP Membrana de Poliuretano 1K",
          "officialConsumption": 1,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_1K_1265e98a-8534-4093-a852-f38e18916844.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion"
        },
        {
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "phase": "Protector alifático PIGMENTADO bajo cuarzo",
          "consumption": 0.4,
          "coats": 1,
          "name": "IDP Revestimiento alifático monocomponente para membranas",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "officialConsumption": 0.4,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        },
        {
          "productId": "idp-arido-de-cuarzo-coloreado-0-3-0-8-mm",
          "phase": "Espolvoreo de cuarzo COLOREADO sobre pigmentado fresco",
          "consumption": 2.5,
          "coats": 1,
          "name": "IDP Árido de cuarzo coloreado 0,3–0,8 mm",
          "commercialName": "IDP Árido de cuarzo coloreado 0,3–0,8 mm",
          "technicalName": "IDP Árido de cuarzo coloreado 0,3–0,8 mm",
          "sourceName": "IDP Árido de cuarzo coloreado 0,3–0,8 mm",
          "officialConsumption": 2.5,
          "packages": [],
          "sheet": "IDP_Arido_de_cuarzo_coloreado_0_3_0_8_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-coloreado-0-3-0-8-mm"
        },
        {
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "phase": "Cierre alifático INCOLORO del cuarzo",
          "consumption": 0.225,
          "coats": 2,
          "name": "IDP Revestimiento alifático monocomponente para membranas",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "officialConsumption": 0.225,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        }
      ],
      "commercialName": "IDP Impermeabilización decorativa con cuarzo color",
      "technicalName": "Sistema técnico de impermeabilización decorativa con cuarzo color",
      "description": "Impermeabilización decorativa de hormigón seco con imprimación epoxi acuosa independiente, membrana de poliuretano monocomponente aplicada en frío, protector alifático pigmentado, cuarzo coloreado y cierre alifático incoloro. Ficha completa de 24 páginas con seis anexos de componentes y alternativas diferenciadas. Dotación revisada 5,85 kg/m².",
      "applications": "El sistema IDP Proof PU DECO es una opción ideal para la impermeabilización de cubierta, balcones y terrazas donde se requiera un acabado estético decorativo.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Membrana de Poliuretano 1K | IDP Revestimiento alifático monocomponente para membranas | IDP Árido de cuarzo coloreado 0,3–0,8 mm | IDP Membrana de Poliuretano 1K ST | IDP Membrana de Poliuretano de Secado Rápido"
    },
    {
      "id": "idp-proof-pu-deco-pavistone",
      "name": "IDP Impermeabilización drenante con mármol triturado",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-proof-pu-deco-pavistone-es.pdf",
      "systemUrl": "/products/idp-proof-pu-deco-pavistone",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "name": "Imprimación epoxi para sistemas de impermeabilización",
          "sourceName": "Hormigón: Imprimación IDP H",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0.5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-009.pdf",
          "commercialName": "IDP Imprimación Epoxi para Impermeabilización",
          "technicalName": "Imprimación epoxi para sistemas de impermeabilización",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "phase": "Capa Base",
          "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
          "name": "Membrana líquida de poliuretano monocomponente para impermeabilización",
          "sourceName": "IDP Impermax",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f03-056.pdf",
          "commercialName": "IDP Membrana de Poliuretano 1K",
          "technicalName": "Membrana líquida de poliuretano monocomponente para impermeabilización",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion"
        },
        {
          "phase": "Puente De Union",
          "productId": "imprimacion-flexible-para-sistemas-de-poliuretano",
          "name": "Imprimación flexible para sistemas de poliuretano",
          "sourceName": "Imprimación IDP Imprimación Flexible de Poliuretano",
          "consumption": 0.3,
          "officialConsumption": 0.3,
          "officialLabel": "0.3 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-013.pdf",
          "commercialName": "IDP Imprimación Flexible de Poliuretano",
          "technicalName": "Imprimación flexible para sistemas de poliuretano",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-flexible-para-sistemas-de-poliuretano"
        },
        {
          "phase": "Pavistone",
          "productId": "",
          "name": "Pavistone.",
          "sourceName": "Pavistone.",
          "consumption": 0.92,
          "officialConsumption": 0.92,
          "officialLabel": "0.92 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "",
          "commercialName": "",
          "technicalName": "",
          "documentStatus": "alternativas_documentadas",
          "productUrl": "",
          "productOptions": [
            {
              "productId": "ligante-de-poliuretano-alifatico-monocomponente-para-pavimentos-de-arido",
              "commercialName": "IDP Ligante de Poliuretano Alifático 1K",
              "technicalName": "Ligante de poliuretano alifático monocomponente para pavimentos de árido",
              "technicalSheet": "IDP_Ligante_de_Poliuretano_Alifatico_1K_74252f08-78fd-4d2e-ae44-f39d80bcae5e.pdf",
              "productUrl": "https://idpproductos.com/products/ligante-de-poliuretano-alifatico-monocomponente-para-pavimentos-de-arido",
              "documentStatus": "validada",
              "configurationCondition": "Seleccionar según soporte y condiciones de obra"
            },
            {
              "productId": "ligante-de-poliuretano-alifatico-bicomponente-resistente-a-uv-para-pavimentos-de-arido",
              "commercialName": "IDP Ligante de Poliuretano Alifático 2K UV",
              "technicalName": "Ligante de poliuretano alifático bicomponente resistente a UV para pavimentos de árido",
              "technicalSheet": "ficha-tecnica-ft-idp-f06-078.pdf",
              "productUrl": "https://idpproductos.com/products/ligante-de-poliuretano-alifatico-bicomponente-resistente-a-uv-para-pavimentos-de-arido",
              "documentStatus": "validada",
              "configurationCondition": "Seleccionar según soporte y condiciones de obra"
            }
          ],
          "selectionRequired": true,
          "prescriptionNote": "Seleccionar una sola alternativa compatible; no sumar las opciones entre sí."
        },
        {
          "phase": "Sellado",
          "productId": "",
          "name": "Piedra de mármol triturado",
          "sourceName": "Piedra de mármol triturado",
          "consumption": 17,
          "officialConsumption": 17,
          "officialLabel": "17 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "",
          "commercialName": "",
          "technicalName": "",
          "documentStatus": "",
          "productUrl": ""
        },
        {
          "phase": "Sellado",
          "productId": "acabado-de-poliuretano-alifatico-monocomponente-de-altas-prestaciones",
          "name": "Acabado de poliuretano alifático monocomponente de altas prestaciones",
          "sourceName": "Floortop IDP 1K",
          "consumption": 0.175,
          "officialConsumption": 0.175,
          "officialLabel": "0.15 - 0.2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f05-074.pdf",
          "commercialName": "IDP Acabado Alifático de Poliuretano 1K",
          "technicalName": "Acabado de poliuretano alifático monocomponente de altas prestaciones",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/acabado-de-poliuretano-alifatico-monocomponente-de-altas-prestaciones"
        }
      ],
      "commercialName": "IDP Impermeabilización drenante con mármol triturado",
      "technicalName": "Sistema técnico de impermeabilización drenante con mármol triturado",
      "description": "Sistema de impermeabilización a base de resinas de poliuretano aromático monocomponente en base disolvente, sellado con sistema drenante de la mezcla de poliuretano alifático transparente con agregados de mármol triturado.",
      "applications": "El sistema IDP Proof PU DECO PAVISTONE es una opción ideal para la impermeabilización de cubierta, balcones y terrazas donde se requiera un acabado estético decorativo.",
      "keywords": "IDP Imprimación Epoxi para Impermeabilización | Imprimación epoxi para sistemas de impermeabilización | IDP Membrana de Poliuretano 1K | Membrana líquida de poliuretano monocomponente para impermeabilización | IDP Imprimación Flexible de Poliuretano | Imprimación flexible para sistemas de poliuretano | IDP Ligante de Poliuretano Alifático 1K | Ligante de poliuretano alifático monocomponente para pavimentos de árido | IDP Ligante de Poliuretano Alifático 2K UV | Ligante de poliuretano alifático bicomponente resistente a UV para pavimentos de árido | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    {
      "id": "idp-proof-pu-park",
      "name": "IDP Impermeabilización de poliuretano para aparcamientos con tráfico ligero",
      "note": "Resumen 13/07/2026 y guía oficial 15 p del MISMO sistema. Se restituye vidrio 150 en primera membrana fresca y rodadura Manual 2 K1,00 DISTINTA; protector exactoPIGMENTADO0,50 dos 0,25. Guía aporta cuarzo NATURAL0,3–0,8 mm 1–2 kg/m²entre manos de acabado: selección explícita 1,50, total 5,65, incluye vidrio nominal 0,150 antes de solapes. No copiarlo al PUA PARKpuro con divergencia de grano. ST/QCalternativas reemplazanmembrana sin sumarse y conservan procedimientos propios; aditivo 5 %últimamano 0,25 equivale 0,0125, NO0,15 del otropliego. No sumado al cuarzo inicial. Para rodado la ficha de aditivo prefiere árido; selección sigue guía. Pliego 1.4.1 con primer acuoso/ST/geotextil/aditivo 0,15 NOsefusiona. Rampas exigen ST, rodadura espesada y≥3 manos deprotector con configuración propia, no cubiertaspor medición inicial. HR≤60 %y soporte 15–25 por intersección de componentes. Sin 100 %sólidos del conjunto, certificado global, clase 3 por grano, SRI105 para gris, potable, antirraíces o radón del edificio por analogía.",
      "sheet": "IDP_Impermeabilizacion_de_poliuretano_para_aparcamientos_con_trafico_ligero.pdf",
      "systemUrl": "/products/idp-proof-pu-park",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
          "phase": "Membrana PU1K fría estándar",
          "consumption": 1,
          "coats": 2,
          "name": "IDP Membrana de Poliuretano 1K",
          "commercialName": "IDP Membrana de Poliuretano 1K",
          "technicalName": "IDP Membrana de Poliuretano 1K",
          "sourceName": "IDP Membrana de Poliuretano 1K",
          "officialConsumption": 1,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_1K_1265e98a-8534-4093-a852-f38e18916844.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion"
        },
        {
          "productId": "malla-de-fibra-de-vidrio-para-refuerzo-de-impermeabilizacion-liquida",
          "phase": "VIDRIO150 embebido en primera membrana fresca; antes de solapes",
          "consumption": 0.15,
          "coats": 1,
          "name": "IDP Malla de Fibra de Vidrio",
          "commercialName": "IDP Malla de Fibra de Vidrio",
          "technicalName": "IDP Malla de Fibra de Vidrio",
          "sourceName": "IDP Malla de Fibra de Vidrio",
          "officialConsumption": 0.15,
          "packages": [],
          "sheet": "IDP_Malla_de_Fibra_de_Vidrio_aca10b7b-f44d-4b6f-ab71-d1ecaf88d74a.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/malla-de-fibra-de-vidrio-para-refuerzo-de-impermeabilizacion-liquida"
        },
        {
          "productId": "membrana-liquida-de-poliuretano-biocomponente-de-aplicacion-manual",
          "phase": "Rodadura PU Manual2K",
          "consumption": 1,
          "coats": 1,
          "name": "IDP Membrana de Poliuretano Manual 2K",
          "commercialName": "IDP Membrana de Poliuretano Manual 2K",
          "technicalName": "IDP Membrana de Poliuretano Manual 2K",
          "sourceName": "IDP Membrana de Poliuretano Manual 2K",
          "officialConsumption": 1,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_Manual_2K_03edec94-c9a7-473d-b218-a058d38801e7.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-biocomponente-de-aplicacion-manual"
        },
        {
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "phase": "Acabado alifático PIGMENTADO; cuarzo entre ambas manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Revestimiento alifático monocomponente para membranas",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Cuarzo NATURAL sobre primera mano FRESCA del acabado",
          "consumption": 1.5,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 1.5,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        }
      ],
      "commercialName": "IDP Impermeabilización de poliuretano para tráfico rodado",
      "technicalName": "Sistema técnico de impermeabilización de poliuretano para tráfico rodado",
      "description": "Impermeabilización en frío de paños horizontales de aparcamientos con tráfico vehicular ligero. Imprimación epoxi independiente, membrana PU1 K reforzada con vidrio 150, rodadura PU Manual 2 K y sellado alifático PIGMENTADO con cuarzo NATURAL0,3–0,8 mm entre manos. Nueve fichas de componentes completas, incluidas alternativas diferenciadas no sumadas.",
      "applications": "El sistema IDP Proof PU PARK es una opción ideal para la impermeabilización de cubiertas de aparcamientos con tráfico vehicular ligero.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de Poliuretano 1K | IDP Malla de Fibra de Vidrio | IDP Membrana de Poliuretano Manual 2K | IDP Revestimiento alifático monocomponente para membranas | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Membrana de Poliuretano 1K ST | IDP Membrana de Poliuretano de Secado Rápido | IDP Aditivo Antideslizante"
    },
    {
      "id": "idp-proof-pu-green-roof",
      "name": "IDP Impermeabilización de poliuretano para cubierta ajardinada",
      "note": "Configuración sobre hormigón SECO: imprimación 0,50 total en dos manos de 0,25 + membrana PU1K 2,00 total en dos manos de 1,00 = 2,50 kg/m² de resinas. Para 100 m² y 5 % de merma, 262,50 kg. Fibra 150 g/m² embebida en primera mano fresca: se mide aparte en m² con solapes y recortes; 100 m² netos equivalen a masa nominal de 15 kg antes de solapes. Tras membrana curada: geotextil inferior de protección 200–500 g/m², drenaje y geotextil superior 200–500 g/m², sustrato y vegetación de proyecto. Estos materiales no son kilos de resina y quedan fuera del cálculo inicial. Definir fichas, solapes, espesor, punzonamiento, filtración, caudal y cargas saturadas antes de obra. No usar geotextil NMDC como sustituto de fibra de vidrio. Sin conversión kg/m² a mm. Espumas de regularización mencionadas en origen son variantes fuera de esta configuración: densidad 50 kg/m³ o 150 kg/m³ no es consumo de epoxi. Ensayo antirraíces de membrana reforzada 2024GT0188: comprobar alcance y suministro; no certificado nuevo del conjunto IDP.",
      "sheet": "IDP_Impermeabilizacion_de_poliuretano_para_cubierta_ajardinada_64969303-452a-4243-bb5a-c69bf455e2eb.pdf",
      "systemUrl": "/products/idp-proof-pu-green-roof",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación epoxi independiente",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; dos manos de 0,25",
          "coats": 2,
          "packages": [
            15
          ],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana PU reforzada con fibra 150",
          "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
          "name": "Membrana de poliuretano aromático monocomponente al disolvente",
          "commercialName": "IDP Membrana de Poliuretano 1K",
          "technicalName": "Membrana de poliuretano aromático monocomponente al disolvente",
          "sourceName": "IDP Membrana de Poliuretano 1K",
          "consumption": 1,
          "officialConsumption": 1,
          "officialLabel": "2,00 kg/m² TOTAL; dos manos de 1,00; fibra embebida en primera mano fresca, medida aparte",
          "coats": 2,
          "packages": [
            25,
            6
          ],
          "sheet": "IDP_Membrana_de_Poliuretano_1K_1265e98a-8534-4093-a852-f38e18916844.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion"
        }
      ],
      "commercialName": "IDP Impermeabilización de poliuretano para cubierta ajardinada",
      "technicalName": "Sistema técnico de impermeabilización de poliuretano para cubierta ajardinada",
      "description": "Sistema sostenible a base de resinas de poliuretano. Añade diseño al tejado, valor a la propiedad. y la mejora de la calidad del aire.",
      "applications": "El sistema IDP PROOF PU GREEN ROOF es una opción ideal para impermeabilizar cubiertas de hormigón en residencias privadas, edificios públicos y obras privadas.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de Poliuretano 1K | IDP Malla de Fibra de Vidrio"
    },
    {
      "id": "idp-proof-pu-spray-green-roof",
      "name": "IDP Poliuretano proyectado para cubierta ajardinada",
      "note": "Drenaje y referencia de geotextil protector identificados y enlazados. La ficha integral de cubierta sigue pendiente de fijar la configuración de protección y filtración, versión y colocación de drenaje, encuentros y mediciones del proyecto. No es una configuración completa aprobada para ejecutar. Dos capas distintas de geotextil de protección, una bajo y otra sobre el drenaje, de 200–500 g/m² según la prescripción de origen. El gramaje no es cantidad de resina ni superficie útil instalada. Acreditar referencia y aptitud de protección/filtración, solapes y superficie neta antes de medir. No sustituir automáticamente por un refuerzo de 80 g/m². Lámina HDPE drenante y acumuladora de agua. Seleccionar versión perforada o no perforada, orientación, disposición, drenajes y superficie en m² conforme al proyecto; considerar recortes y solapes. La masa superficial de 1 kg/m² no equivale a un consumo universal de 1 kg/m² de cubierta ni define su área útil. Ficha completa disponible; no se atribuyen caudal de ensayo, solape o certificado antirraíces no aportados. El resultado de resinas es un subtotal, no una medición completa; no presupuestar la cubierta como 2,50 kg/m² totales.",
      "sheet": "ficha-sistema-idp-proof-pu-spray-green-roof-es.pdf",
      "systemUrl": "/products/idp-proof-pu-spray-green-roof",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "idp-epoxy-100",
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100",
          "officialLabel": "0.25 kg/m² por mano"
        },
        {
          "phase": "Membrana",
          "productId": "membrana-liquida-de-poliuretano-biocomponente-para-impermeabilizacion",
          "name": "IDP Membrana de poliuretano bicomponente de proyección en caliente",
          "commercialName": "IDP Membrana de poliuretano bicomponente de proyección en caliente",
          "technicalName": "IDP Membrana de poliuretano bicomponente de proyección en caliente",
          "sourceName": "IDP Membrana de poliuretano bicomponente de proyección en caliente",
          "consumption": 2,
          "officialConsumption": 2,
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliuretano_bicomponente_de_proyeccion_en_caliente.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-biocomponente-para-impermeabilizacion",
          "officialLabel": "2 kg/m² por mano"
        },
        {
          "phase": "Drenaje: medir superficie en m² según proyecto",
          "productId": "idp-lamina-drenante-y-acumuladora-de-agua-para-cubiertas-vegetales",
          "name": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "commercialName": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "technicalName": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "sourceName": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
          "consumption": 0,
          "officialConsumption": 0,
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Lamina_drenante_y_acumuladora_de_agua_para_cubiertas_vegetales.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-lamina-drenante-y-acumuladora-de-agua-para-cubiertas-vegetales",
          "officialLabel": "Medición pendiente en m²; cero no es ausencia de material"
        }
      ],
      "commercialName": "IDP Poliuretano proyectado para cubierta ajardinada",
      "technicalName": "Sistema técnico de poliuretano proyectado para cubierta ajardinada",
      "description": "Sistema sostenible a base de resinas de poliuretano de aplicación en caliente. Aporta diseño a la cubierta, valor a la propiedad y mejor calidad del aire entre otros.",
      "applications": "El sistema IDP Proof PU SPRAY GREEN ROOF es una opción ideal para la impermeabilización de cubiertas de hormigón en residencias privadas, edificios públicos y obras privadas.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Membrana de Poliuretano 2K | Membrana líquida de poliuretano bicomponente para impermeabilización | IDP Refuerzo Geotextil | Geotextil de refuerzo para sistemas de poliurea proyectada"
    },
    {
      "id": "idp-proof-pu-cool-roof",
      "name": "IDP Impermeabilización reflectante de poliuretano para cubiertas",
      "note": "Fuentes resumen 28/03/2025, membrana 26/08/2026, protector 20/04/2026 y primers completos. Actualización explícita de protectorblanco 0,25–0,35 a selección 0,50(2×0,25)por intervalo pigmentado actual 0,40–0,60. Total 3,00 sin diluyentes, árido o refuerzo general. Primer independiente acuoso 0,50, alternativa epoxi universal 0,50 sustituye, no duplica. Temperatura mínima común 15°Cporprimer, no>10 solo del resumen. Sistema con membrana y protector al DISOLVENTE, no 100 %sólidos o baseagua completo. SRI105 delblanco específico, no SRI99,55 deAqua, otrosRALo ahorroenergético garantizado. Valores de protector pigmentado 60 D/70 %/15 MPa, no incoloro 53 D/173 %/27,4. Ventanas y curados propios, no 24 hdesde seco para protector ni 24 hmaxmembrana. EnsayosCE/ETE/BBAdeorigen requierenconfiguración/suministro, no garantíaaños, BROOFuniversal, clase 3 deversiónlisa, potable o tráfico rodado. Cuatro anexos completos incluyenla alternativa sin activarla.",
      "sheet": "IDP_Impermeabilizacion_reflectante_de_poliuretano_para_cubiertas.pdf",
      "systemUrl": "/products/idp-proof-pu-cool-roof",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "phase": "Imprimación epoxi al agua independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "productId": "membrana-de-poliuretano-liquida-para-impermeabilizacion",
          "phase": "Membrana aromática PU monocomponente",
          "consumption": 1,
          "coats": 2,
          "name": "IDP Membrana de Poliuretano 1K",
          "commercialName": "IDP Membrana de Poliuretano 1K",
          "technicalName": "IDP Membrana de Poliuretano 1K",
          "sourceName": "IDP Membrana de Poliuretano 1K",
          "officialConsumption": 1,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_1K_1265e98a-8534-4093-a852-f38e18916844.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliuretano-liquida-para-impermeabilizacion"
        },
        {
          "productId": "idp-revestimiento-alifatico-monocomponente-para-membranas",
          "phase": "Protección alifática monocomponente blanca",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Revestimiento alifático monocomponente para membranas",
          "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
          "technicalName": "IDP Revestimiento alifático monocomponente para membranas",
          "sourceName": "IDP Revestimiento alifático monocomponente para membranas",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-alifatico-monocomponente-para-membranas"
        }
      ],
      "commercialName": "IDP Cubierta reflectante de poliuretano blanco",
      "technicalName": "Sistema técnico de cubierta reflectante de poliuretano blanco",
      "description": "Impermeabilización reflectante blanca de cubierta de hormigón seco mediante primer epoxi al agua independiente, membrana aromática de PU monocomponente al disolvente y protector alifático monocomponente blanco específico. Dotación de protector actualizada expresamente; cuatro anexos completos, incluido primer alternativo.",
      "applications": "El sistema IDP Proof PU COOL ROOF es una opción ideal para la impermeabilización de cubiertas.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Membrana de Poliuretano 1K | IDP Revestimiento alifático monocomponente para membranas | IDP Imprimación Epoxi Universal"
    },
    {
      "id": "idp-proof-pu-water-tank",
      "name": "IDP Impermeabilización de poliuretano bicomponente para depósitos de agua",
      "note": "Siete anexos incluyen alternativas y refuerzo local, no siete capas acumuladas. No es membrana al agua pese a nombre histórico; no diluir con agua ni sustituir por otraPU2 K. Guía antigua 2 kgUNAmano y 3–4 kgUNAmano para servicio severo contradicen máximo 1,50 vigente: selección revisada 2×1, servicio severo requiere reparto y proyecto propio. GC6–8 %de guía no elimina<4 %de membrana ni autoriza presión negativa; epoxi acuosa solo tanque ABIERTO NO POTABLE. Barrera epoxi-cemento de presión negativa sin referencia exacta no activada: selección seca no se prescribe para ese problema. Fuente cita informe sanitario Applus 928/08/6545 en marco histórico; verificar informe íntegro, formulación, configuración y documentación aplicable antes de consumo humano, sin certificado IDP automático o WRAS de otra resina. Curado mínimo 10 días de guía antes de lavado/llenado, además de curado real. Consultar 24 p/anexos.",
      "sheet": "IDP_Impermeabilizacion_de_poliuretano_bicomponente_para_depositos_de_agua.pdf",
      "systemUrl": "/products/idp-proof-pu-water-tank",
      "imageKey": "coating",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación horizontal seca",
          "consumption": 0.5,
          "coats": 1,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.5,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "membrana-liquida-de-poliuretano-al-agua-bicomponente",
          "phase": "Membrana sin disolventes, dos manos",
          "consumption": 1,
          "coats": 2,
          "name": "IDP Membrana de poliuretano bicomponente sin disolventes para depósitos",
          "commercialName": "IDP Membrana de poliuretano bicomponente sin disolventes para depósitos",
          "technicalName": "IDP Membrana de poliuretano bicomponente sin disolventes para depósitos",
          "sourceName": "IDP Membrana de poliuretano bicomponente sin disolventes para depósitos",
          "officialConsumption": 1,
          "packages": [],
          "sheet": "IDP_Membrana_de_poliuretano_bicomponente_sin_disolventes_para_depositos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-al-agua-bicomponente"
        }
      ],
      "commercialName": "IDP Impermeabilización líquida para depósitos de agua potable",
      "technicalName": "Sistema técnico de impermeabilización líquida para depósitos de agua potable",
      "description": "Impermeabilización de depósitos con imprimación epoxi independiente y membrana de poliuretano bicomponente sin disolventes. Selección horizontal seca y variantes vertical/húmeda diferenciadas.",
      "applications": "El sistema es válido para tanques cerrados y abiertos conteniendo agua contra incendios, agua clorada, aguas residuales entre otras.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de poliuretano bicomponente sin disolventes para depósitos | IDP Imprimación Epoxi para Hormigón Húmedo | IDP Imprimación Epoxi Universal Gel | IDP Imprimación Epoxi Base Agua | IDP Espesante en polvo para resinas epoxi y poliuretano | IDP Geotextil de poliéster y poliamida de 80 g por m²"
    },
    {
      "id": "idp-proof-pu-pool",
      "name": "IDP Impermeabilización líquida para piscinas",
      "note": "Configuración inicial ST sobre hormigón seco y acabado expuesto HORIZONTAL: imprimación 0,50 total en 2 × 0,25 + ST 2,00 total en 2 × 1,00 + acabado 0,50 total en 2 × 0,25 = 3,00 kg/m² de resinas; 100 m² y 5 % de merma = 315,00 kg. PAREDES: ST 3 × 0,70 = 2,10 kg/m² según guía detallada, total de resinas 3,10; medir fondo y paredes por separado. Fibra 150 g/m² embebida y saturada en primera mano fresca; medir m² más solapes fuera de kilos de resina. Bajo CERÁMICA: sustituir acabado expuesto por puente ST 0,30 kg/m² sobre membrana curada y cuarzo 0,3–0,8 mm 1–2 kg/m²; adhesivo C2 flexible, azulejo y juntas de proyecto aparte. No sumar cerámica y acabado expuesto. GC 0,50–0,60 es alternativa para humedad residual sin presión; Gel es regularización vertical sobre soporte SECO, no barrera a presión negativa. QC es alternativa con ficha propia: no heredar sus 48 h de repintado a ST. Consultar ficha completa de 27 páginas para detalles, variantes y curados.",
      "sheet": "IDP_Impermeabilizacion_liquida_para_piscinas_1d02889f-ac9b-42da-af3d-e6aa7ad50fd1.pdf",
      "systemUrl": "/products/idp-proof-pu-pool",
      "imageKey": "coating",
      "layers": [
        {
          "phase": "Imprimación epoxi independiente",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana ST horizontal reforzada",
          "productId": "membrana-liquida-de-poliuretano-monocomponente-para-impermeabilizacion-1",
          "name": "Membrana de poliuretano aromático monocomponente semitixotrópica",
          "commercialName": "IDP Membrana de Poliuretano 1K ST",
          "technicalName": "Membrana de poliuretano aromático monocomponente semitixotrópica",
          "sourceName": "IDP Membrana de Poliuretano 1K ST",
          "consumption": 1,
          "officialConsumption": 1,
          "officialLabel": "2,00 kg/m² TOTAL; 2 × 1,00. Fibra 150 en primera mano fresca, medida aparte",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Membrana_de_Poliuretano_1K_ST.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-liquida-de-poliuretano-monocomponente-para-impermeabilizacion-1"
        },
        {
          "phase": "Acabado alifático expuesto",
          "productId": "acabado-de-poliuretano-alifatico-bicomponente-para-piscinas",
          "name": "Acabado alifático bicomponente para piscinas",
          "commercialName": "IDP Acabado Alifático para Piscinas",
          "technicalName": "Acabado alifático bicomponente para piscinas",
          "sourceName": "IDP Acabado Alifático para Piscinas",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Acabado_Alifatico_para_Piscinas.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/acabado-de-poliuretano-alifatico-bicomponente-para-piscinas"
        }
      ],
      "commercialName": "IDP Impermeabilización líquida para piscinas",
      "technicalName": "Sistema técnico de impermeabilización líquida para piscinas",
      "description": "Piscina de hormigón: imprimación epoxi independiente, membrana ST reforzada con fibra 150 y acabado alifático para piscinas. Alternativa bajo cerámica separada.",
      "applications": "El sistema IDP PROOF PU POOL es una opción ideal para impermeabilización de piscinas deportivas, públicas y particulares. Puede utilizarse en piscinas nuevas o en rehabilitación de piscinas con pérdidas de agua.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Membrana de Poliuretano 1K ST | IDP Acabado Alifático para Piscinas | IDP Malla de Fibra de Vidrio | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Imprimación Epoxi para Hormigón Húmedo | IDP Imprimación Epoxi Universal Gel | IDP Membrana de Poliuretano de Secado Rápido | IDP Imprimación Activadora | IDP Aditivo Antideslizante"
    },
    {
      "id": "idp-floor-ep-12-sl",
      "name": "IDP Autonivelante epoxi liso",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-floor-ep-12-sl-es.pdf",
      "systemUrl": "/products/idp-floor-ep-12-sl",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación fillerizada",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Imprimación epoxi bicomponente fillerizada",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,45-0,50 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Capa base autonivelante",
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "name": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "sourceName": "Resina epoxi 100 % sólidos pigmentada",
          "consumption": 0.6,
          "officialConsumption": 0.6,
          "officialLabel": "0,60 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-030.pdf",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        },
        {
          "phase": "Capa de acabado liso",
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "name": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "sourceName": "Resina epoxi 100 % sólidos pigmentada",
          "consumption": 0.6,
          "officialConsumption": 0.6,
          "officialLabel": "0,60 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-030.pdf",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "commercialName": "IDP Autonivelante epoxi liso",
      "technicalName": "Sistema técnico de autonivelante epoxi liso",
      "description": "Sistema epoxi autonivelante liso para pavimentos continuos, compuesto por imprimación, capa autonivelante y terminación según la secuencia técnica documentada.",
      "applications": "Pavimentos industriales, almacenes, zonas logísticas, talleres y áreas sometidas a tráfico ligero o medio.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos"
    },
    {
      "id": "idp-floor-pua-h-sl-30",
      "name": "IDP Pavimento de poliurea proyectada de curado lento con acabado alifático",
      "note": "Referencia de membrana específica 13/10/2026 recuperada: proyección caliente, A poliol/poliamina, no poliurea pura ni frío. Acabado de pavimentos correcto F05-077 identificado, distinto de F05-072 limitado a mantenimiento de cubiertas; no trasladar esa restricción ni proporciones al producto correcto. No certificado sanitario, actividad antibacteriana, fuego o deslizamiento del conjunto sin ensayo. Clase 1/3 de fuente de acabado lleva unidad 1 kg/m³ incoherente: no convertir a kg/m² ni declarar clase por analogía. Aditivo 5–7%solo última mano 0,25; fino máximo 90µm, no 9µm. Tráfico extremo/rodado requiere evaluar variante con árido según fuente; no clase garantizada por aditivo. Treskgopcionalesdecuarzo nootra membrana. Consultar ficha completa 18 p y anexos.",
      "sheet": "IDP_Pavimento_de_poliurea_proyectada_de_curado_lento_con_acabado_alifatico.pdf",
      "systemUrl": "/products/idp-floor-pua-h-sl-30",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente, dos manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-poliurea-proyectada-de-curado-lento-para-pavimentos",
          "phase": "Poliurea de curado lento, proyección caliente",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Poliurea proyectada de curado lento para pavimentos",
          "commercialName": "IDP Poliurea proyectada de curado lento para pavimentos",
          "technicalName": "IDP Poliurea proyectada de curado lento para pavimentos",
          "sourceName": "IDP Poliurea proyectada de curado lento para pavimentos",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Poliurea_proyectada_de_curado_lento_para_pavimentos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-poliurea-proyectada-de-curado-lento-para-pavimentos"
        },
        {
          "productId": "recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante",
          "phase": "Acabado alifático acuoso pigmentado, dos manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Poliuretano Alifático al Agua Brillante",
          "commercialName": "IDP Poliuretano Alifático al Agua Brillante",
          "technicalName": "IDP Poliuretano Alifático al Agua Brillante",
          "sourceName": "IDP Poliuretano Alifático al Agua Brillante",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Poliuretano_Alifatico_al_Agua_Brillante.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante"
        }
      ],
      "commercialName": "IDP Poliurea autonivelante de curado lento",
      "technicalName": "Sistema técnico de poliurea autonivelante de curado lento",
      "description": "Pavimento de poliurea aromática de curado lento relativo, por proyección en caliente sobre imprimación epoxi independiente. Configuración lisa con acabado alifático acuoso brillante pigmentado; áridos y aditivo opcionales separados.",
      "applications": "El sistema IDP Poliurea autonivelante de curado lento es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, grandes superficies, parkings entre otros.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliurea proyectada de curado lento para pavimentos | IDP Poliuretano Alifático al Agua Brillante | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Aditivo Antideslizante"
    },
    {
      "id": "idp-floor-pua-30-park",
      "name": "IDP Pavimento de poliurea para tráfico rodado",
      "note": "Configuración lisa inicial: imprimación 0,50 + membrana 2,00 + puente de poliuretano SOBRE membrana 0,15 + acabado poliaspártico 0,70 = 3,35 kg/m²; 351,75 kg para 100 m² + 5 %. El acabado se reparte en dos manos, no se duplica el total de fase. Anclaje opcional de base: cuarzo 0,3–0,8 mm, 0,50–0,70 kg/m², fuera del cálculo inicial. Variante rugosa: cuarzo sobre primera mano fresca de acabado; su dotación no consta y se debe definir y medir aparte. Espesor nominal 2,5–3 mm, sin convertir kg/m² en mm. El puente F01-005 no es epoxi ni la referencia flexible F01-013. No atribuir al sistema completo clasificaciones de componentes ni clase de deslizamiento sin ensayo. Formato de membrana según suministro, sin deducir un kit predosificado de bidones separados.",
      "sheet": "IDP_Pavimento_de_poliurea_para_trafico_rodado_57c02b27-7bf3-4f5a-9960-feea406d714c.pdf",
      "systemUrl": "/products/idp-floor-pua-30-park",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [
            15
          ],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana proyectada en caliente",
          "productId": "membrana-de-poliurea-proyectada-de-alta-dureza-con-clasificacion-bfl-s1-para-pavimentos",
          "name": "Membrana de poliurea aromática proyectada de alta dureza, referencia FR",
          "commercialName": "IDP Poliurea Proyectada de Alta Dureza Bfl-s1",
          "technicalName": "Membrana de poliurea aromática proyectada de alta dureza, referencia FR",
          "sourceName": "IDP Poliurea Proyectada de Alta Dureza Bfl-s1",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2,00 kg/m²; una proyección con control de espesor",
          "coats": 1,
          "packages": [
            "A granel"
          ],
          "sheet": "IDP_Poliurea_Proyectada_de_Alta_Dureza_Bfl-s1_769904b6-379b-4bfa-9f06-76a9f3ca9e59.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliurea-proyectada-de-alta-dureza-con-clasificacion-bfl-s1-para-pavimentos"
        },
        {
          "phase": "Puente de unión SOBRE membrana",
          "productId": "imprimacion-de-poliuretano",
          "name": "Imprimación de poliuretano aromático monocomponente al disolvente",
          "commercialName": "IDP Imprimación de Poliuretano",
          "technicalName": "Imprimación de poliuretano aromático monocomponente al disolvente",
          "sourceName": "IDP Imprimación de Poliuretano",
          "consumption": 0.15,
          "officialConsumption": 0.15,
          "officialLabel": "0,15 kg/m²; una mano",
          "coats": 1,
          "packages": [
            20,
            4
          ],
          "sheet": "IDP_Imprimacion_de_Poliuretano.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-de-poliuretano"
        },
        {
          "phase": "Acabado poliaspártico pigmentado",
          "productId": "recubrimiento-poliaspartico-de-aplicacion-manual",
          "name": "Recubrimiento poliaspártico alifático bicomponente pigmentado de baja viscosidad",
          "commercialName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "technicalName": "Recubrimiento poliaspártico alifático bicomponente pigmentado de baja viscosidad",
          "sourceName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "consumption": 0.35,
          "officialConsumption": 0.35,
          "officialLabel": "0,70 kg/m² TOTAL; dos manos de 0,35",
          "coats": 2,
          "packages": [
            15
          ],
          "sheet": "IDP_Recubrimiento_Poliaspartico_de_Baja_Viscosidad_a3c74655-30bb-476f-ae3c-c7c4947ecf67.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliaspartico-de-aplicacion-manual"
        }
      ],
      "commercialName": "IDP Pavimento de poliurea para tráfico rodado",
      "technicalName": "Sistema técnico de pavimento de poliurea para tráfico rodado",
      "description": "Sistema a base de resinas de poliurea aromática bicomponente, con recubrimiento de poliuretano alifático base agua o poliaspártico bicomponente 100% sólidos con acabado liso o antideslizante.",
      "applications": "El sistema IDP Pavimento de poliurea para tráfico rodado es una opción ideal para cubrir pavimentos en interior o exterior ya que proporciona una resistencia a la abrasión y al desgaste. Se recomienda su aplicación en parkings, almacenes, fabricas, centros comerciales entre otros.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliurea Proyectada de Alta Dureza Bfl-s1 | IDP Imprimación de Poliuretano | IDP Recubrimiento Poliaspártico de Baja Viscosidad | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Imprimación Epoxi para Hormigón Húmedo"
    },
    {
      "id": "idp-floor-pua-h-30-park",
      "name": "IDP Pavimento de poliurea con acabado poliaspártico",
      "note": "Configuración lisa inicial: imprimación 0,50 + membrana 2,00 + puente de poliuretano SOBRE membrana 0,15 + acabado poliaspártico 0,50 = 3,15 kg/m²; 330,75 kg para 100 m² + 5 %. El acabado se reparte en dos manos, no se duplica el total de fase. Anclaje opcional de base: cuarzo 0,3–0,8 mm, 0,50–0,70 kg/m², fuera del cálculo inicial. Variante rugosa: cuarzo sobre primera mano fresca de acabado; su dotación no consta y se debe definir y medir aparte. Espesor nominal 2,8–3 mm, sin convertir kg/m² en mm. El puente F01-005 no es epoxi ni la referencia flexible F01-013. No atribuir al sistema completo clasificaciones de componentes ni clase de deslizamiento sin ensayo. Formato de membrana según suministro, sin deducir un kit predosificado de bidones separados.",
      "sheet": "IDP_Pavimento_de_poliurea_con_acabado_poliaspartico_a7d7f0f1-33d9-4b93-a84e-bd2ccfb0b585.pdf",
      "systemUrl": "/products/idp-floor-pua-h-30-park",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente 100 % sólidos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [
            15
          ],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Membrana proyectada en caliente",
          "productId": "membrana-de-poliurea-proyectada-flexible-con-clasificacion-bfl-s1-para-pavimentos",
          "name": "Membrana de poliurea híbrida flexible proyectada en caliente",
          "commercialName": "IDP Poliurea Proyectada Flexible Bfl-s1",
          "technicalName": "Membrana de poliurea híbrida flexible proyectada en caliente",
          "sourceName": "IDP Poliurea Proyectada Flexible Bfl-s1",
          "consumption": 2,
          "officialConsumption": 2,
          "officialLabel": "2,00 kg/m²; una proyección con control de espesor",
          "coats": 1,
          "packages": [
            "A granel"
          ],
          "sheet": "IDP_Poliurea_Proyectada_Flexible_Bfl-s1_227a4430-cc29-4feb-af97-eabda0ec4bcf.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/membrana-de-poliurea-proyectada-flexible-con-clasificacion-bfl-s1-para-pavimentos"
        },
        {
          "phase": "Puente de unión SOBRE membrana",
          "productId": "imprimacion-de-poliuretano",
          "name": "Imprimación de poliuretano aromático monocomponente al disolvente",
          "commercialName": "IDP Imprimación de Poliuretano",
          "technicalName": "Imprimación de poliuretano aromático monocomponente al disolvente",
          "sourceName": "IDP Imprimación de Poliuretano",
          "consumption": 0.15,
          "officialConsumption": 0.15,
          "officialLabel": "0,15 kg/m²; una mano",
          "coats": 1,
          "packages": [
            20,
            4
          ],
          "sheet": "IDP_Imprimacion_de_Poliuretano.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-de-poliuretano"
        },
        {
          "phase": "Acabado poliaspártico pigmentado",
          "productId": "recubrimiento-poliaspartico-de-aplicacion-manual",
          "name": "Recubrimiento poliaspártico alifático bicomponente pigmentado de baja viscosidad",
          "commercialName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "technicalName": "Recubrimiento poliaspártico alifático bicomponente pigmentado de baja viscosidad",
          "sourceName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,40–0,70 kg/m² TOTAL en dos manos; cálculo 2 × 0,25",
          "coats": 2,
          "packages": [
            15
          ],
          "sheet": "IDP_Recubrimiento_Poliaspartico_de_Baja_Viscosidad_a3c74655-30bb-476f-ae3c-c7c4947ecf67.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliaspartico-de-aplicacion-manual"
        }
      ],
      "commercialName": "IDP Pavimento de poliurea con acabado poliaspártico",
      "technicalName": "Sistema técnico de pavimento de poliurea con acabado poliaspártico",
      "description": "Sistema a base de resinas de poliurea aromática bicomponente, con recubrimiento poliaspártico bicomponente 100% sólidos sobre un alifático pigmentado con acabado liso o antideslizante.",
      "applications": "El sistema IDP Floor PUA H 30 PARK es una opción ideal para cubrir estacionamientos interiores, pisos, rampas y accesos.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliurea Proyectada Flexible Bfl-s1 | IDP Imprimación de Poliuretano | IDP Recubrimiento Poliaspártico de Baja Viscosidad | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-floor-pu-10",
      "name": "IDP Poliuretano alifático monocomponente pigmentado",
      "note": "Configuración inicial LISA sin diluir: imprimación 2 × 0,20 = 0,40 kg/m² y acabado F02-032 2 × 0,25 = 0,50; total 0,90 kg/m². Para 100 m² + 5 % de merma, 94,50 kg. Árido opcional 0,3–0,8 mm en primera mano de acabado: dotación no cuantificada en origen, definir y ensayar antes de medir o ejecutar. Sin espesor nominal documentado y sin conversión kg/m² a mm. Soporte 15–30 °C, HR máxima 80 %. No atribuir clase 3 o Bfl-s1 al conjunto sin ensayo aplicable.",
      "sheet": "IDP_Poliuretano_alifatico_monocomponente_pigmentado_946cae0e-bdb5-4691-b673-277f5cb1c471.pdf",
      "systemUrl": "/products/idp-floor-pu-10",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.2,
          "officialConsumption": 0.2,
          "officialLabel": "0,30–0,50 kg/m² TOTAL; cálculo 2 × 0,20 = 0,40",
          "coats": 2,
          "packages": [
            15
          ],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Acabado alifático pigmentado",
          "productId": "revestimiento-monocomponente-para-pavimentos",
          "name": "Revestimiento monocomponente de poliuretano alifático al disolvente para pavimentos",
          "commercialName": "IDP Revestimiento Monocomponente para Pavimentos",
          "technicalName": "Revestimiento monocomponente de poliuretano alifático al disolvente para pavimentos",
          "sourceName": "IDP Revestimiento Monocomponente para Pavimentos",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50–0,60 kg/m² TOTAL; dos manos de 0,25–0,30",
          "coats": 2,
          "packages": [
            25
          ],
          "sheet": "IDP_Revestimiento_Monocomponente_para_Pavimentos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/revestimiento-monocomponente-para-pavimentos"
        }
      ],
      "commercialName": "IDP Poliuretano alifático monocomponente pigmentado",
      "technicalName": "Sistema técnico de poliuretano alifático monocomponente pigmentado",
      "description": "Sistema a base de poliuretano al disolvente monocomponente, alifático, pigmentado, para la protección de suelos de hormigón.",
      "applications": "El sistema IDP Poliuretano alifático monocomponente pigmentado es una opción ideal para revestir pavimentos de hormigón en general, garajes y aparcamientos con tráfico intenso.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Revestimiento Monocomponente para Pavimentos | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-floor-pu-10-w",
      "name": "IDP Revestimiento de poliuretano alifático al agua para pavimentos",
      "note": "La ficha completa y los anexos distinguen F05-077 brillante de F05-072 de cubiertas y de acabado antibacteriano. No trasladar restricciones o proporciones entre ellos. Selección lisa gris medio/oscuro: no clase 3, árido 0,1–0,5 sin dosis, mate≤0,15 sin ficha específica o GC para soporte húmedo habilitados por analogía. Colores claros mínimo tres manos de resumen 0,15–0,20 frente recomendación vigente 0,25/capa: contrastar antes de fijar configuración clara, no usar dos manos como suficiente. Producto de acabado contiene incidencias de unidad 1 kg/m³ y dilución 10/15 %, conservadas sin convertir a receta. No sistema 100 %sólidos, certificado sanitario, agua potable, química por inmersión o deslizamiento del conjunto. Consultar las diez páginas y los dos anexos íntegros.",
      "sheet": "IDP_Revestimiento_de_poliuretano_alifatico_al_agua_para_pavimentos.pdf",
      "systemUrl": "/products/idp-floor-pu-10-w",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "phase": "Imprimación base agua independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "productId": "recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante",
          "phase": "PU alifático acuoso brillante pigmentado",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Poliuretano Alifático al Agua Brillante",
          "commercialName": "IDP Poliuretano Alifático al Agua Brillante",
          "technicalName": "IDP Poliuretano Alifático al Agua Brillante",
          "sourceName": "IDP Poliuretano Alifático al Agua Brillante",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Poliuretano_Alifatico_al_Agua_Brillante.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante"
        }
      ],
      "commercialName": "IDP Poliuretano al agua liso o antideslizante",
      "technicalName": "Sistema técnico de poliuretano al agua liso o antideslizante",
      "description": "Revestimiento fino de poliuretano alifático bicomponente acuoso brillante pigmentado sobre imprimación epoxi base agua independiente. Selección lisa gris medio/oscuro, con datos técnicos completos de ambos productos y sus condiciones comunes.",
      "applications": "El sistema IDP Poliuretano al agua liso o antideslizante es una opción ideal para revestir pavimentos de hormigón en general, garajes y aparcamientos con tráfico intenso.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Poliuretano Alifático al Agua Brillante"
    },
    {
      "id": "idp-floor-pu-20",
      "name": "IDP Multicapa rugoso de poliuretano aromático para pavimentos",
      "note": "Selección de matriz 2,00 kg/m² TOTALPU+fino, relación 1:0,3 con reparto por MASA adoptado y explicitado: resina 2/1,3=1,538462, fino 2×0,3/1,3=0,461538; original no imprime palabra masa, comprobar procedimiento/suministro y registrar base antes de dosificar. No 2 kgde cada ingrediente ni 1:0,5 de rampa. Espolvoreo 3 kg/m² NATURAL 0,3–0,8 en PU FRESCO, no árido del acabado deotra impermeabilización. Sellado acuoso F05-077 corregido 0,40→0,50 dos 0,25 según ficha actual 30/07/2026 y paño de cubrición/fricción. Sin clase 3 por grano/masa; anexo del acabado imprime«1 kg/m³ »con 0,4–0,9, no se convierte o equipara. HR<60 %/soporte 15–25 prevalecen sobre 85 %/30°Cde guía;<4 % soporte, no 8 % posteriorcruzado. A: Bpropios deprimer/PU/acuoso distintos. Alternativa F02-032 monocomponente al DISOLVENTE distinta de F05-074 y de F05-072 de cubiertas, no acumulada. Anclajeprimer sin masa no activado; aditivo FINO 5–7 % solo última 0,25=0,0125–0,0175 extra, no incluido. Total 6,00/630 kg 100 m²+5 %. Masa 100 % sólidosno convierte acuoso/conjunto en 100 % sólidos. No garantía estructural, fisurauniversal, clasefuego, potable, antibacteriano o SRI grisporanalogía.",
      "sheet": "IDP_Multicapa_rugoso_de_poliuretano_aromatico_para_pavimentos.pdf",
      "systemUrl": "/products/idp-floor-pu-20",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-resina-autonivelante-de-poliuretano-65-shore-d",
          "phase": "Parte de RESINA A+B de mezcla PU+fino2,00TOTAL1:0,3 por masa",
          "consumption": 1.5384615384615383,
          "coats": 1,
          "name": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "commercialName": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "technicalName": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "sourceName": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "officialConsumption": 1.5384615384615383,
          "packages": [],
          "sheet": "IDP_Resina_autonivelante_de_poliuretano_65_Shore_D.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-resina-autonivelante-de-poliuretano-65-shore-d"
        },
        {
          "productId": "idp-arido-de-cuarzo-0-1-0-3-mm",
          "phase": "Carga fina incorporada;completa mezcla2,00TOTAL,no otra resina",
          "consumption": 0.4615384615384615,
          "coats": 1,
          "name": "IDP Árido de cuarzo 0,1–0,3 mm",
          "commercialName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "technicalName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "sourceName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "officialConsumption": 0.4615384615384615,
          "packages": [],
          "sheet": "IDP_Arido_de_cuarzo_0_1_0_3_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-0-1-0-3-mm"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Espolvoreo sobre PU FRESCO,no carga fina incorporada",
          "consumption": 3,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 3,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "productId": "recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante",
          "phase": "Sellado alifático acuoso PIGMENTADO",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Poliuretano Alifático al Agua Brillante",
          "commercialName": "IDP Poliuretano Alifático al Agua Brillante",
          "technicalName": "IDP Poliuretano Alifático al Agua Brillante",
          "sourceName": "IDP Poliuretano Alifático al Agua Brillante",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Poliuretano_Alifatico_al_Agua_Brillante.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante"
        }
      ],
      "commercialName": "IDP Poliuretano rugoso 100 % sólidos",
      "technicalName": "Sistema técnico de poliuretano rugoso 100 % sólidos",
      "description": "Multicapa rugoso de poliuretano aromático 65 Shore D sobre imprimación epoxi independiente, con carga fina incorporada y cuarzo natural grueso espolvoreado en fresco. Selección con acabado alifático acuoso pigmentado, dos manos; ficha completa 24 p/siete anexos.",
      "applications": "El sistema IDP Poliuretano rugoso 100 % sólidos es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, talleres, que soliciten un acabado rugoso y con mayor tolerancia a movimientos y suras que los sistemas epoxy convencionales.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Resina autonivelante de poliuretano 65 Shore D | IDP Árido de cuarzo 0,1–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Poliuretano Alifático al Agua Brillante | IDP Revestimiento Monocomponente para Pavimentos | IDP Aditivo Antideslizante"
    },
    {
      "id": "idp-floor-pu-20-r",
      "name": "IDP Poliuretano rugoso para hormigón",
      "note": "Configuración seleccionada de rampa: imprimación epoxi 0,50 kg/m² TOTAL (2 × 0,25), anclaje grueso 0,50, principal 2,00 TOTAL de mezcla resina:cuarzo fino 1:0,5 (dos manos de 1,00), espolvoreo grueso 4,00 y acabado alifático 1K PIGMENTADO F02-032 0,70 TOTAL (2 × 0,35). Total 7,70 kg/m²; 100 m² + 5 % = 808,50 kg. La fuente imprime 0,40 de imprimación y dos manos de 0,25: se documenta la discrepancia y se selecciona 0,50, sin multiplicarlo de nuevo por dos. Principal: resina 1,333333 y cuarzo fino 0,666667 kg/m²; no 2 kg de cada producto. No usar F02-028 como equivalencia automática del ligante, ni F05-077/F05-074 como acabado. Sin dilución inicial, espesor ni clase3 inventados.",
      "sheet": "IDP_Poliuretano_rugoso_para_hormigon_d7d34c7c-53b3-4c40-ba87-a338fb2c78ca.pdf",
      "systemUrl": "/products/idp-floor-pu-20-r",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "idp-epoxy-100",
          "consumption": 0.25,
          "coats": 2,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Anclaje sobre imprimación",
          "productId": "arido-de-cuarzo-idp",
          "consumption": 0.5,
          "coats": 1,
          "officialLabel": "0,50 kg/m²; no confundir con espolvoreo principal",
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 0.5,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Principal: resina PU 65D",
          "productId": "idp-resina-autonivelante-de-poliuretano-65-shore-d",
          "consumption": 0.6666666666666666,
          "coats": 2,
          "officialLabel": "1,333333 kg/m² TOTAL de resina A+B; dos manos de mezcla1,00",
          "name": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "commercialName": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "technicalName": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "sourceName": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "officialConsumption": 0.6666666666666666,
          "packages": [],
          "sheet": "IDP_Resina_autonivelante_de_poliuretano_65_Shore_D.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-resina-autonivelante-de-poliuretano-65-shore-d"
        },
        {
          "phase": "Principal: carga fina0,1–0,3mm",
          "productId": "idp-arido-de-cuarzo-0-1-0-3-mm",
          "consumption": 0.3333333333333333,
          "coats": 2,
          "officialLabel": "0,666667 kg/m² TOTAL de cuarzo; mezcla total2,00 a1:0,5",
          "name": "IDP Árido de cuarzo 0,1–0,3 mm",
          "commercialName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "technicalName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "sourceName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "officialConsumption": 0.3333333333333333,
          "packages": [],
          "sheet": "IDP_Arido_de_cuarzo_0_1_0_3_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-0-1-0-3-mm"
        },
        {
          "phase": "Espolvoreo principal fresco",
          "productId": "arido-de-cuarzo-idp",
          "consumption": 4,
          "coats": 1,
          "officialLabel": "4,00 kg/m²; retirar exceso tras curado",
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 4,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Sellado alifático1K pigmentado",
          "productId": "revestimiento-monocomponente-para-pavimentos",
          "consumption": 0.35,
          "coats": 2,
          "officialLabel": "0,70 kg/m² TOTAL;2×0,35",
          "name": "IDP Revestimiento Monocomponente para Pavimentos",
          "commercialName": "IDP Revestimiento Monocomponente para Pavimentos",
          "technicalName": "IDP Revestimiento Monocomponente para Pavimentos",
          "sourceName": "IDP Revestimiento Monocomponente para Pavimentos",
          "officialConsumption": 0.35,
          "packages": [],
          "sheet": "IDP_Revestimiento_Monocomponente_para_Pavimentos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/revestimiento-monocomponente-para-pavimentos"
        }
      ],
      "commercialName": "IDP Poliuretano rugoso para hormigón",
      "technicalName": "Sistema técnico de poliuretano rugoso para hormigón",
      "description": "Sistema rugoso de poliuretano para rampas de hormigón con imprimación epoxi independiente, carga fina, espolvoreo grueso y acabado alifático1K pigmentado.",
      "applications": "IDP Poliuretano rugoso para hormigón es una opción ideal para el recubrimiento de pavimentos en rampas de parkings comerciales, industriales y residenciales.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Resina autonivelante de poliuretano 65 Shore D | IDP Árido de cuarzo 0,1–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Revestimiento Monocomponente para Pavimentos"
    },
    {
      "id": "idp-floor-pu-30",
      "name": "IDP Autonivelante de poliuretano aromático para pavimentos",
      "note": "Prescripción 30/10/2025 y masa exacta 20/05/2026 de 65 Shore D,36 %elongación,8,3 MPa, no ligante flexible 85 Shore A ni F02-028 de otra formulación. Fuente imprime densidad B0,20 g/cm³ incoherente: conservar sin cambiar a 1,20 ni calcular espesor/mezcla. Relaciones expresas 100:19 peso/100:24 volumen; envases nominales no las sustituyen. Primer 0,50+masa 3,00+F05-0770,50=4,00. Tecnocem alternativo 2,00+epoxi 0,50 tras 48–72 h requiere procedimiento y referencia exactos, no mortero epoxi-cemento genérico acumulado. Masa SIN carga añadida, no mezcla de rampas. Sin disolvente en masa no significa conjunto 100 %sólidos con acabado acuoso. Clase 3 de otro árido con 1 kg/m³ y dilución 10/15 %del acabado conservadas sin conversión o receta inventada. Fuego Bfl-s 1 de masa, CE/Applus 09/32301291 y AITEX EN13501-1:2018 requieren informe/suministro/configuración, no certificado conjunto. No 39 %biocarbono de otra formulación, sanitario, antibacteriano, agua potable, norma deportiva o carga universal por usos. Aditivo fino 90µm, no 9, soloúltima 0,25. Consultar 17 páginas y cinco anexos completos.",
      "sheet": "IDP_Autonivelante_de_poliuretano_aromatico_para_pavimentos.pdf",
      "systemUrl": "/products/idp-floor-pu-30",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-resina-autonivelante-de-poliuretano-65-shore-d",
          "phase": "Masa PU autonivelante aromático 65 Shore D",
          "consumption": 3,
          "coats": 1,
          "name": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "commercialName": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "technicalName": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "sourceName": "IDP Resina autonivelante de poliuretano 65 Shore D",
          "officialConsumption": 3,
          "packages": [],
          "sheet": "IDP_Resina_autonivelante_de_poliuretano_65_Shore_D.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-resina-autonivelante-de-poliuretano-65-shore-d"
        },
        {
          "productId": "recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante",
          "phase": "Acabado PU alifático acuoso brillante pigmentado",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Poliuretano Alifático al Agua Brillante",
          "commercialName": "IDP Poliuretano Alifático al Agua Brillante",
          "technicalName": "IDP Poliuretano Alifático al Agua Brillante",
          "sourceName": "IDP Poliuretano Alifático al Agua Brillante",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Poliuretano_Alifatico_al_Agua_Brillante.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante"
        }
      ],
      "commercialName": "IDP Poliuretano pigmentado 100 % sólidos",
      "technicalName": "Sistema técnico de poliuretano pigmentado 100 % sólidos",
      "description": "Pavimento autonivelante de poliuretano aromático bicomponente de 65 Shore D sobre imprimación epoxi independiente, con acabado alifático acuoso brillante pigmentado. Selección lisa sin carga añadida; anclaje y aditivo opcionales separados.",
      "applications": "El sistema IDP Poliuretano pigmentado 100 % sólidos es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, tiendas o fábricas.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Resina autonivelante de poliuretano 65 Shore D | IDP Poliuretano Alifático al Agua Brillante | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Aditivo Antideslizante"
    },
    {
      "id": "idp-floor-pu-30-comfort",
      "name": "IDP Poliuretano liso con lámina de caucho",
      "note": "Selección LISA del resumen 22/10/2025 con primer 0,30; guía propia prescribe 0,50 en 0,20+0,30 y cuarzo 0,3–0,8 sin cantidad: variante distinta no activada ni dosificada por analogía. CauchoPlus 4 mm contemplado técnicamente; confirmar formato comercial y disponibilidad antes de suministro; no stock inventado. La lámina se mide en m², separada del subtotal 5,068 kg/m², y no se convierte por densidad. Cierre 0,90 y adhesivo 0,35 son selecciones dentro de intervalos oficiales, no rendimientos garantizados. Antislip 5–7%última mano es alternativa no activada en LISO, requiere referencia y clase exactas; no copiar 10%airless. Fuentes de todos los materiales completas anexadas. Sin atribución automática de dB, altura de caída, EN14904, Bfl-s 1 o prestaciones sanitarias del conjunto. Conservar y verificar lotes, suministro, despiece, proporciones, curado, espesores y aceptación.",
      "sheet": "IDP_Poliuretano_liso_con_lamina_de_caucho_72ef945d-b3f3-4124-a7b5-5f22c3bda7c6.pdf",
      "systemUrl": "/products/idp-floor-pu-30-comfort",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.3,
          "coats": 1,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.3,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-adhesivo-de-poliuretano-bicomponente-de-curado-rapido",
          "phase": "Adhesivo de la lámina",
          "consumption": 0.35,
          "coats": 1,
          "name": "IDP Adhesivo de poliuretano bicomponente de curado rápido",
          "commercialName": "IDP Adhesivo de poliuretano bicomponente de curado rápido",
          "technicalName": "IDP Adhesivo de poliuretano bicomponente de curado rápido",
          "sourceName": "IDP Adhesivo de poliuretano bicomponente de curado rápido",
          "officialConsumption": 0.35,
          "packages": [],
          "sheet": "IDP_Adhesivo_de_poliuretano_bicomponente_de_curado_rapido.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-adhesivo-de-poliuretano-bicomponente-de-curado-rapido"
        },
        {
          "productId": "resina-autonivelante-flexible-de-poliuretano",
          "phase": "Cierre de poros del caucho",
          "consumption": 0.9,
          "coats": 1,
          "name": "IDP Poliuretano Autonivelante Flexible",
          "commercialName": "IDP Poliuretano Autonivelante Flexible",
          "technicalName": "IDP Poliuretano Autonivelante Flexible",
          "sourceName": "IDP Poliuretano Autonivelante Flexible",
          "officialConsumption": 0.9,
          "packages": [],
          "sheet": "IDP_Poliuretano_Autonivelante_Flexible_0dfc4091-3ac0-4552-9a37-d68b7d2d6450.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-autonivelante-flexible-de-poliuretano"
        },
        {
          "productId": "idp-espesante-en-polvo-para-resinas-epoxi-y-poliuretano",
          "phase": "Espesante integrado en cierre, 2 %",
          "consumption": 0.018,
          "coats": 1,
          "name": "IDP Espesante en polvo para resinas epoxi y poliuretano",
          "commercialName": "IDP Espesante en polvo para resinas epoxi y poliuretano",
          "technicalName": "IDP Espesante en polvo para resinas epoxi y poliuretano",
          "sourceName": "IDP Espesante en polvo para resinas epoxi y poliuretano",
          "officialConsumption": 0.018,
          "packages": [],
          "sheet": "IDP_Espesante_en_polvo_para_resinas_epoxi_y_poliuretano.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-espesante-en-polvo-para-resinas-epoxi-y-poliuretano"
        },
        {
          "productId": "resina-autonivelante-flexible-de-poliuretano",
          "phase": "Masa autonivelante flexible",
          "consumption": 3,
          "coats": 1,
          "name": "IDP Poliuretano Autonivelante Flexible",
          "commercialName": "IDP Poliuretano Autonivelante Flexible",
          "technicalName": "IDP Poliuretano Autonivelante Flexible",
          "sourceName": "IDP Poliuretano Autonivelante Flexible",
          "officialConsumption": 3,
          "packages": [],
          "sheet": "IDP_Poliuretano_Autonivelante_Flexible_0dfc4091-3ac0-4552-9a37-d68b7d2d6450.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-autonivelante-flexible-de-poliuretano"
        },
        {
          "productId": "recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante",
          "phase": "Acabado brillante pigmentado, dos manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Poliuretano Alifático al Agua Brillante",
          "commercialName": "IDP Poliuretano Alifático al Agua Brillante",
          "technicalName": "IDP Poliuretano Alifático al Agua Brillante",
          "sourceName": "IDP Poliuretano Alifático al Agua Brillante",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Poliuretano_Alifatico_al_Agua_Brillante.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante"
        }
      ],
      "commercialName": "IDP Poliuretano liso con lámina de caucho",
      "technicalName": "Sistema técnico de poliuretano liso con lámina de caucho",
      "description": "Pavimento liso de poliuretano flexible sobre lámina de caucho SBR Plus adherida, cierre de poros con espesante en polvo y acabado alifático al agua brillante pigmentado. Ficha completa con seis anexos; medición de caucho por superficie, separada de las resinas.",
      "applications": "El sistema IDP Poliuretano pigmentado 100 % sólidos COMFORT es una opción ideal para el recubrimiento de pavimentos en zonas tipo guarderías, salas deportivas, colegios.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Adhesivo de poliuretano bicomponente de curado rápido | IDP Lámina amortiguante de caucho reciclado para pavimentos de confort | IDP Poliuretano Autonivelante Flexible | IDP Espesante en polvo para resinas epoxi y poliuretano | IDP Poliuretano Alifático al Agua Brillante",
      "prescription": {
        "status": "Configuración de proyecto basada en la secuencia documentada; la lámina de caucho y su adhesivo son capas constitutivas del sistema.",
        "summary": "Sistema ≈6 mm · lámina 4 mm",
        "object": "Suministro y ejecución del sistema IDP Floor PU 30 Comfort, pavimento decorativo continuo de poliuretano de 6 mm de espesor total aproximado, ejecutado sobre base previa endurecida mediante imprimación epoxi, adhesivo reactivo, lámina amortiguante de caucho de 4 mm, sellado de la lámina, capa autonivelante flexible de poliuretano y acabado alifático bicomponente en base agua.",
        "substrate": "Aplicación sobre base previa endurecida, resistente, cohesiva, limpia y apta para superficies decorativas en locales públicos. Incluir limpieza y desbastado fino para abrir el poro; la humedad, temperatura, punto de rocío y reparaciones se ajustarán a las fichas vigentes y a las condiciones reales de obra.",
        "thickness": "Configuración de proyecto: 6 mm de espesor total aproximado, incluida una lámina IDP Lámina Amortiguante de Caucho de 4 mm; comprobar el espesor final mediante muestra y control de ejecución.",
        "finish": "Capa autonivelante pigmentada en color RAL a elegir por la Dirección Facultativa dentro del Grupo 1, protegida con acabado alifático bicomponente en base agua.",
        "totalConsumption": "5,05 kg/m² de productos líquidos orientativos, más 1 m²/m² de lámina de caucho de 4 mm y un 1-2 % de espesante sobre la resina de sellado",
        "closing": "Ejecutar cada operación tras comprobar el curado y la aptitud de la anterior. La lámina debe quedar adherida de forma continua, sin bolsas, pliegues ni juntas abiertas, y sellada antes de aplicar la capa autonivelante. Incluir limpieza, replanteo, encuentros y limpieza final.",
        "limitations": "Los consumos y el espesor final deberán validarse en obra. La ficha de IDP Lámina Amortiguante de Caucho y la de la resina autonivelante flexible permanecen bajo control documental hasta completar la fuente exacta; no atribuir prestaciones acústicas, de impacto, reacción al fuego, resbaladicidad o VOC al sistema completo sin documentación aplicable a esta configuración."
      },
      "surfaceMaterials": [
        {
          "phase": "Lámina amortiguante, medición independiente",
          "name": "IDP Lámina de caucho SBR Plus, 4 mm",
          "consumptionM2": 1,
          "sheet": "https://cdn.shopify.com/s/files/1/1061/8748/9621/files/IDP_Lamina_amortiguante_de_caucho_reciclado_para_pavimentos_de_confort.pdf?v=1793611760",
          "productUrl": "https://idpproductos.com/products/lamina-amortiguante-de-caucho-reciclado-para-pavimentos-de-confort"
        }
      ]
    },
    {
      "id": "idp-floor-pu-40-eco",
      "name": "IDP Poliuretano renovable con árido local",
      "note": "REVISIÓN TÉCNICA ABIERTA. El ligante exacto es la versión 2K de origen biológico; no se sustituye por la variante alifática UV. La fuente combina 6 % sobre 45 kg de árido local 6/12 con 2,50 kg de resina; faltan dosificación y compatibilidad acreditadas de esa granulometría, que no figura en la tabla 2–6/6–8 de la ficha actual. También debe identificarse el espolvoreo local 0–12: no equivale a cuarzo 0,3–0,8. Los campos a cero indican medición por completar, no ausencia de material. No emitir cantidades totales hasta completar la receta.",
      "sheet": "ficha-sistema-idp-floor-pu-40-eco-es.pdf",
      "systemUrl": "/products/idp-floor-pu-40-eco",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Ligante 2K: COMPLETAR dosificación validada para árido local 6/12",
          "productId": "ligante-de-poliuretano-bicomponente-de-origen-parcialmente-biologico-para-pavimentos-de-arido",
          "name": "IDP Ligante de Poliuretano 2K de Origen Biológico",
          "sourceName": "IDP Ligante de Poliuretano 2K de Origen Biológico",
          "consumption": 0,
          "officialConsumption": 0,
          "officialLabel": "PENDIENTE: fuente 6% sobre 45 kg frente 2,50 kg; no convertir a una receta confirmada",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Ligante_de_Poliuretano_2K_de_Origen_Biologico.pdf",
          "commercialName": "IDP Ligante de Poliuretano 2K de Origen Biológico",
          "technicalName": "IDP Ligante de Poliuretano 2K de Origen Biológico",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/ligante-de-poliuretano-bicomponente-de-origen-parcialmente-biologico-para-pavimentos-de-arido"
        },
        {
          "phase": "Capa Base",
          "productId": "",
          "name": "Triturado de cantera / Sustrato de grava local",
          "sourceName": "Triturado de cantera / Sustrato de grava local",
          "consumption": 45,
          "officialConsumption": 45,
          "officialLabel": "45 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "",
          "commercialName": "",
          "technicalName": "",
          "documentStatus": "",
          "productUrl": ""
        },
        {
          "phase": "Espolvoreo local 0–12: COMPLETAR referencia y dotación acreditadas",
          "productId": "",
          "name": "Árido local 0–12 de proyecto",
          "sourceName": "Espolvoreo de áridos lavados",
          "consumption": 0,
          "officialConsumption": 0,
          "officialLabel": "PENDIENTE: no sustituir por cuarzo 0,3–0,8",
          "coats": 1,
          "packages": [],
          "sheet": "",
          "commercialName": "Árido local 0–12 de proyecto",
          "technicalName": "Árido local 0–12 de proyecto",
          "documentStatus": "pendiente",
          "productUrl": ""
        }
      ],
      "commercialName": "IDP Poliuretano renovable con árido local",
      "technicalName": "Sistema técnico de poliuretano renovable con árido local",
      "description": "Sistema bi componente, aromático 100% sólidos a base de resinas de poliuretano provenientes de fuentes renovables, para la protección de superficies y senderos con agregado local triturado.",
      "applications": "El Sistema Floor PU 40 ECO es una opción ideal la protección de sustratos en proyectos de renaturalización de espacios urbanos y senderos de montaña con tránsito peatonal, rutas de ciclismo BTT y secciones de tránsito vehicular en zonas montañosas que suelen requerir mantenimiento continuo.",
      "keywords": "IDP Ligante de Poliuretano Alifático 2K UV | Ligante de poliuretano alifático bicomponente resistente a UV para pavimentos de árido | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos"
    },
    {
      "id": "idp-floor-pu-40-safety",
      "name": "IDP Pavimento continuo de caucho SBR y EPDM aglomerado con poliuretano",
      "note": "El resumen 04/11/2025 dice 21% sobre 7,20 kg EPDM y también 1,80 kg de ligante, equivalente 25%. Se selecciona 21% respaldado además por la ficha EXACTA del aglomerante alifático 19/08/2024(18–21 partes/100 EPDM), derivando 1,512 kg/m² por 7,20×0,21: es cálculo IDP explícito, no cifra impresa por fabricante. La mezcla 8,712 está dentro 8–10 kg/m² por 10 mmde esa ficha. El ejemplo genérico de granulado 1,80+7,20 no identifica formulación y no sustituye la receta de la resina específica;25% queda excluido, no fusionado. Base 3,12+20,88=24 kg y 14,94% sobre SBR dentro 12–15 del ligante. M4(2–7) está en intervalo 1–7 del aglomerante; no afirmar fracción 1 mm ni curva idéntica a M8. EPDM1–4(90%) frente catálogo 1–3,5: confirmar lote/curva sin inventar fracción. Espesor 40 mm nominal, comprobar paño y obra, no garantía por kilos. No altura crítica de caída, certificación deportiva, acústica, fuego o de cualquier parque infantil sin ensayo exacto de configuración. Primer 69% sólidos al disolvente: el conjunto no se declara 100% sólidos ni exento de disolventes. Cinco anexos completos; no equivalencia con ligante mineral ni versión aromática lenta.",
      "sheet": "IDP_Pavimento_continuo_de_caucho_SBR_y_EPDM_aglomerado_con_poliuretano.pdf",
      "systemUrl": "/products/idp-floor-pu-40-safety",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "imprimacion-flexible-para-sistemas-de-poliuretano",
          "phase": "Imprimación flexible independiente",
          "consumption": 0.15,
          "coats": 1,
          "name": "IDP Imprimación Flexible de Poliuretano",
          "commercialName": "IDP Imprimación Flexible de Poliuretano",
          "technicalName": "IDP Imprimación Flexible de Poliuretano",
          "sourceName": "IDP Imprimación Flexible de Poliuretano",
          "officialConsumption": 0.15,
          "packages": [],
          "sheet": "IDP_Imprimacion_Flexible_de_Poliuretano_7f338b78-81a5-45eb-b432-2ac2ecf00186.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-flexible-para-sistemas-de-poliuretano"
        },
        {
          "productId": "idp-aglomerante-de-poliuretano-aromatico-monocomponente-para-caucho",
          "phase": "Base SBR: aglomerante integrado",
          "consumption": 3.12,
          "coats": 1,
          "name": "IDP Aglomerante de poliuretano aromático monocomponente para caucho",
          "commercialName": "IDP Aglomerante de poliuretano aromático monocomponente para caucho",
          "technicalName": "IDP Aglomerante de poliuretano aromático monocomponente para caucho",
          "sourceName": "IDP Aglomerante de poliuretano aromático monocomponente para caucho",
          "officialConsumption": 3.12,
          "packages": [],
          "sheet": "IDP_Aglomerante_de_poliuretano_aromatico_monocomponente_para_caucho.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-aglomerante-de-poliuretano-aromatico-monocomponente-para-caucho"
        },
        {
          "productId": "idp-granulado-de-caucho-sbr-para-pavimentos-elasticos",
          "phase": "Base SBR: granulado integrado",
          "consumption": 20.88,
          "coats": 1,
          "name": "IDP Granulado de caucho SBR para pavimentos elásticos",
          "commercialName": "IDP Granulado de caucho SBR para pavimentos elásticos",
          "technicalName": "IDP Granulado de caucho SBR para pavimentos elásticos",
          "sourceName": "IDP Granulado de caucho SBR para pavimentos elásticos",
          "officialConsumption": 20.88,
          "packages": [],
          "sheet": "IDP_Granulado_de_caucho_SBR_para_pavimentos_elasticos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-granulado-de-caucho-sbr-para-pavimentos-elasticos"
        },
        {
          "productId": "idp-aglomerante-de-poliuretano-alifatico-monocomponente-para-caucho",
          "phase": "Acabado EPDM: aglomerante integrado, 21 %",
          "consumption": 1.512,
          "coats": 1,
          "name": "IDP Aglomerante de poliuretano alifático monocomponente para caucho",
          "commercialName": "IDP Aglomerante de poliuretano alifático monocomponente para caucho",
          "technicalName": "IDP Aglomerante de poliuretano alifático monocomponente para caucho",
          "sourceName": "IDP Aglomerante de poliuretano alifático monocomponente para caucho",
          "officialConsumption": 1.512,
          "packages": [],
          "sheet": "IDP_Aglomerante_de_poliuretano_alifatico_monocomponente_para_caucho.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-aglomerante-de-poliuretano-alifatico-monocomponente-para-caucho"
        },
        {
          "productId": "idp-granulado-de-caucho-epdm-para-pavimentos-elasticos",
          "phase": "Acabado EPDM: granulado integrado",
          "consumption": 7.2,
          "coats": 1,
          "name": "IDP Granulado de caucho EPDM para pavimentos elásticos",
          "commercialName": "IDP Granulado de caucho EPDM para pavimentos elásticos",
          "technicalName": "IDP Granulado de caucho EPDM para pavimentos elásticos",
          "sourceName": "IDP Granulado de caucho EPDM para pavimentos elásticos",
          "officialConsumption": 7.2,
          "packages": [],
          "sheet": "IDP_Granulado_de_caucho_EPDM_para_pavimentos_elasticos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-granulado-de-caucho-epdm-para-pavimentos-elasticos"
        }
      ],
      "commercialName": "IDP Poliuretano alifático con agregado SBR o EPDM",
      "technicalName": "Sistema técnico de poliuretano alifático con agregado sbr o epdm",
      "description": "Pavimento continuo de caucho colocado in situ, con base SBR y aglomerante de poliuretano aromático, acabado EPDM con aglomerante alifático específico e imprimación flexible independiente. Selección del 21 % sobre EPDM respaldada por la ficha del ligante; espesor nominal aproximado de 40 mm sujeto a comprobación de obra. Cinco fichas completas anexadas.",
      "applications": "El sistema IDP Floor PU 40 SAFETY es una opción ideal para el recubrimiento de pavimentos, pavimentos decorativos, parques infantiles.",
      "keywords": "IDP Imprimación Flexible de Poliuretano | IDP Aglomerante de poliuretano aromático monocomponente para caucho | IDP Granulado de caucho SBR para pavimentos elásticos | IDP Aglomerante de poliuretano alifático monocomponente para caucho | IDP Granulado de caucho EPDM para pavimentos elásticos"
    },
    {
      "id": "idp-floor-puc-30-4-mm",
      "name": "IDP Pavimento autonivelante de poliuretano-cemento de 4 mm",
      "note": "Producto exacto recuperado FTespañola 17/12/2024 desde enlace del catálogo 2026, kit 20,6 kg ydensidad 2,00 coincidentes con referenciaIDP existente. No equiparación por nombregenérico ni transferencia del kitantiguo 19,5 kg/1,75. Fuente propia 04/11/2025 prescribe MISMOmortero de contacto 1,50–2,00 y principal 6,00: selección contacto 2,00, TOTAL8,00 kg/m²para nominalTOTAL4 mm, coherente con tabla actual 8/10/12 para 4/5/6 mm. No añadir otra vez contacto sobre 8/12, ni duplicar cargaC/pigmentoDcomo capas. Espesorreal yabsorción comprobados, no garantía geométrica por masa. RelaciónA12,8/B13,3/C100 incoherente preservada; kit PREDOSIFICADO explícito, solo conjuntoscompletos compatibles identificados, NOfraccionamiento ni relacióninventada. Cfigura«líquido»comoerrata frente a carga mineral en saco. A75 %sólidos: no 100 %delconjunto. No imponer imprimación epoxi por regla del piloto. Temperaturas 15–30/HR<80/rocío 3, soporte<4 %,>28 días/cohesión>1,5 propios. Ventana contacto→principal numéricaNOaportada: procedimiento de suministro y aptitud/adherencia, no copiar 24 h. Fuenteactual 7 díasuso, no 48 htráficodenso. Sin C40/F20/Rd 45/clase 3/antimicrobiano/DoPglobal o contactoalimentario garantizados. Variante 4 mmFUERAde choque térmico general: producto exige mínimo 6 mm; servicio−15/+70°Cno es lavado caliente ilimitado.",
      "sheet": "IDP_Pavimento_autonivelante_de_poliuretano-cemento_de_4_mm.pdf",
      "systemUrl": "/products/idp-floor-puc-30-4-mm",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "mortero-de-poliuretano-cementoso-autonivelante-de-altas-resistencias",
          "phase": "Capa de contacto del MISMO mortero COMPLETO",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Poliuretano-Cemento Autonivelante",
          "commercialName": "IDP Poliuretano-Cemento Autonivelante",
          "technicalName": "IDP Poliuretano-Cemento Autonivelante",
          "sourceName": "IDP Poliuretano-Cemento Autonivelante",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Poliuretano-Cemento_Autonivelante_86829c0d-8475-4ece-9813-9ad577f8dd1b.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/mortero-de-poliuretano-cementoso-autonivelante-de-altas-resistencias"
        },
        {
          "productId": "mortero-de-poliuretano-cementoso-autonivelante-de-altas-resistencias",
          "phase": "Capa principal del MISMO kit;total del conjunto8kg/m² para nominal4mm",
          "consumption": 6,
          "coats": 1,
          "name": "IDP Poliuretano-Cemento Autonivelante",
          "commercialName": "IDP Poliuretano-Cemento Autonivelante",
          "technicalName": "IDP Poliuretano-Cemento Autonivelante",
          "sourceName": "IDP Poliuretano-Cemento Autonivelante",
          "officialConsumption": 6,
          "packages": [],
          "sheet": "IDP_Poliuretano-Cemento_Autonivelante_86829c0d-8475-4ece-9813-9ad577f8dd1b.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/mortero-de-poliuretano-cementoso-autonivelante-de-altas-resistencias"
        }
      ],
      "commercialName": "IDP Poliuretano cemento de 4 mm",
      "technicalName": "Sistema técnico de poliuretano cemento de 4 mm",
      "description": "Pavimento autonivelante de poliuretano-cemento sobre hormigón. Mismo kit completo 20,6 kg como contacto 2,00 y principal 6,00: TOTAL8,00 kg/m², nominalTOTAL4 mm, espesor real a comprobar. Siete páginas con anexo íntegro del producto exacto, mezcla y límites documentados.",
      "applications": "Cocinas industriales, zonas de uso pesado, conserveras, plantas de congelado y mataderos.",
      "keywords": "IDP Poliuretano-Cemento Autonivelante"
    },
    {
      "id": "idp-floor-puc-40-safety-4-mm",
      "name": "IDP Poliuretano cemento multicapa antideslizante de 4 mm",
      "note": "Configuración antideslizante de 4 mm documentada con capa de contacto, cuerpo autonivelante de poliuretano cemento, árido de cuarzo a saturación y sellado mate compatible.",
      "sheet": "ficha-sistema-idp-floor-puc-40-safety-4-mm-es.pdf",
      "systemUrl": "/products/idp-floor-puc-40-safety-4-mm",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Capa de contacto y raspado",
          "productId": "mortero-de-poliuretano-cemento-autonivelante-antimicrobiano",
          "name": "Mortero de poliuretano cemento autonivelante de cuatro componentes con tecnología antimicrobiana",
          "sourceName": "IDP Mortero de Poliuretano-Cemento Antimicrobiano",
          "consumption": 1.5,
          "officialConsumption": 1.5,
          "officialLabel": "1,5 kg/m²",
          "coats": 1,
          "packages": [
            17.6
          ],
          "sheet": "ficha-tecnica-ft-idp-f02-096.pdf",
          "commercialName": "IDP Mortero de Poliuretano-Cemento Antimicrobiano",
          "technicalName": "Mortero de poliuretano cemento autonivelante de cuatro componentes con tecnología antimicrobiana",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/mortero-de-poliuretano-cemento-autonivelante-antimicrobiano",
          "relationType": "capa",
          "applicationMethod": "con llana metálica lisa sobre el terrazo cementoso preparado, limpio y aspirado",
          "executionLabel": "una capa continua",
          "prescriptionNote": "Cerrar poro y regularizar sin dejar calvas, charcos ni contaminantes antes de la capa principal."
        },
        {
          "phase": "Capa principal autonivelante",
          "productId": "mortero-de-poliuretano-cemento-autonivelante-antimicrobiano",
          "name": "Mortero de poliuretano cemento autonivelante de cuatro componentes con tecnología antimicrobiana",
          "sourceName": "IDP Mortero de Poliuretano-Cemento Antimicrobiano",
          "consumption": 3.8,
          "officialConsumption": 3.8,
          "officialLabel": "3,8 kg/m²",
          "coats": 1,
          "packages": [
            17.6
          ],
          "sheet": "ficha-tecnica-ft-idp-f02-096.pdf",
          "commercialName": "IDP Mortero de Poliuretano-Cemento Antimicrobiano",
          "technicalName": "Mortero de poliuretano cemento autonivelante de cuatro componentes con tecnología antimicrobiana",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/mortero-de-poliuretano-cemento-autonivelante-antimicrobiano",
          "relationType": "capa",
          "applicationMethod": "vertido, extendido a espesor uniforme con rastrillo calibrado o llana y desaireado inmediato con rodillo de púas",
          "executionLabel": "una capa autonivelante",
          "prescriptionNote": "Trabajar por lotes completos y paños continuos, respetando vida útil, juntas y tiempos de unión entre amasadas."
        },
        {
          "phase": "Espolvoreo de árido a saturación",
          "productId": "arido-de-cuarzo-idp",
          "name": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "consumption": 3.5,
          "officialConsumption": 3.5,
          "officialLabel": "3,5 kg/m²",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "ficha-tecnica-ft-idp-f07-092.pdf",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp",
          "relationType": "capa",
          "applicationMethod": "espolvoreo uniforme a saturación sobre la capa principal todavía fresca, seguido de barrido y aspiración del excedente tras su curado",
          "executionLabel": "un espolvoreo continuo",
          "prescriptionNote": "Para reproducir la configuración de referencia se seleccionará la fracción efectiva 0,4-0,8 mm; no sellar hasta eliminar todo árido suelto."
        },
        {
          "phase": "Sellado mate",
          "productId": "sellador-de-poliuretano-cemento-mate-antimicrobiano",
          "name": "Sellador híbrido de poliuretano cemento de cuatro componentes con acabado mate y tecnología antimicrobiana",
          "sourceName": "IDP Sellador de Poliuretano-Cemento Mate Antimicrobiano",
          "consumption": 0.6,
          "officialConsumption": 0.6,
          "officialLabel": "0,6 kg/m²",
          "coats": 1,
          "packages": [
            4.95
          ],
          "sheet": "ficha-tecnica-ft-idp-f02-097.pdf",
          "commercialName": "IDP Sellador de Poliuretano-Cemento Mate Antimicrobiano",
          "technicalName": "Sellador híbrido de poliuretano cemento de cuatro componentes con acabado mate y tecnología antimicrobiana",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/sellador-de-poliuretano-cemento-mate-antimicrobiano",
          "relationType": "capa",
          "applicationMethod": "con rastra de goma, homogeneizando y terminando inmediatamente con rodillo de pelo largo en pasadas cruzadas",
          "executionLabel": "una capa de sellado",
          "prescriptionNote": "Aplicar únicamente sobre el árido perfectamente adherido, barrido, aspirado, seco y libre de contaminación."
        }
      ],
      "commercialName": "IDP Poliuretano cemento multicapa antideslizante de 4 mm",
      "technicalName": "Sistema técnico de poliuretano cemento multicapa antideslizante de 4 mm",
      "description": "Sistema continuo de poliuretano cemento de 4 mm, antimicrobiano y de textura antideslizante, formado por capa de contacto, cuerpo autonivelante, árido de cuarzo a saturación y sellado mate.",
      "applications": "Cocinas industriales, industria alimentaria y de bebidas, zonas de proceso en seco, cámaras y áreas con tránsito peatonal o rodado ligero a medio que requieran higiene, limpieza y control del deslizamiento.",
      "keywords": "IDP Mortero de Poliuretano-Cemento Antimicrobiano | Mortero de poliuretano cemento autonivelante de cuatro componentes con tecnología antimicrobiana | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos | IDP Sellador de Poliuretano-Cemento Mate Antimicrobiano | Sellador híbrido de poliuretano cemento de cuatro componentes con acabado mate y tecnología antimicrobiana",
      "prescription": {
        "status": "Prescripción técnica controlada: secuencia de 4 mm basada en la configuración oficial de capa de contacto, cuerpo SL, cuarzo y sellado mate.",
        "object": "Suministro y ejecución de pavimento continuo IDP Floor PUC 40 Safety 4 mm, de poliuretano cemento, acabado mate antimicrobiano y antideslizante, sobre terrazo cementoso apto, con preparación, rozas de anclaje, cuatro capas integrales y limpieza final.",
        "substrate": "Terrazo exclusivamente cementoso, totalmente adherido, cohesivo y sin humedad ascendente; retirar ceras, selladores, grasas y partes débiles, abrir poro por granallado, escarificado o fresado y aspirar. Exigir adherencia por tracción superior a 1,5 N/mm². El diamantado general solo se admite tras prueba de adherencia aprobada; reservarlo preferentemente para bordes y detalles. Ejecutar rozas de anclaje en perímetros, puertas, pilares, sumideros, canales y juntas, con ancho y profundidad aproximados del doble del espesor instalado; respetar las juntas activas.",
        "thickness": "Espesor nominal total del sistema: 4 mm. No confundir con la variante basada en mortero MF y árido a saturación, cuya configuración oficial alcanza aproximadamente 6 mm.",
        "finish": "Acabado mate texturado. Referencia documentada: R12-V4 según DIN 51130 y PTV 65 en seco / 55 en húmedo según EN 13036-4. La aceptación como Clase 3 del CTE se comprobará con certificado vigente aplicable a la configuración exacta ejecutada.",
        "summary": "4 mm nominales · consumo orientativo total 9,4 kg/m²",
        "totalConsumption": "9,4 kg/m²: 1,5 kg/m² de contacto + 3,8 kg/m² de cuerpo SL + 3,5 kg/m² de cuarzo + 0,6 kg/m² de sellado.",
        "performance": [
          {
            "property": "Antimicrobiano",
            "target": "Tecnología de iones de plata integrada en la familia del sistema; método de referencia ISO 22196.",
            "evidenceStatus": "Documentado por el fabricante para la configuración de referencia"
          },
          {
            "property": "Deslizamiento",
            "target": "R12-V4 y PTV 55 en húmedo; Clase 3 como requisito contractual de aceptación.",
            "evidenceStatus": "Ensayo de referencia; exigir certificado vigente del conjunto exacto"
          },
          {
            "property": "Higiene",
            "target": "Sistema de referencia con certificación HACCP International.",
            "evidenceStatus": "Documentado para el sistema completo de referencia"
          },
          {
            "property": "Soporte",
            "target": "Adherencia por tracción superior a 1,5 N/mm² y terrazo cementoso sin ceras ni humedad ascendente.",
            "evidenceStatus": "Control previo obligatorio en obra"
          }
        ],
        "closing": "Aplicar a temperatura de soporte y ambiente compatible con las fichas vigentes, con el soporte al menos 3 °C sobre el punto de rocío y humedad ambiental controlada. Documentar lotes, consumos, temperaturas, humedad, punto de rocío y tiempos. Habilitar tránsito peatonal, ligero, pesado y exposición química únicamente después de los plazos de curado del producto aplicado.",
        "limitations": "No aplicar sobre terrazo resinoso, piezas huecas o sueltas, superficies enceradas, soportes con presión de agua o humedad ascendente. No mezclar componentes parciales ni añadir agua, disolventes o cargas ajenas. Medias cañas, reparación estructural, juntas nuevas y barrera de humedad se medirán aparte salvo inclusión expresa."
      }
    },
    {
      "id": "idp-floor-puc-30-6-mm",
      "name": "IDP Pavimento autonivelante de poliuretano-cemento de 6 mm",
      "note": "Producto exacto recuperado FTespañola 17/12/2024 desde enlace del catálogo 2026, kit 20,6 kg ydensidad 2,00 coincidentes con referenciaIDP existente. No equiparación por nombregenérico ni transferencia del kitantiguo 19,5 kg/1,75. Fuente propia 04/11/2025 prescribe MISMOmortero de contacto 1,50–2,00 y principal 10,00: selección contacto 2,00, TOTAL12,00 kg/m²para nominalTOTAL6 mm, coherente con tabla actual 8/10/12 para 4/5/6 mm. No añadir otra vez contacto sobre 8/12, ni duplicar cargaC/pigmentoDcomo capas. Espesorreal yabsorción comprobados, no garantía geométrica por masa. RelaciónA12,8/B13,3/C100 incoherente preservada; kit PREDOSIFICADO explícito, solo conjuntoscompletos compatibles identificados, NOfraccionamiento ni relacióninventada. Cfigura«líquido»comoerrata frente a carga mineral en saco. A75 %sólidos: no 100 %delconjunto. No imponer imprimación epoxi por regla del piloto. Temperaturas 15–30/HR<80/rocío 3, soporte<4 %,>28 días/cohesión>1,5 propios. Ventana contacto→principal numéricaNOaportada: procedimiento de suministro y aptitud/adherencia, no copiar 24 h. Fuenteactual 7 díasuso, no 48 htráficodenso. Sin C40/F20/Rd 45/clase 3/antimicrobiano/DoPglobal o contactoalimentario garantizados. Variante 6 mmrequiere espesorreal/ciclos/interfazvalidados;−25/+80°Ccon+80 soloDERRAMEPUNTUAL, noinmersión/calorcontinuo.",
      "sheet": "IDP_Pavimento_autonivelante_de_poliuretano-cemento_de_6_mm.pdf",
      "systemUrl": "/products/idp-floor-puc-30-6-mm",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "mortero-de-poliuretano-cementoso-autonivelante-de-altas-resistencias",
          "phase": "Capa de contacto del MISMO mortero COMPLETO",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Poliuretano-Cemento Autonivelante",
          "commercialName": "IDP Poliuretano-Cemento Autonivelante",
          "technicalName": "IDP Poliuretano-Cemento Autonivelante",
          "sourceName": "IDP Poliuretano-Cemento Autonivelante",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Poliuretano-Cemento_Autonivelante_86829c0d-8475-4ece-9813-9ad577f8dd1b.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/mortero-de-poliuretano-cementoso-autonivelante-de-altas-resistencias"
        },
        {
          "productId": "mortero-de-poliuretano-cementoso-autonivelante-de-altas-resistencias",
          "phase": "Capa principal del MISMO kit;total del conjunto12kg/m² para nominal6mm",
          "consumption": 10,
          "coats": 1,
          "name": "IDP Poliuretano-Cemento Autonivelante",
          "commercialName": "IDP Poliuretano-Cemento Autonivelante",
          "technicalName": "IDP Poliuretano-Cemento Autonivelante",
          "sourceName": "IDP Poliuretano-Cemento Autonivelante",
          "officialConsumption": 10,
          "packages": [],
          "sheet": "IDP_Poliuretano-Cemento_Autonivelante_86829c0d-8475-4ece-9813-9ad577f8dd1b.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/mortero-de-poliuretano-cementoso-autonivelante-de-altas-resistencias"
        }
      ],
      "commercialName": "IDP Poliuretano cemento de 6 mm",
      "technicalName": "Sistema técnico de poliuretano cemento de 6 mm",
      "description": "Pavimento autonivelante de poliuretano-cemento sobre hormigón. Mismo kit completo 20,6 kg como contacto 2,00 y principal 10,00: TOTAL12,00 kg/m², nominalTOTAL6 mm, espesor real a comprobar. Siete páginas con anexo íntegro del producto exacto, mezcla y límites documentados.",
      "applications": "Cocinas industriales, zonas de uso pesado, conserveras, plantas de congelado y mataderos.",
      "keywords": "IDP Poliuretano-Cemento Autonivelante"
    },
    {
      "id": "idp-floor-pu-20-deco",
      "name": "IDP Poliuretano decorativo alifático rugoso",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-floor-pu-20-deco-es.pdf",
      "systemUrl": "/products/idp-floor-pu-20-deco",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0.5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Recubrimiento Superficial",
          "productId": "resina-autonivelante-de-poliuretano",
          "name": "Resina autonivelante de poliuretano",
          "sourceName": "Resina autonivelante de poliuretano + árido (0­0,3 mm, relación 1/0,3)",
          "consumption": 1,
          "officialConsumption": 1,
          "officialLabel": "1 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-028.pdf",
          "commercialName": "IDP Poliuretano Autonivelante",
          "technicalName": "Resina autonivelante de poliuretano",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-autonivelante-de-poliuretano"
        },
        {
          "phase": "Sellado Del Sistema",
          "productId": "recubrimiento-de-poliuretano-alifatico-al-agua",
          "name": "Acabado alifático bicomponente de poliuretano en base agua",
          "sourceName": "IDP ECO Barniz /Floortop 1K IDP ECO Barniz / Floortop 1K",
          "consumption": 0.175,
          "officialConsumption": 0.175,
          "officialLabel": "0,15-0,2 kg/m²",
          "coats": 2,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f05-072.pdf",
          "commercialName": "IDP Acabado Alifático de Poliuretano al Agua",
          "technicalName": "Acabado alifático bicomponente de poliuretano en base agua",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-de-poliuretano-alifatico-al-agua"
        }
      ],
      "commercialName": "IDP Poliuretano decorativo alifático rugoso",
      "technicalName": "Sistema técnico de poliuretano decorativo alifático rugoso",
      "description": "Sistema bicomponente 100% sólidos a base de resinas de poliuretano, pigmentado con acabado alifático y rugoso, para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Poliuretano rugoso 100 % sólidos DECO es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, talleres, que soliciten un acabado rugoso y con mayor tolerancia a movimientos y fisuras que los sistemas epoxi convencionales.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliuretano Autonivelante | Resina autonivelante de poliuretano | IDP Acabado Alifático de Poliuretano al Agua | Acabado alifático bicomponente de poliuretano en base agua"
    },
    {
      "id": "idp-floor-pu-40-deco-ext-peatonal-vehicular",
      "name": "IDP Moqueta de piedra de poliuretano alifático",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-floor-pu-40-deco-ext-peatonal-vehicular-es.pdf",
      "systemUrl": "/products/idp-floor-pu-40-deco-ext-peatonal-vehicular",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 0.55,
          "officialConsumption": 0.55,
          "officialLabel": "0,5 - 0,6 kg/m²",
          "coats": 2,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Capa Base",
          "productId": "ligante-de-poliuretano-alifatico-monocomponente-para-pavimentos-de-arido",
          "name": "Ligante de poliuretano alifático monocomponente para pavimentos de árido",
          "sourceName": "IDP Pavistone",
          "consumption": 1.5,
          "officialConsumption": 1.5,
          "officialLabel": "1-2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Ligante_de_Poliuretano_Alifatico_1K_74252f08-78fd-4d2e-ae44-f39d80bcae5e.pdf",
          "commercialName": "IDP Ligante de Poliuretano Alifático 1K",
          "technicalName": "Ligante de poliuretano alifático monocomponente para pavimentos de árido",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/ligante-de-poliuretano-alifatico-monocomponente-para-pavimentos-de-arido"
        },
        {
          "phase": "Capa Base",
          "productId": "ligante-de-poliuretano-alifatico-monocomponente-para-pavimentos-de-arido",
          "name": "Ligante de poliuretano alifático monocomponente para pavimentos de árido",
          "sourceName": "IDP Pavistone IDP Pavistone 1K HV peso 6 mm.",
          "consumption": 0.92,
          "officialConsumption": 0.92,
          "officialLabel": "0,92 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Ligante_de_Poliuretano_Alifatico_1K_74252f08-78fd-4d2e-ae44-f39d80bcae5e.pdf",
          "commercialName": "IDP Ligante de Poliuretano Alifático 1K",
          "technicalName": "Ligante de poliuretano alifático monocomponente para pavimentos de árido",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/ligante-de-poliuretano-alifatico-monocomponente-para-pavimentos-de-arido"
        },
        {
          "phase": "Capa Base",
          "productId": "",
          "name": "Mármol IDP triturado",
          "sourceName": "Mármol IDP triturado",
          "consumption": 17,
          "officialConsumption": 17,
          "officialLabel": "17 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "",
          "commercialName": "",
          "technicalName": "",
          "documentStatus": "",
          "productUrl": ""
        },
        {
          "phase": "Capa Base",
          "productId": "ligante-de-poliuretano-alifatico-bicomponente-resistente-a-uv-para-pavimentos-de-arido",
          "name": "IDP Ligante de Poliuretano Alifático 2K UV",
          "sourceName": "IDP Ligante de Poliuretano Alifático 2K UV",
          "consumption": 1.5,
          "officialConsumption": 1.5,
          "officialLabel": "1-2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Ligante_de_Poliuretano_Alifatico_2K_UV_88c47c04-f71f-4e8a-9848-264fad8f0bcd.pdf",
          "commercialName": "IDP Ligante de Poliuretano Alifático 2K UV",
          "technicalName": "IDP Ligante de Poliuretano Alifático 2K UV",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/ligante-de-poliuretano-alifatico-bicomponente-resistente-a-uv-para-pavimentos-de-arido"
        },
        {
          "phase": "Capa Base",
          "productId": "",
          "name": "Mármol IDP triturado 1:1 granulometría 1-3 3-6",
          "sourceName": "Mármol IDP triturado 1:1 granulometría 1-3 3-6",
          "consumption": 34,
          "officialConsumption": 34,
          "officialLabel": "34 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "",
          "commercialName": "",
          "technicalName": "",
          "documentStatus": "",
          "productUrl": ""
        }
      ],
      "commercialName": "IDP Moqueta de piedra de poliuretano alifático",
      "technicalName": "Sistema técnico de moqueta de piedra de poliuretano alifático",
      "description": "Sistema de moqueta de piedra de uno y dos componentes a base de dos capas de resinas de poliuretano con acabado alifático para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Floor PU 40 DECO EXT es una opción ideal para cubrir pavimentos en diferentes tipos de proyectos como diseño, cines, decoración de jardines, locales comerciales, terrazas y balcones, alrededor de piscinas, estacionamientos, etc.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Ligante de Poliuretano Alifático 1K | Ligante de poliuretano alifático monocomponente para pavimentos de árido | IDP Ligante de Poliuretano Alifático 2K UV | Ligante de poliuretano alifático bicomponente resistente a UV para pavimentos de árido"
    },
    {
      "id": "idp-floor-pu-20-flex",
      "name": "IDP Poliuretano flexible rugoso",
      "note": "La fuente de 09/06/2025 menciona asfalto en sus aplicaciones, pero su descripción, ventajas y base especifican hormigón. Esta ficha selecciona la configuración sobre hormigón con imprimación epoxi independiente. Anclaje de base: 0,50–0,70 kg/m², selección 0,60. Intermedia: 1,80–2,00 kg/m² de MEZCLA, resina: árido 1:0,3. Acabado: 0,60–0,80 kg/m² TOTAL en dos manos. La fuente no fija espesor; definirlo y comprobarlo en proyecto. No añadir otros 3 kg/m² del uso autonivelante puro ni espesante por defecto. El acabado contiene disolvente: el conjunto no se describe como 100 % sólidos. Los ensayos de producto no certifican por sí solos el deslizamiento, fuego o carga de tráfico del sistema. La fuente del acabado expresa la arena de su ensayo como 1 kg/m³; no se cambia a kg/m² ni se anuncia aquella clase para esta configuración. Cinco fichas completas anexadas.",
      "sheet": "IDP_Poliuretano_flexible_rugoso_1d69c987-bbf7-492b-8bab-04e067b0e969.pdf",
      "systemUrl": "/products/idp-floor-pu-20-flex",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi: dos manos de 0,25, total 0,50",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Anclaje sobre segunda mano fresca",
          "consumption": 0.6,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 0.6,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "productId": "resina-autonivelante-flexible-de-poliuretano",
          "phase": "Resina A+B de la intermedia 1:0,3",
          "consumption": 1.4615384615384615,
          "coats": 1,
          "name": "IDP Poliuretano Autonivelante Flexible",
          "commercialName": "IDP Poliuretano Autonivelante Flexible",
          "technicalName": "IDP Poliuretano Autonivelante Flexible",
          "sourceName": "IDP Poliuretano Autonivelante Flexible",
          "officialConsumption": 1.4615384615384615,
          "packages": [],
          "sheet": "IDP_Poliuretano_Autonivelante_Flexible_0dfc4091-3ac0-4552-9a37-d68b7d2d6450.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-autonivelante-flexible-de-poliuretano"
        },
        {
          "productId": "idp-arido-de-cuarzo-0-0-3-mm",
          "phase": "Cuarzo fino de la misma mezcla intermedia",
          "consumption": 0.4384615384615384,
          "coats": 1,
          "name": "IDP Árido de cuarzo 0–0,3 mm",
          "commercialName": "IDP Árido de cuarzo 0–0,3 mm",
          "technicalName": "IDP Árido de cuarzo 0–0,3 mm",
          "sourceName": "IDP Árido de cuarzo 0–0,3 mm",
          "officialConsumption": 0.4384615384615384,
          "packages": [],
          "sheet": "IDP_Arido_de_cuarzo_0_0_3_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-0-0-3-mm"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Espolvoreo principal en fresco",
          "consumption": 4.0,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 4.0,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "productId": "revestimiento-monocomponente-para-pavimentos",
          "phase": "Sellado: dos manos de 0,35, total 0,70",
          "consumption": 0.35,
          "coats": 2,
          "name": "IDP Revestimiento Monocomponente para Pavimentos",
          "commercialName": "IDP Revestimiento Monocomponente para Pavimentos",
          "technicalName": "IDP Revestimiento Monocomponente para Pavimentos",
          "sourceName": "IDP Revestimiento Monocomponente para Pavimentos",
          "officialConsumption": 0.35,
          "packages": [],
          "sheet": "IDP_Revestimiento_Monocomponente_para_Pavimentos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/revestimiento-monocomponente-para-pavimentos"
        }
      ],
      "commercialName": "IDP Poliuretano flexible rugoso",
      "technicalName": "Sistema técnico de poliuretano flexible rugoso",
      "description": "Pavimento multicapa de poliuretano flexible rugoso sobre hormigón, con imprimación epoxi independiente, anclaje de cuarzo, intermedia cargada y acabado alifático monocomponente pigmentado. Cinco fichas completas anexadas.",
      "applications": "IDP Poliuretano flexible rugoso es una opción ideal para el recubrimiento de pavimentos asfalticos en parkings comerciales, industriales y residenciales.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliuretano Autonivelante Flexible | IDP Árido de cuarzo 0–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Revestimiento Monocomponente para Pavimentos"
    },
    {
      "id": "idp-floor-pu-20-flex-asf",
      "name": "IDP Poliuretano flexible rugoso para asfalto",
      "note": "Configuración seleccionada del sistema 08/10/2025: base flexible 1,25 kg/m² de ligante A+B, espesante EN POLVO2 %=0,025, intermedia 1,90 TOTAL mezcla resina: cuarzo 0–0,3 mm 1:0,3, espolvoreo grueso 4,00 y acabado alifático 1K PIGMENTADO F02-0320,70 TOTAL (2×0,35). Total 7,875 kg/m²; 100 m²+5 %=826,875 kg(826,88 redondeado). Anclaje opcional 1,00 aparte. No base de aditivo puro, no epoxi rígido sobre asfalto por uniformidad, no F05-077 al agua ni F05-074 como acabado. Polvo primario 1–3 % frente a catálogo 2–4 %: selección común 2 %, prueba previa, sin rango fusionado 1–4. No sustituirlo por tixotropante líquido ni F07-0830,9 kg. Recalcular polvo 2 % si cambia la dosis de base y mantener relación 1:0,3 de intermedia; el cálculo usa los gramajes introducidos. Sin espesor nominal ni clase de deslizamiento inventados.",
      "sheet": "IDP_Poliuretano_flexible_rugoso_para_asfalto_f08c5df8-13a7-4b0d-bbb1-1ae92b228679.pdf",
      "systemUrl": "/products/idp-floor-pu-20-flex-asf",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Base: ligante PU flexible",
          "productId": "resina-autonivelante-flexible-de-poliuretano",
          "name": "IDP Poliuretano Autonivelante Flexible",
          "commercialName": "IDP Poliuretano Autonivelante Flexible",
          "technicalName": "IDP Poliuretano Autonivelante Flexible",
          "sourceName": "IDP Poliuretano Autonivelante Flexible",
          "consumption": 1.25,
          "officialConsumption": 1.25,
          "officialLabel": "1,25 kg/m² de resina A+B",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Poliuretano_Autonivelante_Flexible_0dfc4091-3ac0-4552-9a37-d68b7d2d6450.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-autonivelante-flexible-de-poliuretano"
        },
        {
          "phase": "Base: espesante EN POLVO al 2 %",
          "productId": "idp-espesante-en-polvo-para-resinas-epoxi-y-poliuretano",
          "name": "IDP Espesante en polvo para resinas epoxi y poliuretano",
          "commercialName": "IDP Espesante en polvo para resinas epoxi y poliuretano",
          "technicalName": "IDP Espesante en polvo para resinas epoxi y poliuretano",
          "sourceName": "IDP Espesante en polvo para resinas epoxi y poliuretano",
          "consumption": 0.025,
          "officialConsumption": 0.025,
          "officialLabel": "0,025 kg/m² para base 1,25; recalcular 2 % al cambiar base",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Espesante_en_polvo_para_resinas_epoxi_y_poliuretano.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-espesante-en-polvo-para-resinas-epoxi-y-poliuretano"
        },
        {
          "phase": "Intermedia: ligante flexible",
          "productId": "resina-autonivelante-flexible-de-poliuretano",
          "name": "IDP Poliuretano Autonivelante Flexible",
          "commercialName": "IDP Poliuretano Autonivelante Flexible",
          "technicalName": "IDP Poliuretano Autonivelante Flexible",
          "sourceName": "IDP Poliuretano Autonivelante Flexible",
          "consumption": 1.4615384615384615,
          "officialConsumption": 1.4615384615384615,
          "officialLabel": "1,461538 kg/m² de resina; mezcla total 1,90 a 1:0,3",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Poliuretano_Autonivelante_Flexible_0dfc4091-3ac0-4552-9a37-d68b7d2d6450.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-autonivelante-flexible-de-poliuretano"
        },
        {
          "phase": "Intermedia: cuarzo0–0,3mm",
          "productId": "idp-arido-de-cuarzo-0-0-3-mm",
          "name": "IDP Árido de cuarzo 0–0,3 mm",
          "commercialName": "IDP Árido de cuarzo 0–0,3 mm",
          "technicalName": "IDP Árido de cuarzo 0–0,3 mm",
          "sourceName": "IDP Árido de cuarzo 0–0,3 mm",
          "consumption": 0.4384615384615384,
          "officialConsumption": 0.4384615384615384,
          "officialLabel": "0,438462 kg/m² de carga fina; mezcla total 1,90",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Arido_de_cuarzo_0_0_3_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-0-0-3-mm"
        },
        {
          "phase": "Espolvoreo principal fresco",
          "productId": "arido-de-cuarzo-idp",
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "consumption": 4,
          "officialConsumption": 4,
          "officialLabel": "4,00 kg/m²; retirar exceso tras curado",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Sellado alifático monocomponente PIGMENTADO",
          "productId": "revestimiento-monocomponente-para-pavimentos",
          "name": "IDP Revestimiento Monocomponente para Pavimentos",
          "commercialName": "IDP Revestimiento Monocomponente para Pavimentos",
          "technicalName": "IDP Revestimiento Monocomponente para Pavimentos",
          "sourceName": "IDP Revestimiento Monocomponente para Pavimentos",
          "consumption": 0.35,
          "officialConsumption": 0.35,
          "officialLabel": "0,70 kg/m² TOTAL; 2×0,35",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Revestimiento_Monocomponente_para_Pavimentos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/revestimiento-monocomponente-para-pavimentos"
        }
      ],
      "commercialName": "IDP Poliuretano flexible rugoso para asfalto",
      "technicalName": "Sistema técnico de poliuretano flexible rugoso para asfalto",
      "description": "Base flexible con espesante en polvo, intermedia cargada de cuarzo0–0,3mm, espolvoreo grueso y acabado alifático1K para asfalto.",
      "applications": "IDP Poliuretano flexible rugoso para asfalto es una opción ideal para el recubrimiento de pavimentos asfalticos en parkings comerciales, industriales y residenciales.",
      "keywords": "IDP Poliuretano Autonivelante Flexible | IDP Espesante en polvo para resinas epoxi y poliuretano | IDP Árido de cuarzo 0–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Revestimiento Monocomponente para Pavimentos"
    },
    {
      "id": "idp-floor-pu-30-flex-asf",
      "name": "IDP Autonivelante de poliuretano flexible para asfalto",
      "note": "Base flexible 1,00–1,50 kg/m² de resina + espesante 1–2 %; el aditivo no sustituye al ligante. Masa 3,00 y acabado brillante F05-077 0,50 total en dos manos de 0,25. Cálculo: 1,25 + 0,01875 + 3,00 + 0,50 = 4,76875 kg/m². Rugoso opcional: aditivo 5–7 % solo en última mano (0,0125–0,0175 kg/m²), fuera del cálculo inicial y sin tercera mano. Soporte >10 y hasta 25 °C, ambiente 10–30 °C, HR máxima 60 %.",
      "sheet": "ficha-sistema-idp-floor-pu-30-flex-asf-es.pdf",
      "systemUrl": "/products/idp-floor-pu-30-flex-asf",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Base flexible: resina",
          "productId": "resina-autonivelante-flexible-de-poliuretano",
          "name": "Resina autonivelante flexible de poliuretano",
          "commercialName": "IDP Poliuretano Autonivelante Flexible",
          "technicalName": "Resina autonivelante flexible de poliuretano",
          "sourceName": "IDP Poliuretano Autonivelante Flexible",
          "consumption": 1.25,
          "officialConsumption": 1.25,
          "officialLabel": "1,00–1,50 kg/m² de resina",
          "coats": 1,
          "packages": [
            25,
            5
          ],
          "sheet": "IDP_Poliuretano_Autonivelante_Flexible_5e822d95-f5be-48ea-a46f-baefc7059919.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-autonivelante-flexible-de-poliuretano"
        },
        {
          "phase": "Espesante de base",
          "productId": "aditivo-espesante-para-resinas-de-poliuretano",
          "name": "Aditivo espesante para resinas de poliuretano",
          "commercialName": "IDP Espesante para Poliuretano",
          "technicalName": "Aditivo espesante para resinas de poliuretano",
          "sourceName": "IDP Espesante para Poliuretano",
          "consumption": 0.01875,
          "officialConsumption": 0.01875,
          "officialLabel": "1–2 % sobre resina de base; cálculo 1,5 % × 1,25 = 0,01875",
          "coats": 1,
          "packages": [
            0.9
          ],
          "sheet": "IDP_Espesante_para_Poliuretano_db630099-274c-49bd-8eed-4346065dcc24.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/aditivo-espesante-para-resinas-de-poliuretano"
        },
        {
          "phase": "Masa autonivelante",
          "productId": "resina-autonivelante-flexible-de-poliuretano",
          "name": "Resina autonivelante flexible de poliuretano",
          "commercialName": "IDP Poliuretano Autonivelante Flexible",
          "technicalName": "Resina autonivelante flexible de poliuretano",
          "sourceName": "IDP Poliuretano Autonivelante Flexible",
          "consumption": 3,
          "officialConsumption": 3,
          "officialLabel": "3,00 kg/m²",
          "coats": 1,
          "packages": [
            25,
            5
          ],
          "sheet": "IDP_Poliuretano_Autonivelante_Flexible_5e822d95-f5be-48ea-a46f-baefc7059919.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-autonivelante-flexible-de-poliuretano"
        },
        {
          "phase": "Sellado alifático brillante",
          "productId": "recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante",
          "name": "Recubrimiento de poliuretano alifático bicomponente al agua de acabado brillante",
          "commercialName": "IDP Poliuretano Alifático al Agua Brillante",
          "technicalName": "Recubrimiento de poliuretano alifático bicomponente al agua de acabado brillante",
          "sourceName": "IDP Poliuretano Alifático al Agua Brillante",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [
            15,
            4
          ],
          "sheet": "IDP_Poliuretano_Alifatico_al_Agua_Brillante.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante"
        }
      ],
      "commercialName": "IDP Autonivelante de poliuretano flexible para asfalto",
      "technicalName": "Sistema técnico de autonivelante de poliuretano flexible para asfalto",
      "description": "Sistema bicomponente autonivelante 100% sólidos a base de resinas de poliuretano, pigmentado, con acabado liso para la protección de superficies y pavimentos de asfalto.",
      "applications": "El sistema IDP Autonivelante de poliuretano flexible para asfalto es una opción ideal para el recubrimiento de pavimentos de asfalto en locales industriales, almacenes, estacionamientos, talleres, clínicas, hospitales, etc., que requieran un acabado liso y con mayor tolerancia a movimientos y fisuras que los sistemas.",
      "keywords": "IDP Poliuretano Autonivelante Flexible | Resina autonivelante flexible de poliuretano | IDP Acabado Alifático de Poliuretano al Agua | Acabado alifático bicomponente de poliuretano en base agua"
    },
    {
      "id": "idp-floor-pu-30-flex-e",
      "name": "IDP Autonivelante de poliuretano flexible para exterior",
      "note": "Anclaje OPCIONAL: cuarzo 0,3–0,8 mm, 0,50–0,70 kg/m² sobre imprimación fresca; no es otra imprimación. Configuración inicial LISA sin diluir: imprimación 2 × 0,20 = 0,40 kg/m² + masa flexible 3,00 kg/m² y acabado F02-032 2 × 0,25 = 0,50; total 3,90 kg/m². Para 100 m² + 5 % de merma, 409,50 kg. Árido opcional 0,3–0,8 mm en primera mano de acabado: dotación no cuantificada en origen, definir y ensayar antes de medir o ejecutar. Espesor aproximado 2,2–2,6 mm según fuente, sin conversión genérica kg/m² a mm. Soporte 15–25 °C, HR máxima 60 %. No atribuir clase 3 o Bfl-s1 al conjunto sin ensayo aplicable.",
      "sheet": "IDP_Autonivelante_de_poliuretano_flexible_para_exterior_dfba4563-e7f8-4774-bd5b-2b15142b809a.pdf",
      "systemUrl": "/products/idp-floor-pu-30-flex-e",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.2,
          "officialConsumption": 0.2,
          "officialLabel": "0,30–0,50 kg/m² TOTAL; cálculo 2 × 0,20 = 0,40",
          "coats": 2,
          "packages": [
            15
          ],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Masa autonivelante flexible",
          "productId": "resina-autonivelante-flexible-de-poliuretano",
          "name": "Resina autonivelante flexible de poliuretano bicomponente",
          "commercialName": "IDP Poliuretano Autonivelante Flexible",
          "technicalName": "Resina autonivelante flexible de poliuretano bicomponente",
          "sourceName": "IDP Poliuretano Autonivelante Flexible",
          "consumption": 3,
          "officialConsumption": 3,
          "officialLabel": "3,00 kg/m²; una capa",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "IDP_Poliuretano_Autonivelante_Flexible_5e822d95-f5be-48ea-a46f-baefc7059919.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-autonivelante-flexible-de-poliuretano"
        },
        {
          "phase": "Acabado alifático pigmentado",
          "productId": "revestimiento-monocomponente-para-pavimentos",
          "name": "Revestimiento monocomponente de poliuretano alifático al disolvente para pavimentos",
          "commercialName": "IDP Revestimiento Monocomponente para Pavimentos",
          "technicalName": "Revestimiento monocomponente de poliuretano alifático al disolvente para pavimentos",
          "sourceName": "IDP Revestimiento Monocomponente para Pavimentos",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; dos manos de 0,25",
          "coats": 2,
          "packages": [
            25
          ],
          "sheet": "IDP_Revestimiento_Monocomponente_para_Pavimentos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/revestimiento-monocomponente-para-pavimentos"
        }
      ],
      "commercialName": "IDP Autonivelante de poliuretano flexible para exterior",
      "technicalName": "Sistema técnico de autonivelante de poliuretano flexible para exterior",
      "description": "Sistema bicomponente autonivelante 100% sólidos a base de resinas de poliuretano, pigmentado, con acabado liso para la protección de superficies y pavimentos de hormigón.",
      "applications": "Pavimentos exteriores de aparcamientos, centros comerciales, oficinas, clínicas, hospitales y pistas deportivas que requieran un acabado flexible y tolerante a movimientos y fisuras.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliuretano Autonivelante Flexible | IDP Revestimiento Monocomponente para Pavimentos | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-floor-pu-30-flex-i",
      "name": "IDP Autonivelante de poliuretano flexible para interiores",
      "note": "Masa específica vigente 25/05/2026 y acabado brillante 30/07/2026 íntegros. HR máxima 60 %de la masa limita conjunto; sus ensayos a 70 %HR no amplían aplicación. Referencia Bfl-s 1 Aitex 2022 AN6310 del material: comprobar informe y configuración antes de certificar conjunto con primer/acabado. No certificado sanitario, actividad antibacteriana, norma deportiva, aptitud alimentaria/agua potable o clase 3 por usos enumerados. Aditivo fino máximo 90µm, promedio 40–60, no 9µm; para desgaste extremo/rodado fuente prefiere árido espolvoreado, sin dosis/clase inventadas. 39 %biocarbono se refiere a carbono total, no peso de resina. Incidencias de brillo 60°C, impactoN/m, unidad 1 kg/m³del acabado y dilución 10/15 % conservadas sin convertir en receta. Masa aromática protegida con acabado alifático no promete estabilidad absoluta de cualquier pigmento. Consultar las 16 páginas y cinco anexos.",
      "sheet": "IDP_Autonivelante_de_poliuretano_flexible_para_interiores.pdf",
      "systemUrl": "/products/idp-floor-pu-30-flex-i",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "resina-autonivelante-flexible-de-poliuretano",
          "phase": "Masa PU autonivelante flexible",
          "consumption": 3,
          "coats": 1,
          "name": "IDP Poliuretano Autonivelante Flexible",
          "commercialName": "IDP Poliuretano Autonivelante Flexible",
          "technicalName": "IDP Poliuretano Autonivelante Flexible",
          "sourceName": "IDP Poliuretano Autonivelante Flexible",
          "officialConsumption": 3,
          "packages": [],
          "sheet": "IDP_Poliuretano_Autonivelante_Flexible_0dfc4091-3ac0-4552-9a37-d68b7d2d6450.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-autonivelante-flexible-de-poliuretano"
        },
        {
          "productId": "recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante",
          "phase": "Acabado PU alifático acuoso brillante pigmentado",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Poliuretano Alifático al Agua Brillante",
          "commercialName": "IDP Poliuretano Alifático al Agua Brillante",
          "technicalName": "IDP Poliuretano Alifático al Agua Brillante",
          "sourceName": "IDP Poliuretano Alifático al Agua Brillante",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Poliuretano_Alifatico_al_Agua_Brillante.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante"
        }
      ],
      "commercialName": "IDP Autonivelante de poliuretano flexible para interior",
      "technicalName": "Sistema técnico de autonivelante de poliuretano flexible para interior",
      "description": "Pavimento autonivelante flexible de poliuretano bicomponente para hormigón interior, con imprimación epoxi independiente y acabado alifático acuoso brillante pigmentado de pavimentos. Selección lisa sin carga añadida, árido y aditivo opcionales separados.",
      "applications": "Pavimentos interiores de aparcamientos, centros comerciales, oficinas, clínicas, hospitales y pistas deportivas que requieran un acabado flexible y tolerante a movimientos y fisuras.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliuretano Autonivelante Flexible | IDP Poliuretano Alifático al Agua Brillante | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Aditivo Antideslizante"
    },
    {
      "id": "idp-floor-pu-10-sport",
      "name": "IDP Revestimiento de poliuretano alifático para pavimentos deportivos",
      "note": "Resumen 01/04/2025 describe 2 K pero prescribe acabado Floortop 1 K exacto F02-032: se corrige identidad a MONOCOMPONENTE al disolvente sin cambiar formulación. Primer epoxi sí A+B. Selección hormigón primer 0,50 + pigmentado 0,15+0,10=0,75; no doble 0,25 ni barniz incoloro automático. Incoloro opcional del mismo producto 0,10 separado; no barniz acuoso satinado/mate. Vinilo/FLEX, árido y marcajes no activados en configuración hormigón. Sin homologación deportiva, absorción de impacto, rebote, EN14904/14877, clase 3 o apertura automática de público. Árido 0,4–0,9 a 1 kg/m³ del anexo conserva incidencia, sin conversión o traslado. SRI104,5–105,4 solo blanco, no gris ni ahorro garantizado. Química y limpieza deben respetar condiciones; isopropanol de limpieza localizada no resistencia a inmersión. Consultar 11 páginas y dos anexos completos.",
      "sheet": "IDP_Revestimiento_de_poliuretano_alifatico_para_pavimentos_deportivos.pdf",
      "systemUrl": "/products/idp-floor-pu-10-sport",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "revestimiento-monocomponente-para-pavimentos",
          "phase": "PU alifático 1K pigmentado: primera mano",
          "consumption": 0.15,
          "coats": 1,
          "name": "IDP Revestimiento Monocomponente para Pavimentos",
          "commercialName": "IDP Revestimiento Monocomponente para Pavimentos",
          "technicalName": "IDP Revestimiento Monocomponente para Pavimentos",
          "sourceName": "IDP Revestimiento Monocomponente para Pavimentos",
          "officialConsumption": 0.15,
          "packages": [],
          "sheet": "IDP_Revestimiento_Monocomponente_para_Pavimentos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/revestimiento-monocomponente-para-pavimentos"
        },
        {
          "productId": "revestimiento-monocomponente-para-pavimentos",
          "phase": "PU alifático 1K pigmentado: segunda mano",
          "consumption": 0.1,
          "coats": 1,
          "name": "IDP Revestimiento Monocomponente para Pavimentos",
          "commercialName": "IDP Revestimiento Monocomponente para Pavimentos",
          "technicalName": "IDP Revestimiento Monocomponente para Pavimentos",
          "sourceName": "IDP Revestimiento Monocomponente para Pavimentos",
          "officialConsumption": 0.1,
          "packages": [],
          "sheet": "IDP_Revestimiento_Monocomponente_para_Pavimentos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/revestimiento-monocomponente-para-pavimentos"
        }
      ],
      "commercialName": "IDP Poliuretano deportivo liso o antideslizante",
      "technicalName": "Sistema técnico de poliuretano deportivo liso o antideslizante",
      "description": "Revestimiento deportivo liso sobre hormigón seco mediante imprimación epoxi independiente y poliuretano alifático MONOCOMPONENTE pigmentado al disolvente, en dos manos desiguales de 0,15+0,10. Identidad 1 K corregida frente a descripción genérica 2 K del resumen.",
      "applications": "IDP Poliuretano deportivo liso o antideslizante es una opción ideal para el recubrimiento de pavimentos en pabellones y canchas deportivas multiuso.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Revestimiento Monocomponente para Pavimentos"
    },
    {
      "id": "idp-floor-pu-10-w-sport",
      "name": "IDP Revestimiento de poliuretano al agua para pavimentos deportivos",
      "note": "Referencia satinada exacta publicada en 4 p desde primaria 05/02/2025 actualmente enlazada, distinta de brillante/mate; no revisión 2026. Fuente deportiva 18/02/2026 asigna 0,25 pigmentado+0,10 satinado=0,35; cifra marginal 0,125 sin asignación no se suma como capa. Selección lisa de 0,85 excluye agua, marcajes, regularización y opciones. Cubrición del color comprobada; si requiere más manos, revisar receta/medición antes de obra. No EN14904, EN14877, homologación federativa, amortiguación, rebote o clase 3 sin ensayo de configuración. Dotación 1 kg/m³de otro grano en anexos no se convierte a kg/m² ni rellena el árido opcional sin cantidad. Satinado sólidos 33/100/48 incoherentes con 100:19 peso, brillo<10 %y agua oxigenada sin resultado se conservan; no cálculo teórico de espesor ni química copiada. Aditivo fino máximo 90µm, no 9; fuente prefiere árido para desgaste extremo/rodado sin habilitar esa variante automáticamente. Consultar 18 p y cinco anexos.",
      "sheet": "IDP_Revestimiento_de_poliuretano_al_agua_para_pavimentos_deportivos.pdf",
      "systemUrl": "/products/idp-floor-pu-10-w-sport",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "phase": "Imprimación epoxi base agua independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "productId": "recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante",
          "phase": "PU alifático acuoso PIGMENTADO",
          "consumption": 0.25,
          "coats": 1,
          "name": "IDP Poliuretano Alifático al Agua Brillante",
          "commercialName": "IDP Poliuretano Alifático al Agua Brillante",
          "technicalName": "IDP Poliuretano Alifático al Agua Brillante",
          "sourceName": "IDP Poliuretano Alifático al Agua Brillante",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Poliuretano_Alifatico_al_Agua_Brillante.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante"
        },
        {
          "productId": "idp-barniz-de-poliuretano-alifatico-al-agua-satinado",
          "phase": "Barniz PU acuoso SATINADO INCOLORO",
          "consumption": 0.1,
          "coats": 1,
          "name": "IDP Barniz de poliuretano alifático al agua satinado",
          "commercialName": "IDP Barniz de poliuretano alifático al agua satinado",
          "technicalName": "IDP Barniz de poliuretano alifático al agua satinado",
          "sourceName": "IDP Barniz de poliuretano alifático al agua satinado",
          "officialConsumption": 0.1,
          "packages": [],
          "sheet": "IDP_Barniz_de_poliuretano_alifatico_al_agua_satinado.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-barniz-de-poliuretano-alifatico-al-agua-satinado"
        }
      ],
      "commercialName": "IDP Poliuretano deportivo al agua",
      "technicalName": "Sistema técnico de poliuretano deportivo al agua",
      "description": "Revestimiento de película fina para hormigón deportivo compatible, con imprimación epoxi base agua independiente, una mano de poliuretano acuoso pigmentado y otra de barniz satinado incoloro específico. Configuración lisa, árido/aditivo opcionales separados y requisitos de uso comprobados según proyecto.",
      "applications": "IDP Poliuretano deportivo al agua es una opción ideal para el recubrimiento de pavimentos en pabellones y canchas deportivas multiuso.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Poliuretano Alifático al Agua Brillante | IDP Barniz de poliuretano alifático al agua satinado | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Aditivo Antideslizante"
    },
    {
      "id": "idp-floor-pu-20-w-sport",
      "name": "IDP Revestimiento multicapa de poliuretano al agua para pavimentos deportivos",
      "note": "Prescripción 08/10/2025 contrastada con brillante 30/07/2026 y satinado 05/02/2025 actualmente enlazado. Primer suma 0,25+0,20=0,45, no cifra nominal 0,40. Pigmentado actualizado a mínimo recomendado 0,25×2=0,50 frente 0,20×2 del resumen; cambio visible, no atribuido a original. Total 1,15 sin agua. Satinado 0,20 cumple su máximo/capa, no mate 0,15 ni brillante. Árido opcional 0,1–0,5 a 1–1,5 kg/m² sin referencia exacta no activado/no sustitución por 0,1–0,3 o 0,3–0,8. No añadir aditivo de otra receta. Unidades 1 kg/m³de otro árido en anexos no convertidas ni clase 3 trasladada. Sólidos satinados 33/100/48 incoherentes con 100:19 peso y casillaagua oxigenada vacía conservados, no cálculo teórico o dato químico rellenado. Sin EN14904/14877, homologación, absorción de impacto, rebote, antibacteriano, agua potable o aptitud de público expuesto por base agua. Consultar 14 p y tres anexos íntegros.",
      "sheet": "IDP_Revestimiento_multicapa_de_poliuretano_al_agua_para_pavimentos_deportivos.pdf",
      "systemUrl": "/products/idp-floor-pu-20-w-sport",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "phase": "Imprimación acuosa: primera mano",
          "consumption": 0.25,
          "coats": 1,
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "phase": "Imprimación acuosa: segunda mano",
          "consumption": 0.2,
          "coats": 1,
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "officialConsumption": 0.2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "productId": "recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante",
          "phase": "PU acuoso pigmentado",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Poliuretano Alifático al Agua Brillante",
          "commercialName": "IDP Poliuretano Alifático al Agua Brillante",
          "technicalName": "IDP Poliuretano Alifático al Agua Brillante",
          "sourceName": "IDP Poliuretano Alifático al Agua Brillante",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Poliuretano_Alifatico_al_Agua_Brillante.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante"
        },
        {
          "productId": "idp-barniz-de-poliuretano-alifatico-al-agua-satinado",
          "phase": "Barniz satinado incoloro",
          "consumption": 0.2,
          "coats": 1,
          "name": "IDP Barniz de poliuretano alifático al agua satinado",
          "commercialName": "IDP Barniz de poliuretano alifático al agua satinado",
          "technicalName": "IDP Barniz de poliuretano alifático al agua satinado",
          "sourceName": "IDP Barniz de poliuretano alifático al agua satinado",
          "officialConsumption": 0.2,
          "packages": [],
          "sheet": "IDP_Barniz_de_poliuretano_alifatico_al_agua_satinado.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-barniz-de-poliuretano-alifatico-al-agua-satinado"
        }
      ],
      "commercialName": "IDP Poliuretano deportivo al agua liso o antideslizante",
      "technicalName": "Sistema técnico de poliuretano deportivo al agua liso o antideslizante",
      "description": "Revestimiento multicapa deportivo acuoso sobre imprimación epoxi base agua independiente, dos manos pigmentadas y una de barniz satinado incoloro específico. Configuración lisa con corrección visible de suma de primer y dosis vigente del pigmentado.",
      "applications": "IDP Poliuretano deportivo al agua liso o antideslizante es una opción ideal para el recubrimiento de pavimentos en pabellones y canchas deportivas multiuso exterior e interior.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Poliuretano Alifático al Agua Brillante | IDP Barniz de poliuretano alifático al agua satinado"
    },
    {
      "id": "idp-floor-ep-10",
      "name": "IDP Epoxi pigmentado liso o rugoso",
      "note": "Cálculo inicial de la versión LISA: dos manos de imprimación (0,40–0,50 total) y dos de revestimiento (0,60–1,00 total). La versión RUGOSA añade expresamente una fase de IDP Árido de Cuarzo 0,3–0,8 mm a 1 kg/m² sobre la primera mano fresca; no está sumada por defecto. Valores iniciales resinas 1,25 kg/m², antes de merma. Soporte y ambiente del conjunto 15–30 °C; HR máxima 80 %. Repintado del revestimiento epoxi desde su aplicación: a 10 °C mínimo 24 h y máximo 3 días; a 23 °C mínimo 12 h y máximo 36 h. No interpolar otros climas sin confirmación; fuera de ventana preparar y comprobar adherencia. Imprimación con proporción y ventana propias, distintas. Mezcla del revestimiento A: B 100:25 en PESO, 300–400 rpm durante 1–2 min. Proteger del agua y condensación 24 h; evitar agua estancada 7 días. Curado: a 23 °C peatones 24 h, ligero 2 días y completo 6 días; a 10 °C 36 h, 4 y 8 días. Protección frente a agua y condensación 48 h por guía del sistema, más estricta que 24 h generales del producto. Árido opcional 1 kg/m²solo sobre primera mano fresca del revestimiento, excluido del inicial liso. Otra variante de guía 0,20+0,30 de primer con anclaje SIN dotación no se activa ni hereda 1 kg del acabado.",
      "sheet": "IDP_Epoxi_pigmentado_liso_o_rugoso_b40eeb29-9af5-4632-a62b-761f08f673dc.pdf",
      "systemUrl": "/products/idp-floor-ep-10",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación",
          "consumption": 0.225,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.225,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "phase": "Recubrimiento",
          "consumption": 0.4,
          "coats": 2,
          "name": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "sourceName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "officialConsumption": 0.4,
          "packages": [],
          "sheet": "IDP_Revestimiento_Epoxi_de_Altas_Prestaciones_c45d6c11-2735-44ce-9ab8-915b7e49d21f.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "commercialName": "IDP Epoxi pigmentado liso o rugoso",
      "technicalName": "Sistema técnico de epoxi pigmentado liso o rugoso",
      "description": "Sistema bi-componente a base de resinas epoxi, pigmentado, con acabado liso o rugoso, para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Epoxi pigmentado liso o rugoso es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, y parkings entre otros.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Revestimiento Epoxi de Altas Prestaciones | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-floor-ep-10-w",
      "name": "IDP Revestimiento epoxi al agua para pavimentos",
      "note": "Resumen 10/07/2025 indica pintura 0,30–0,50 TOTAL pero dos manos 0,15–0,20: ficha de producto 13/05/2024 enlazada por catálogo 2026 exige mínimo 0,25 POR MANO. Se corrige IDP a 0,25×2=0,50, total inicial 1,00 con primer, y se conserva contradicción visible. No ejecutar dosis inferior ni habilitar colores claros con 0,50 si requieren 0,600. Árido opcional 0,1–0,5 a 1 kg/m² sin referencia exacta no activado, no sustitución por 0,1–0,3 o 0,3–0,8. Clase 3 de otro grano imprime 1 kg/m³ en anexo, sin conversión inventada. Pintura satinada exacta, sin barniz añadido, sin antibacteriano, agua potable o contacto alimentario. Fuego Bfl-s 1 y clases de producto no certifican todo conjunto. Química superficial 24 h 25°C no inmersión ni tabla del primer. Humedad residual no autoriza capilaridad/presión negativa. Consultar 10 páginas y dos anexos completos.",
      "sheet": "IDP_Revestimiento_epoxi_al_agua_para_pavimentos.pdf",
      "systemUrl": "/products/idp-floor-ep-10-w",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "phase": "Imprimación epoxi base agua independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "productId": "pintura-epoxi-base-agua-de-dos-componentes-para-suelos",
          "phase": "Pintura epoxi acuosa pigmentada satinada",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Pintura Epoxi al Agua",
          "commercialName": "IDP Pintura Epoxi al Agua",
          "technicalName": "IDP Pintura Epoxi al Agua",
          "sourceName": "IDP Pintura Epoxi al Agua",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Pintura_Epoxi_al_Agua_d9f1d32b-d529-4603-b45f-bd17c4e813c8.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/pintura-epoxi-base-agua-de-dos-componentes-para-suelos"
        }
      ],
      "commercialName": "IDP Epoxi al agua liso o rugoso",
      "technicalName": "Sistema técnico de epoxi al agua liso o rugoso",
      "description": "Revestimiento de película fina epoxi acuosa pigmentada satinada sobre imprimación epoxi base agua independiente. Configuración lisa de color medio/oscuro y dosis por mano corregida expresamente al mínimo de la ficha del producto.",
      "applications": "El sistema IDP Epoxi al agua liso o rugoso es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, y parkings entre otros.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Pintura Epoxi al Agua"
    },
    {
      "id": "idp-floor-ep-10-w-ab",
      "name": "IDP Revestimiento epoxi al agua antibacteriano para suelos y paredes",
      "note": "Actividad declarada ISO 846 e ISO 22196 de formulación de origen; no certificado sanitario IDP, esterilidad o prevención de infecciones de toda la instalación. Mantener limpieza/desinfección y controles sin ampliar intervalos por una afirmación comercial. Fuente de revestimiento 08/05/2020 actualmente enlazada y revalidada el 01/11/2026, no revisión 2026. Incidencias originales de unidad de viscosidad, adhesión 4,0 sin unidad y fila térmica incoherente conservadas en anexo, sin rellenar por analogía. Mezclas pigmentado/incoloro/imprimaciones diferentes. Masa inicial 0,95 excluye agua y barniz, color claro requiere tres manos, no dos. Imprimación alternativa 100:47 PESO/100:51 VOLUMEN requiere dotación/procedimiento propios antes de activación. Consultar ficha completa y tres anexos.",
      "sheet": "IDP_Revestimiento_epoxi_al_agua_antibacteriano_para_suelos_y_paredes.pdf",
      "systemUrl": "/products/idp-floor-ep-10-w-ab",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "phase": "Imprimación base agua, dos manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "productId": "idp-revestimiento-epoxi-al-agua-antibacteriano-y-antifungico",
          "phase": "Revestimiento pigmentado claro, tres manos",
          "consumption": 0.15,
          "coats": 3,
          "name": "IDP Revestimiento epoxi al agua antibacteriano y antifúngico",
          "commercialName": "IDP Revestimiento epoxi al agua antibacteriano y antifúngico",
          "technicalName": "IDP Revestimiento epoxi al agua antibacteriano y antifúngico",
          "sourceName": "IDP Revestimiento epoxi al agua antibacteriano y antifúngico",
          "officialConsumption": 0.15,
          "packages": [],
          "sheet": "IDP_Revestimiento_epoxi_al_agua_antibacteriano_y_antifungico.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-epoxi-al-agua-antibacteriano-y-antifungico"
        }
      ],
      "commercialName": "IDP Epoxi al agua antibacteriano",
      "technicalName": "Sistema técnico de epoxi al agua antibacteriano",
      "description": "Revestimiento epoxi acuoso de película fina con actividad antibacteriana y antifúngica declarada en origen, sobre imprimación epoxi base agua independiente. Configuración clara de tres manos, con datos propios de cada producto.",
      "applications": "El sistema IDP Epoxi al agua antibacteriano es una opción ideal para el recubrimiento de suelos y paredes en hospitales , clínicas, industrias farmacéuticas, industria alimentaria, clínicas veterinarias, etc.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Revestimiento epoxi al agua antibacteriano y antifúngico | IDP Imprimación Epoxi Universal"
    },
    {
      "id": "idp-floor-ep-20",
      "name": "IDP Epoxi antideslizante de alta resistencia",
      "note": "Resumen 08/10/2025 contrastado íntegro. Selección primer 0,50 dos 0,25, anclajecuarzo 0,3–0,8 mm 0,50, intermediaepoxi 0,40, espolvoreomismoárido 1,25, selladoepoxi 0,60 TOTALdos 0,30. Total 3,25;341,25 kg 100 m²+5 %. Se actualiza expresamente sellado histórico 0,50 a 0,60, dentrodelrango 0,40–0,60 para respetar mínimo de colores claros y dos manos. Anclaje incluido conforme a resumenactual; catálogoantiguolodenomina opcional, no copiar esa variante como la inicial. Repintado del revestimiento epoxi desde su aplicación: a 10 °C mínimo 24 h y máximo 3 días; a 23 °C mínimo 12 h y máximo 36 h. No interpolar otros climas sin confirmación; fuera de ventana preparar y comprobar adherencia. Imprimación con proporción y ventana propias, distintas. Mezcla del revestimiento A: B 100:25 en PESO, 300–400 rpm durante 1–2 min. Proteger del agua y condensación 24 h; evitar agua estancada 7 días. Curado: a 23 °C peatones 24 h, ligero 2 días y completo 6 días; a 10 °C 36 h, 4 y 8 días.",
      "sheet": "IDP_Epoxi_antideslizante_de_alta_resistencia_78bd4956-2bd2-45c6-885c-f5bc33df4e33.pdf",
      "systemUrl": "/products/idp-floor-ep-20",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Árido de anclaje",
          "consumption": 0.5,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 0.5,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "phase": "Capa intermedia",
          "consumption": 0.4,
          "coats": 1,
          "name": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "sourceName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "officialConsumption": 0.4,
          "packages": [],
          "sheet": "IDP_Revestimiento_Epoxi_de_Altas_Prestaciones_c45d6c11-2735-44ce-9ab8-915b7e49d21f.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Espolvoreo intermedio",
          "consumption": 1.25,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 1.25,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "phase": "Sellado",
          "consumption": 0.3,
          "coats": 2,
          "name": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "sourceName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "officialConsumption": 0.3,
          "packages": [],
          "sheet": "IDP_Revestimiento_Epoxi_de_Altas_Prestaciones_c45d6c11-2735-44ce-9ab8-915b7e49d21f.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "commercialName": "IDP Epoxi antideslizante de alta resistencia",
      "technicalName": "Sistema técnico de epoxi antideslizante de alta resistencia",
      "description": "Sistema bicomponente 100% solidos a base de resinas epoxy de alta resistencia mecánica y química, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón.",
      "applications": "IDP Epoxi antideslizante de alta resistencia es una opción ideal para el recubrimiento de pavimentos industriales, comerciales, y almacenes.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Revestimiento Epoxi de Altas Prestaciones | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-floor-ep-20-cd",
      "name": "IDP Multicapa epoxi conductivo",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-floor-ep-20-cd-es.pdf",
      "systemUrl": "/products/idp-floor-ep-20-cd",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "imprimacion-conductiva-para-pavimentos-antiestaticos",
          "name": "Imprimación conductiva para pavimentos antiestáticos",
          "sourceName": "Imprimación conductiva IDP aplicada a rodillo sobre el soporte sellado",
          "consumption": 0.15,
          "officialConsumption": 0.15,
          "officialLabel": "0,15 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-003.pdf",
          "commercialName": "IDP Imprimación Conductiva",
          "technicalName": "Imprimación conductiva para pavimentos antiestáticos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-conductiva-para-pavimentos-antiestaticos"
        },
        {
          "phase": "Fondo",
          "productId": "imprimacion-conductiva-para-pavimentos-antiestaticos",
          "name": "Imprimación conductiva para pavimentos antiestáticos",
          "sourceName": "Fondo",
          "consumption": 2.75,
          "officialConsumption": 2.75,
          "officialLabel": "2,5-3 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-003.pdf",
          "commercialName": "IDP Imprimación Conductiva",
          "technicalName": "Imprimación conductiva para pavimentos antiestáticos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-conductiva-para-pavimentos-antiestaticos"
        },
        {
          "phase": "Acabado",
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "name": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "sourceName": "Acabado epoxi pigmentado IDP aplicado con llana de goma",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-030.pdf",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "commercialName": "IDP Multicapa epoxi conductivo",
      "technicalName": "Sistema técnico de multicapa epoxi conductivo",
      "description": "Sistema multicapa industrial y decorativo basado en resinas epoxi, Epoxy 100 y áridos de cuarzo CD.",
      "applications": "Aplicable en electrónica y áreas esd, industria general y mantenimiento, logística y almacenes, industria mecánica y automoción, industria química y farmacéutica, sanidad, laboratorios y salas limpias, conforme al soporte, la preparación y las condiciones reales de obra.",
      "keywords": "IDP Imprimación Conductiva | Imprimación conductiva para pavimentos antiestáticos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos | IDP Cinta Conductora de Cobre | Cinta conductora de cobre para pavimentos antiestáticos"
    },
    {
      "id": "idp-floor-ep-20-os8",
      "name": "IDP Epoxi antideslizante para parkings",
      "note": "Receta y consumos conservados según prescripción contrastada. Repintado del revestimiento epoxi desde su aplicación: a 10 °C mínimo 24 h y máximo 3 días; a 23 °C mínimo 12 h y máximo 36 h. No interpolar otros climas sin confirmación; fuera de ventana preparar y comprobar adherencia. Imprimación con proporción y ventana propias, distintas. Mezcla del revestimiento A: B 100:25 en PESO, 300–400 rpm durante 1–2 min. Proteger del agua y condensación 24 h; evitar agua estancada 7 días. Curado: a 23 °C peatones 24 h, ligero 2 días y completo 6 días; a 10 °C 36 h, 4 y 8 días. Ficha completa de 20 páginas con 5 anexos vigentes íntegros; no certificado automático del sistema ni clasificación de resbaladicidad por analogía.",
      "sheet": "IDP_Epoxi_antideslizante_para_parkings_e42035a9-deea-4437-ad03-61a72be2bcb0.pdf",
      "systemUrl": "/products/idp-floor-ep-20-os8",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-revestimiento-epoxi-incoloro-100-solidos",
          "phase": "Intermedia: ligante INCOLORO",
          "consumption": 0.8,
          "coats": 1,
          "name": "IDP Revestimiento epoxi incoloro 100 % sólidos",
          "commercialName": "IDP Revestimiento epoxi incoloro 100 % sólidos",
          "technicalName": "IDP Revestimiento epoxi incoloro 100 % sólidos",
          "sourceName": "IDP Revestimiento epoxi incoloro 100 % sólidos",
          "officialConsumption": 0.8,
          "packages": [],
          "sheet": "IDP_Revestimiento_epoxi_incoloro_100_solidos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-epoxi-incoloro-100-solidos"
        },
        {
          "productId": "idp-arido-de-cuarzo-0-1-0-3-mm",
          "phase": "Intermedia: carga FINA 0,1–0,3",
          "consumption": 0.4,
          "coats": 1,
          "name": "IDP Árido de cuarzo 0,1–0,3 mm",
          "commercialName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "technicalName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "sourceName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "officialConsumption": 0.4,
          "packages": [],
          "sheet": "IDP_Arido_de_cuarzo_0_1_0_3_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-0-1-0-3-mm"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Espolvoreo principal en fresco",
          "consumption": 3,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 3,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "phase": "Sellado epoxi PIGMENTADO",
          "consumption": 0.3,
          "coats": 2,
          "name": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "sourceName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "officialConsumption": 0.3,
          "packages": [],
          "sheet": "IDP_Revestimiento_Epoxi_de_Altas_Prestaciones_c45d6c11-2735-44ce-9ab8-915b7e49d21f.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "commercialName": "IDP Epoxi antideslizante para parkings",
      "technicalName": "Sistema técnico de epoxi antideslizante para parkings",
      "description": "Sistema bicomponente 100% solidos a base de resinas epoxy de alta resistencia mecánica y química, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón.",
      "applications": "IDP Epoxi antideslizante para parkings es una opción ideal para el recubrimiento de pavimentos de parkings en locales industriales, comerciales y residenciales.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Revestimiento epoxi incoloro 100 % sólidos | IDP Árido de cuarzo 0,1–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Revestimiento Epoxi de Altas Prestaciones"
    },
    {
      "id": "idp-floor-ep-20-plus",
      "name": "IDP Epoxi antideslizante industrial y comercial",
      "note": "Receta y consumos conservados según prescripción contrastada. Repintado del revestimiento epoxi desde su aplicación: a 10 °C mínimo 24 h y máximo 3 días; a 23 °C mínimo 12 h y máximo 36 h. No interpolar otros climas sin confirmación; fuera de ventana preparar y comprobar adherencia. Imprimación con proporción y ventana propias, distintas. Mezcla del revestimiento A: B 100:25 en PESO, 300–400 rpm durante 1–2 min. Proteger del agua y condensación 24 h; evitar agua estancada 7 días. Curado: a 23 °C peatones 24 h, ligero 2 días y completo 6 días; a 10 °C 36 h, 4 y 8 días. Ficha completa de 16 páginas con 4 anexos vigentes íntegros; no certificado automático del sistema ni clasificación de resbaladicidad por analogía.",
      "sheet": "IDP_Epoxi_antideslizante_industrial_y_comercial_7d1c93fb-5393-4cad-badc-6a8af0fa1ac9.pdf",
      "systemUrl": "/products/idp-floor-ep-20-plus",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "phase": "Resina de capa intermedia",
          "consumption": 1.3333333333333333,
          "coats": 1,
          "name": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "sourceName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "officialConsumption": 1.3333333333333333,
          "packages": [],
          "sheet": "IDP_Revestimiento_Epoxi_de_Altas_Prestaciones_c45d6c11-2735-44ce-9ab8-915b7e49d21f.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        },
        {
          "productId": "idp-arido-de-cuarzo-0-1-0-3-mm",
          "phase": "Carga fina de capa intermedia",
          "consumption": 0.6666666666666666,
          "coats": 1,
          "name": "IDP Árido de cuarzo 0,1–0,3 mm",
          "commercialName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "technicalName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "sourceName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "officialConsumption": 0.6666666666666666,
          "packages": [],
          "sheet": "IDP_Arido_de_cuarzo_0_1_0_3_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-0-1-0-3-mm"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Espolvoreo en fresco",
          "consumption": 3,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 3,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "phase": "Sellado epoxi",
          "consumption": 0.3,
          "coats": 2,
          "name": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "sourceName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "officialConsumption": 0.3,
          "packages": [],
          "sheet": "IDP_Revestimiento_Epoxi_de_Altas_Prestaciones_c45d6c11-2735-44ce-9ab8-915b7e49d21f.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "commercialName": "IDP Epoxi antideslizante industrial y comercial",
      "technicalName": "Sistema técnico de epoxi antideslizante industrial y comercial",
      "description": "Sistema bicomponente 100% solidos a base de resinas epoxy de alta resistencia mecánica y química, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón.",
      "applications": "IDP Epoxi antideslizante de alta resistencia PLUS es una opción ideal para el recubrimiento de pavimentos industriales, comerciales, y almacenes.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Revestimiento Epoxi de Altas Prestaciones | IDP Árido de cuarzo 0,1–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-floor-ep-20-r",
      "name": "IDP Epoxi rugoso antideslizante",
      "note": "Receta y consumos conservados según prescripción contrastada. Repintado del revestimiento epoxi desde su aplicación: a 10 °C mínimo 24 h y máximo 3 días; a 23 °C mínimo 12 h y máximo 36 h. No interpolar otros climas sin confirmación; fuera de ventana preparar y comprobar adherencia. Imprimación con proporción y ventana propias, distintas. Mezcla del revestimiento A: B 100:25 en PESO, 300–400 rpm durante 1–2 min. Proteger del agua y condensación 24 h; evitar agua estancada 7 días. Curado: a 23 °C peatones 24 h, ligero 2 días y completo 6 días; a 10 °C 36 h, 4 y 8 días. Ficha completa de 14 páginas con 3 anexos vigentes íntegros; no certificado automático del sistema ni clasificación de resbaladicidad por analogía.",
      "sheet": "IDP_Epoxi_rugoso_antideslizante_b063aef2-0024-4ff4-892f-e1b2358bfd4a.pdf",
      "systemUrl": "/products/idp-floor-ep-20-r",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Base: ligante",
          "consumption": 0.65,
          "coats": 1,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.65,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Base: carga 1:1",
          "consumption": 0.65,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 0.65,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "productId": "arido-de-cuarzo-idp",
          "phase": "Espolvoreo",
          "consumption": 4.5,
          "coats": 1,
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 4.5,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "phase": "Sellado",
          "consumption": 0.35,
          "coats": 2,
          "name": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "sourceName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "officialConsumption": 0.35,
          "packages": [],
          "sheet": "IDP_Revestimiento_Epoxi_de_Altas_Prestaciones_c45d6c11-2735-44ce-9ab8-915b7e49d21f.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "commercialName": "IDP Epoxi rugoso antideslizante",
      "technicalName": "Sistema técnico de epoxi rugoso antideslizante",
      "description": "Sistema bicomponente a base de resinas epoxy, pigmentado, con acabado rugoso, (anti-slip), para la protección de pavimentos de hormigón.",
      "applications": "IDP Epoxi rugoso antideslizante es una opción ideal para el recubrimiento de pavimentos en rampas de parkings comerciales, residenciales e industriales.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Revestimiento Epoxi de Altas Prestaciones"
    },
    {
      "id": "idp-floor-ep-20-w",
      "name": "IDP Epoxi al agua rugoso",
      "note": "Imprimación independiente 0,50 TOTAL (2 × 0,25); capa intermedia 2,00 de MEZCLA resina:cuarzo fino 0,1–0,3 mm 1:0,5 = resina 1,333333 + fino 0,666667; espolvoreo cuarzo 0,3–0,8 mm 3,00; sellado epoxi al agua 0,50 TOTAL (2 × 0,25). Total 6,00 kg/m²; para 100 m² + 5 %: 630,00 kg. Corrección expresa: original 0,40 total en dos manos incumple mínimo de producto 0,25 por mano. Colores claros RAL 1003, 1014, 2010, 3002 y 9003 (Grupo 1) requieren mínimo 0,60 de sellado: dos de 0,30, sistema 6,10 y cálculo 640,50 kg. Anclaje opcional 0,50–1,00 aparte, no incluido. No sustituir cuarzo fino por grueso, ni duplicar consumos por manos. Repintar una vez seco al tacto y dentro de las 24 h siguientes, condicionado a curado y adherencia. Espesor nominal aproximado 2–2,5 mm, no equivalencia kg/m²=mm; no clase antideslizante automática.",
      "sheet": "IDP_Epoxi_al_agua_rugoso_15974db7-c52e-41be-8e4c-e71bf753984a.pdf",
      "systemUrl": "/products/idp-floor-ep-20-w",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "imprimacion-epoxi-para-sistemas-de-impermeabilizacion",
          "name": "IDP Imprimación Epoxi Base Agua",
          "commercialName": "IDP Imprimación Epoxi Base Agua",
          "technicalName": "IDP Imprimación Epoxi Base Agua",
          "sourceName": "IDP Imprimación Epoxi Base Agua",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-epoxi-para-sistemas-de-impermeabilizacion"
        },
        {
          "phase": "Resina de capa intermedia",
          "productId": "pintura-epoxi-base-agua-de-dos-componentes-para-suelos",
          "name": "IDP Pintura Epoxi al Agua",
          "commercialName": "IDP Pintura Epoxi al Agua",
          "technicalName": "IDP Pintura Epoxi al Agua",
          "sourceName": "IDP Pintura Epoxi al Agua",
          "consumption": 1.3333333333333333,
          "officialConsumption": 1.3333333333333333,
          "officialLabel": "1,333333 kg/m²; parte de mezcla total 2,00",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Pintura_Epoxi_al_Agua_d9f1d32b-d529-4603-b45f-bd17c4e813c8.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/pintura-epoxi-base-agua-de-dos-componentes-para-suelos"
        },
        {
          "phase": "Carga fina de capa intermedia",
          "productId": "idp-arido-de-cuarzo-0-1-0-3-mm",
          "name": "IDP Árido de cuarzo 0,1–0,3 mm",
          "commercialName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "technicalName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "sourceName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "consumption": 0.6666666666666666,
          "officialConsumption": 0.6666666666666666,
          "officialLabel": "0,666667 kg/m²; resina:árido 1:0,5; mezcla TOTAL 2,00",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "IDP_Arido_de_cuarzo_0_1_0_3_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-0-1-0-3-mm"
        },
        {
          "phase": "Espolvoreo en fresco",
          "productId": "arido-de-cuarzo-idp",
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "consumption": 3,
          "officialConsumption": 3,
          "officialLabel": "3,00 kg/m²; retirar exceso tras curado",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Sellado epoxi al agua",
          "productId": "pintura-epoxi-base-agua-de-dos-componentes-para-suelos",
          "name": "IDP Pintura Epoxi al Agua",
          "commercialName": "IDP Pintura Epoxi al Agua",
          "technicalName": "IDP Pintura Epoxi al Agua",
          "sourceName": "IDP Pintura Epoxi al Agua",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Pintura_Epoxi_al_Agua_d9f1d32b-d529-4603-b45f-bd17c4e813c8.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/pintura-epoxi-base-agua-de-dos-componentes-para-suelos"
        }
      ],
      "commercialName": "IDP Epoxi al agua rugoso",
      "technicalName": "Sistema técnico de epoxi al agua rugoso",
      "description": "Sistema bicomponente a base de resinas epoxy hidrodiluibles, pigmentado, con acabado rugoso para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Epoxi al agua rugoso es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, lonjas, industria alimentaria.",
      "keywords": "IDP Imprimación Epoxi Base Agua | IDP Pintura Epoxi al Agua | IDP Árido de cuarzo 0,1–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-floor-ep-30",
      "name": "IDP Epoxi antideslizante 100 % sólidos",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-floor-ep-30-es.pdf",
      "systemUrl": "/products/idp-floor-ep-30",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Capa Intermedia",
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "name": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "sourceName": "EP Nivel + agregados relación 1:0.5",
          "consumption": 3,
          "officialConsumption": 3,
          "officialLabel": "3 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-030.pdf",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "commercialName": "IDP Epoxi antideslizante 100 % sólidos",
      "technicalName": "Sistema técnico de epoxi antideslizante 100 % sólidos",
      "description": "Sistema bicomponente 100% solidos a base de resinas epoxy, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón.",
      "applications": "IDP Epoxi antideslizante 100 % sólidos es una opción ideal para el recubrimiento de pavimentos industriales, comerciales, y almacenes.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos"
    },
    {
      "id": "idp-floor-ep-30-ab",
      "name": "IDP Autonivelante epoxi antibacteriano con acabado de poliuretano alifático",
      "note": "Masa y acabado son dos formulaciones específicas con actividad de origen ISO 846/22196; no sustituir por resinas convencionales ni atribuir certificado sanitario IDP, esterilidad, prevención de infecciones o mayor intervalo de higiene. Mantener limpieza/desinfección. Conjunto no 100 % sólidos: acabado acuoso pigmentado 67 % de no volátiles, incoloro 49 %. Fuente 2020 actualmente enlazada, no revisión 2026. Contraste español 2014: unidad de viscosidad y reaplicación; discrepancias de adhesión, densidad, pot life, secado y química de masa explícitas en anexo, sin corregir por analogía. No se garantiza adhesión contractual sin informe/configuración real. Clase 3 histórica de acabado no se atribuye automáticamente al sistema. Selección inicial sin carga opcional: grano 0,3 mm y base de 30–40 % deben definirse antes de activar, no sustituir por otro intervalo ni sumar a 3 kg automáticamente. Consultar ficha 18 p/anexos.",
      "sheet": "IDP_Autonivelante_epoxi_antibacteriano_con_acabado_de_poliuretano_alifatico.pdf",
      "systemUrl": "/products/idp-floor-ep-30-ab",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente, dos manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-autonivelante-epoxi-antibacteriano-y-antifungico",
          "phase": "Autonivelante epoxi sin carga añadida",
          "consumption": 3,
          "coats": 1,
          "name": "IDP Autonivelante epoxi antibacteriano y antifúngico",
          "commercialName": "IDP Autonivelante epoxi antibacteriano y antifúngico",
          "technicalName": "IDP Autonivelante epoxi antibacteriano y antifúngico",
          "sourceName": "IDP Autonivelante epoxi antibacteriano y antifúngico",
          "officialConsumption": 3,
          "packages": [],
          "sheet": "IDP_Autonivelante_epoxi_antibacteriano_y_antifungico_d4ed427e-f216-4381-935b-0cfaa778d1a8.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-autonivelante-epoxi-antibacteriano-y-antifungico"
        },
        {
          "productId": "idp-acabado-de-poliuretano-alifatico-al-agua-antibacteriano",
          "phase": "Acabado PU acuoso pigmentado, dos manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Acabado de poliuretano alifático al agua antibacteriano",
          "commercialName": "IDP Acabado de poliuretano alifático al agua antibacteriano",
          "technicalName": "IDP Acabado de poliuretano alifático al agua antibacteriano",
          "sourceName": "IDP Acabado de poliuretano alifático al agua antibacteriano",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Acabado_de_poliuretano_alifatico_al_agua_antibacteriano.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-acabado-de-poliuretano-alifatico-al-agua-antibacteriano"
        }
      ],
      "commercialName": "IDP Autonivelante epoxi antibacteriano y antifúngico",
      "technicalName": "Sistema técnico de autonivelante epoxi antibacteriano y antifúngico",
      "description": "Pavimento continuo con imprimación epoxi independiente, masa autonivelante epoxi y acabado específico de poliuretano alifático acuoso, ambos con actividad antibacteriana y antifúngica declarada. Selección lisa sin carga o anclaje opcionales.",
      "applications": "El sistema IDP Autonivelante epoxi antibacteriano y antifúngico es una opción ideal para el recubrimiento de pavimentos en locales tipo salas blancas, quirófanos, etc.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Autonivelante epoxi antibacteriano y antifúngico | IDP Acabado de poliuretano alifático al agua antibacteriano | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-floor-ep-30-cd",
      "name": "IDP Autonivelante epoxi conductivo",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-floor-ep-30-cd-es.pdf",
      "systemUrl": "/products/idp-floor-ep-30-cd",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Primer",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0.5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Primer",
          "productId": "diluyente-para-sistemas-epoxi-bicomponentes",
          "name": "Diluyente para sistemas epoxi bicomponentes",
          "sourceName": "IDP Disolvente",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "250 g/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f07-089.pdf",
          "commercialName": "IDP Diluyente para Epoxi 2K",
          "technicalName": "Diluyente para sistemas epoxi bicomponentes",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/diluyente-para-sistemas-epoxi-bicomponentes"
        },
        {
          "phase": "Primer Antiestático",
          "productId": "imprimacion-conductiva-para-pavimentos-antiestaticos",
          "name": "Imprimación conductiva para pavimentos antiestáticos",
          "sourceName": "Primer Black",
          "consumption": 0.15,
          "officialConsumption": 0.15,
          "officialLabel": "0,150 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-003.pdf",
          "commercialName": "IDP Imprimación Conductiva",
          "technicalName": "Imprimación conductiva para pavimentos antiestáticos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-conductiva-para-pavimentos-antiestaticos"
        },
        {
          "phase": "Capa De Recubrimiento",
          "productId": "revestimiento-autonivelante-conductivo-para-pavimentos-antiestaticos",
          "name": "Revestimiento autonivelante conductivo para pavimentos antiestáticos",
          "sourceName": "Level CD",
          "consumption": 2.125,
          "officialConsumption": 2.125,
          "officialLabel": "2-2,25 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-031.pdf",
          "commercialName": "IDP Revestimiento Autonivelante Conductivo",
          "technicalName": "Revestimiento autonivelante conductivo para pavimentos antiestáticos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/revestimiento-autonivelante-conductivo-para-pavimentos-antiestaticos"
        }
      ],
      "commercialName": "IDP Autonivelante epoxi conductivo",
      "technicalName": "Sistema técnico de autonivelante epoxi conductivo",
      "description": "Sistema autonivelante conductivo basado en resinas epoxi 100% solidos para la protección de superficies de hormigón.",
      "applications": "El sistema IDP Autonivelante epoxi conductivo es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, grandes superficies, que requieran de un sistema conductivo.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Diluyente para Epoxi 2K | Diluyente para sistemas epoxi bicomponentes | IDP Imprimación Conductiva | Imprimación conductiva para pavimentos antiestáticos | IDP Revestimiento Autonivelante Conductivo | Revestimiento autonivelante conductivo para pavimentos antiestáticos | IDP Cinta Conductora de Cobre | Cinta conductora de cobre para pavimentos antiestáticos"
    },
    {
      "id": "idp-floor-ep-40",
      "name": "IDP Capa autonivelante epoxi de regularización con cuarzo fino",
      "note": "Rendimiento específico del sistema ycuarzo 1,9 kg/m²/mm frente a orientación genérica actual del ligante 2 kg/m²/mm: se conserva prescripción específica, con paño ymedición real de espesor/consumo, no densidad universal. Primera diluida 10–15 %del resumen NOactivada: selección sin diluir compatible con ficha actual. Aaprox 100/B98 no justifican 100 %absoluto del conjunto. Alternativas NOsumadas: fina 1:0,5 a 1,7 kg/m²/mm, media 1:1 a 1,9, gruesa 15–20 mmcon unión 0,3–0,5 y 1:8 a 2,2 kg/m²/mm; curva 25 %cada 0,1–0,5/0,4–0,7/0,7–1,2/2–4, no sustituir por cuarzo fino. Anclaje opcional 0,3–0,8 a 1 kgdistinto del espolvoreo opcional 0,4–0,8 aprox 4 kg, referencia exacta de este último no acreditada yfuera de receta. Acabado pigmentado opcionaldos 0,2–0,25 noactivado; contrastar mínimos del producto/color antes de medirlo. Sin conductividad, clase 3, certificado del conjunto o curado de otra resina. Datos ydiscrepancias íntegros en PDF; no se declara cerrada la rama gruesa por seleccionar intermedia.",
      "sheet": "IDP_Capa_autonivelante_epoxi_de_regularizacion_con_cuarzo_fino.pdf",
      "systemUrl": "/products/idp-floor-ep-40",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación independiente, dos manos de0,25",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-epoxy-100",
          "phase": "Ligante A+B del mortero1:1por masa",
          "consumption": 1.9,
          "coats": 1,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 1.9,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-arido-de-cuarzo-0-1-0-3-mm",
          "phase": "Carga fina del mortero1:1por masa",
          "consumption": 1.9,
          "coats": 1,
          "name": "IDP Árido de cuarzo 0,1–0,3 mm",
          "commercialName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "technicalName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "sourceName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "officialConsumption": 1.9,
          "packages": [],
          "sheet": "IDP_Arido_de_cuarzo_0_1_0_3_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-0-1-0-3-mm"
        }
      ],
      "commercialName": "IDP Epoxi con áridos naturales para regularización",
      "technicalName": "Sistema técnico de epoxi con áridos naturales para regularización",
      "description": "Capa intermedia autonivelante epoxi con cuarzo natural fino 0,1–0,3 mm, nominal 2 mm, imprimación independiente. Nueve páginas con ambas fichas de componente completas. Configuración inicial sin espolvoreos o acabado opcionales.",
      "applications": "El sistema IDP Epoxi con áridos naturales para regularización es una opción ideal para la nivelación de suelos en naves industriales, almacenes, garajes, fábricas.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Árido de cuarzo 0,1–0,3 mm"
    },
    {
      "id": "idp-floor-ep-20-cd-deco",
      "name": "IDP Multicapa conductivo de cuarzo color",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-floor-ep-20-cd-deco-es.pdf",
      "systemUrl": "/products/idp-floor-ep-20-cd-deco",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "imprimacion-conductiva-para-pavimentos-antiestaticos",
          "name": "Imprimación conductiva para pavimentos antiestáticos",
          "sourceName": "Imprimación conductiva IDP aplicada a rodillo sobre el soporte sellado",
          "consumption": 0.15,
          "officialConsumption": 0.15,
          "officialLabel": "0,15 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-003.pdf",
          "commercialName": "IDP Imprimación Conductiva",
          "technicalName": "Imprimación conductiva para pavimentos antiestáticos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/imprimacion-conductiva-para-pavimentos-antiestaticos"
        },
        {
          "phase": "Acabado",
          "productId": "ligante-transparente-para-acabados-epoxi-decorativos-efecto-marmol",
          "name": "Ligante transparente para acabados epoxi decorativos efecto mármol",
          "sourceName": "Acabado epoxi transparente IDP aplicado con llana de goma",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-020.pdf",
          "commercialName": "IDP Ligante Epoxi Decorativo",
          "technicalName": "Ligante transparente para acabados epoxi decorativos efecto mármol",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/ligante-transparente-para-acabados-epoxi-decorativos-efecto-marmol"
        }
      ],
      "commercialName": "IDP Multicapa conductivo de cuarzo color",
      "technicalName": "Sistema técnico de multicapa conductivo de cuarzo color",
      "description": "Sistema multicapa industrial y decorativo basado en resinas epoxi, Top CD, áridos de cuarzo coloreado y CUARZO COLOR CD.",
      "applications": "Aplicable en comercial, oficinas y espacios públicos, electrónica y áreas esd, industria general y mantenimiento, logística y almacenes, industria mecánica y automoción, industria química y farmacéutica, conforme al soporte, la preparación y las condiciones reales de obra.",
      "keywords": "IDP Imprimación Conductiva | Imprimación conductiva para pavimentos antiestáticos | IDP Ligante Epoxi Decorativo | Ligante transparente para acabados epoxi decorativos efecto mármol | IDP Cinta Conductora de Cobre | Cinta conductora de cobre para pavimentos antiestáticos"
    },
    {
      "id": "idp-floor-ep-20-decor-uv",
      "name": "IDP Epoxi decorativo con cuarzo coloreado y sellado alifático",
      "note": "Imprimación 0,50TOTAL(2×0,25), anclaje natural 0,50, intermedia 1,65 MEZCLA TOTAL resina: cuarzo 0–0,3 mm 1:1,5(resina 0,66+arena 0,99), espolvoreo COLOREADO0,3–0,8 mm con dotación superficial PENDIENTE y sellado poliaspártico TRANSPARENTE0,40TOTAL en una aplicación. Los 3,05 kg/m² son SUBTOTAL SIN árido coloreado, no total de sistema. La fuente imprime 3 kg/m³: no se cambia a 3 kg/m². Completar dotación acreditada de proyecto antes de ejecutar o emitir total/PDFde cantidades. Cero en ese campo señala medición por completar y no ausencia de árido. Epoxi subyacente puede amarillear: sellado alifático transparente no acredita pantalla UV; selección interior, sin promesa general UV/clase 3. No ligante pigmentado, no arena natural como coloreada, no relaciones A:B de versión pigmentada en acabado transparente.",
      "sheet": "IDP_Epoxi_decorativo_con_cuarzo_coloreado_y_sellado_alifatico.pdf",
      "systemUrl": "/products/idp-floor-ep-20-decor-uv",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación independiente",
          "productId": "idp-epoxy-100",
          "consumption": 0.25,
          "coats": 2,
          "officialLabel": "0,50 kg/m² TOTAL; 2×0,25",
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Anclaje de cuarzo NATURAL",
          "productId": "arido-de-cuarzo-idp",
          "consumption": 0.5,
          "coats": 1,
          "officialLabel": "0,50 kg/m²; no es cuarzo coloreado",
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "officialConsumption": 0.5,
          "packages": [],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Intermedia: resina epoxi INCOLORA",
          "productId": "idp-revestimiento-epoxi-incoloro-100-solidos",
          "consumption": 0.66,
          "coats": 1,
          "officialLabel": "0,66 kg/m² de resina; mezcla total 1,65 a 1:1,5",
          "name": "IDP Revestimiento epoxi incoloro 100 % sólidos",
          "commercialName": "IDP Revestimiento epoxi incoloro 100 % sólidos",
          "technicalName": "IDP Revestimiento epoxi incoloro 100 % sólidos",
          "sourceName": "IDP Revestimiento epoxi incoloro 100 % sólidos",
          "officialConsumption": 0.66,
          "packages": [],
          "sheet": "IDP_Revestimiento_epoxi_incoloro_100_solidos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-revestimiento-epoxi-incoloro-100-solidos"
        },
        {
          "phase": "Intermedia: cuarzo 0–0,3 mm",
          "productId": "idp-arido-de-cuarzo-0-0-3-mm",
          "consumption": 0.99,
          "coats": 1,
          "officialLabel": "0,99 kg/m² de arena; mezcla total 1,65",
          "name": "IDP Árido de cuarzo 0–0,3 mm",
          "commercialName": "IDP Árido de cuarzo 0–0,3 mm",
          "technicalName": "IDP Árido de cuarzo 0–0,3 mm",
          "sourceName": "IDP Árido de cuarzo 0–0,3 mm",
          "officialConsumption": 0.99,
          "packages": [],
          "sheet": "IDP_Arido_de_cuarzo_0_0_3_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-0-0-3-mm"
        },
        {
          "phase": "Espolvoreo COLOREADO: COMPLETAR dotación",
          "productId": "idp-arido-de-cuarzo-coloreado-0-3-0-8-mm",
          "consumption": 0,
          "coats": 1,
          "officialLabel": "PENDIENTEkg/m²; fuente 3 kg/m³ no convertible sin aclaración",
          "name": "IDP Árido de cuarzo coloreado 0,3–0,8 mm",
          "commercialName": "IDP Árido de cuarzo coloreado 0,3–0,8 mm",
          "technicalName": "IDP Árido de cuarzo coloreado 0,3–0,8 mm",
          "sourceName": "IDP Árido de cuarzo coloreado 0,3–0,8 mm",
          "officialConsumption": 0,
          "packages": [],
          "sheet": "IDP_Arido_de_cuarzo_coloreado_0_3_0_8_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-coloreado-0-3-0-8-mm"
        },
        {
          "phase": "Sellado alifático TRANSPARENTE",
          "productId": "recubrimiento-poliaspartico-de-aplicacion-manual",
          "consumption": 0.4,
          "coats": 1,
          "officialLabel": "0,40 kg/m² TOTAL; una aplicación",
          "name": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "commercialName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "technicalName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "sourceName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "officialConsumption": 0.4,
          "packages": [],
          "sheet": "IDP_Recubrimiento_Poliaspartico_de_Baja_Viscosidad_a3c74655-30bb-476f-ae3c-c7c4947ecf67.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliaspartico-de-aplicacion-manual"
        }
      ],
      "commercialName": "IDP Epoxi decorativo UV con cuarzo color",
      "technicalName": "Sistema técnico de epoxi decorativo uv con cuarzo color",
      "description": "Multicapa decorativo interior con epoxi incoloro cargado, espolvoreo de cuarzo coloreado y sellado poliaspártico alifático transparente. La dotación superficial del árido decorativo debe completarse para cerrar cantidades.",
      "applications": "El sistema IDP Epoxi decorativo UV con cuarzo color es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, cocinas, tiendas.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Revestimiento epoxi incoloro 100 % sólidos | IDP Árido de cuarzo 0–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Árido de cuarzo coloreado 0,3–0,8 mm | IDP Recubrimiento Poliaspártico de Baja Viscosidad"
    },
    {
      "id": "idp-floor-ep-30-deco-metal",
      "name": "IDP Epoxi decorativo efecto metálico",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-floor-ep-30-deco-metal-es.pdf",
      "systemUrl": "/products/idp-floor-ep-30-deco-metal",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 0.35,
          "officialConsumption": 0.35,
          "officialLabel": "0,3-0,4 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 0.75,
          "officialConsumption": 0.75,
          "officialLabel": "0,7-0,8 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Capa Intermedia",
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "name": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "sourceName": "EP Nivel Clear",
          "consumption": 1.1,
          "officialConsumption": 1.1,
          "officialLabel": "1-1,2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-030.pdf",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        },
        {
          "phase": "Capa De Sellado",
          "productId": "recubrimiento-de-poliuretano-alifatico-al-agua",
          "name": "Acabado alifático bicomponente de poliuretano en base agua",
          "sourceName": "Colodur ECO Mate ***",
          "consumption": 0.125,
          "officialConsumption": 0.125,
          "officialLabel": "0,1-0,15 kg/m²",
          "coats": 2,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f05-072.pdf",
          "commercialName": "IDP Acabado Alifático de Poliuretano al Agua",
          "technicalName": "Acabado alifático bicomponente de poliuretano en base agua",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-de-poliuretano-alifatico-al-agua"
        }
      ],
      "commercialName": "IDP Epoxi decorativo efecto metálico",
      "technicalName": "Sistema técnico de epoxi decorativo efecto metálico",
      "description": "Sistema bi-componente 100% sólidos a base de resinas epoxy, pigmentado con efectos metálicos para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Floor EP30 DECO es una opción ideal para el recubrimiento de pavimentos en locales comerciales, Garajes, tiendas, oficinas.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos | IDP Acabado Alifático de Poliuretano al Agua | Acabado alifático bicomponente de poliuretano en base agua | IDP Pigmento Decorativo para Epoxi | Pigmento decorativo para resinas epoxi"
    },
    {
      "id": "idp-floor-ep-30-deco-marmol",
      "name": "IDP Epoxi decorativo efecto mármol",
      "note": "Formulación inicial extraída de la ficha técnica del sistema. Puede ajustar cada gramaje según las condiciones reales de la obra.",
      "sheet": "ficha-sistema-idp-floor-ep-30-deco-marmol-es.pdf",
      "systemUrl": "/products/idp-floor-ep-30-deco-marmol",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 0.35,
          "officialConsumption": 0.35,
          "officialLabel": "0,3-0,4 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "Epoxy 100",
          "consumption": 0.75,
          "officialConsumption": 0.75,
          "officialLabel": "0,7-0,8 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Capa Intermedia",
          "productId": "ligante-transparente-para-acabados-epoxi-decorativos-efecto-marmol",
          "name": "Ligante transparente para acabados epoxi decorativos efecto mármol",
          "sourceName": "Pavistone Epoxy UV",
          "consumption": 1.1,
          "officialConsumption": 1.1,
          "officialLabel": "1-1,2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-020.pdf",
          "commercialName": "IDP Ligante Epoxi Decorativo",
          "technicalName": "Ligante transparente para acabados epoxi decorativos efecto mármol",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/ligante-transparente-para-acabados-epoxi-decorativos-efecto-marmol"
        },
        {
          "phase": "Capa De Sellado",
          "productId": "recubrimiento-de-poliuretano-alifatico-al-agua",
          "name": "Acabado alifático bicomponente de poliuretano en base agua",
          "sourceName": "Colodur ECO Mate ***",
          "consumption": 0.125,
          "officialConsumption": 0.125,
          "officialLabel": "0,1-0,15 kg/m²",
          "coats": 2,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f05-072.pdf",
          "commercialName": "IDP Acabado Alifático de Poliuretano al Agua",
          "technicalName": "Acabado alifático bicomponente de poliuretano en base agua",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-de-poliuretano-alifatico-al-agua"
        }
      ],
      "commercialName": "IDP Epoxi decorativo efecto mármol",
      "technicalName": "Sistema técnico de epoxi decorativo efecto mármol",
      "description": "Sistema bi-componente 100% sólidos a base de resinas epoxy, pigmentado con efectos mármol para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Epoxi antideslizante 100 % sólidos DECO es una opción ideal para el recubrimiento de pavimentos en locales comerciales, garajes, tiendas, oficinas.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Ligante Epoxi Decorativo | Ligante transparente para acabados epoxi decorativos efecto mármol | IDP Acabado Alifático de Poliuretano al Agua | Acabado alifático bicomponente de poliuretano en base agua | IDP Pigmento Decorativo para Epoxi | Pigmento decorativo para resinas epoxi"
    },
    {
      "id": "idp-floor-pa-30",
      "name": "IDP Pavimento de poliurea proyectada de curado lento",
      "note": "Referencia de membrana específica 13/10/2026 recuperada: proyección caliente, A poliol/poliamina, no poliurea pura ni frío. Acabado de pavimentos correcto F05-077 identificado, distinto de F05-072 limitado a mantenimiento de cubiertas; no trasladar esa restricción ni proporciones al producto correcto. No certificado sanitario, actividad antibacteriana, fuego o deslizamiento del conjunto sin ensayo. Clase 1/3 de fuente de acabado lleva unidad 1 kg/m³ incoherente: no convertir a kg/m² ni declarar clase por analogía. El código histórico PA no acredita poliaspártico: química real es poliurea proyectada. Selección inicial sin acabado; sellado opcional no sumado. Cambio de color de membrana vista esperado por UV. Consultar ficha completa 16 p y anexos.",
      "sheet": "IDP_Pavimento_de_poliurea_proyectada_de_curado_lento.pdf",
      "systemUrl": "/products/idp-floor-pa-30",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente, dos manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "idp-poliurea-proyectada-de-curado-lento-para-pavimentos",
          "phase": "Poliurea de curado lento, proyección caliente",
          "consumption": 2,
          "coats": 1,
          "name": "IDP Poliurea proyectada de curado lento para pavimentos",
          "commercialName": "IDP Poliurea proyectada de curado lento para pavimentos",
          "technicalName": "IDP Poliurea proyectada de curado lento para pavimentos",
          "sourceName": "IDP Poliurea proyectada de curado lento para pavimentos",
          "officialConsumption": 2,
          "packages": [],
          "sheet": "IDP_Poliurea_proyectada_de_curado_lento_para_pavimentos.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-poliurea-proyectada-de-curado-lento-para-pavimentos"
        }
      ],
      "commercialName": "IDP Poliaspártico alifático liso",
      "technicalName": "Sistema técnico de poliaspártico alifático liso",
      "description": "Pavimento de poliurea aromática de curado lento relativo, por proyección en caliente sobre imprimación epoxi independiente. Configuración inicial de membrana vista con sellado alifático y anclaje opcionales separados.",
      "applications": "IDP Poliaspártico alifático liso es una opción ideal para el recubrimiento de pavimentos industriales, comerciales, almacenes y grandes superficies.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Poliurea proyectada de curado lento para pavimentos | IDP Poliuretano Alifático al Agua Brillante | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-floor-pas-10",
      "name": "IDP Revestimiento poliaspártico alifático para pavimentos",
      "note": "Resumen 23/07/2025 permite acabado al disolvente o 100 LV: se selecciona solo baja viscosidad F02-027, edición española 23/04/2026. Su recomendación 0,25/capa se adopta en dos manos 0,50 TOTAL, actualización explícita de 0,30–0,40 del resumen, no mínimo universal inventado. Inglés 200 g/capa y ensayo 200 g versus español 250 g/capa y ensayo 1.000 g, con celda inglesa B aromático: no fusionar idiomas/química. Dos manos para color medio/oscuro con cubrición comprobada; claros mínimo tres con medición propia. Árido opcional 0,3–0,5 a 2–3 kg/m² sin referencia exacta no activado, no sustituir por 0,3–0,8. Clase 3 y fuego Bfl-s 1 del producto no certifican conjunto, rampa, otra dosis o color. No agua potable, contacto alimentario, impermeabilización o variante antibacteriana. Química superficial 24 h 25°C no inmersión; limpieza compatible y curado real. Consultar 10 páginas y dos anexos completos.",
      "sheet": "IDP_Revestimiento_poliaspartico_alifatico_para_pavimentos.pdf",
      "systemUrl": "/products/idp-floor-pas-10",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación epoxi independiente",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "recubrimiento-poliaspartico-de-aplicacion-manual",
          "phase": "Poliaspártico alifático pigmentado manual",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "commercialName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "technicalName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "sourceName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Recubrimiento_Poliaspartico_de_Baja_Viscosidad_a3c74655-30bb-476f-ae3c-c7c4947ecf67.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliaspartico-de-aplicacion-manual"
        }
      ],
      "commercialName": "IDP Poliaspártico de secado rápido liso o antideslizante",
      "technicalName": "Sistema técnico de poliaspártico de secado rápido liso o antideslizante",
      "description": "Revestimiento poliaspártico alifático bicomponente de baja viscosidad, de aplicación manual, pigmentado liso sobre imprimación epoxi independiente. Dosis de acabado actualizada explícitamente a la recomendación general de la edición española vigente del producto.",
      "applications": "El sistema IDP Poliaspártico de secado rápido liso o antideslizante es una opción ideal para el recubrimiento de suelos, rampas, zonas de acceso gracias a su rápido curado.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Recubrimiento Poliaspártico de Baja Viscosidad"
    },
    {
      "id": "idp-floor-pas-20",
      "name": "IDP Poliaspártico sin disolventes antideslizante",
      "note": "Configuración de GUÍA de aplicación: imprimación independiente 0,50 total (0,20 + 0,30), anclaje grueso 0,50, intermedia 1,20 TOTAL de MEZCLA resina:cuarzo fino 0,1–0,3 mm 1:0,8 (resina 0,666667 + fino 0,533333), espolvoreo grueso 2,50 y sellado pigmentado 0,50 total (2 × 0,25). Total 5,20 kg/m²; para 100 m² + 5 %: 546,00 kg. No duplicar los 1,20 como resina más carga. Guía prescribe espolvoreo 2–2,50, resumen de sistema 01/04/2025 indica 3,00: diferencia explícita, configuración alternativa con 3,00 suma 5,70 y calcula 598,50 kg, no se suman ambas. El espesor 2,2–2,6 mm es nominal del resumen de origen, no certificado del reparto de guía. Comprobar espesor y deslizamiento reales.",
      "sheet": "IDP_Poliaspartico_sin_disolventes_antideslizante_28b13f83-7fe9-462a-9c90-68bc12dfb9fb.pdf",
      "systemUrl": "/products/idp-floor-pas-20",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Primera mano de imprimación independiente",
          "productId": "idp-epoxy-100",
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.2,
          "officialConsumption": 0.2,
          "officialLabel": "0,20 kg/m²; primera de total 0,50",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Segunda mano de imprimación independiente",
          "productId": "idp-epoxy-100",
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.3,
          "officialConsumption": 0.3,
          "officialLabel": "0,30 kg/m²; segunda de total 0,50",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Anclaje sobre imprimación fresca",
          "productId": "arido-de-cuarzo-idp",
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,50 kg/m²; selección de 0,50–0,70",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Resina pigmentada de capa intermedia",
          "productId": "recubrimiento-poliaspartico-de-aplicacion-manual",
          "name": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "commercialName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "technicalName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "sourceName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "consumption": 0.6666666666666666,
          "officialConsumption": 0.6666666666666666,
          "officialLabel": "0,666667 kg/m²; parte de mezcla TOTAL 1,20",
          "coats": 1,
          "packages": [],
          "sheet": "IDP_Recubrimiento_Poliaspartico_de_Baja_Viscosidad_a3c74655-30bb-476f-ae3c-c7c4947ecf67.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliaspartico-de-aplicacion-manual"
        },
        {
          "phase": "Carga fina de capa intermedia",
          "productId": "idp-arido-de-cuarzo-0-1-0-3-mm",
          "name": "IDP Árido de cuarzo 0,1–0,3 mm",
          "commercialName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "technicalName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "sourceName": "IDP Árido de cuarzo 0,1–0,3 mm",
          "consumption": 0.5333333333333333,
          "officialConsumption": 0.5333333333333333,
          "officialLabel": "0,533333 kg/m²; relación 1:0,8; mezcla TOTAL 1,20",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "IDP_Arido_de_cuarzo_0_1_0_3_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-arido-de-cuarzo-0-1-0-3-mm"
        },
        {
          "phase": "Espolvoreo principal en fresco",
          "productId": "arido-de-cuarzo-idp",
          "name": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "sourceName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "consumption": 2.5,
          "officialConsumption": 2.5,
          "officialLabel": "2,50 kg/m² según GUÍA; retirar exceso tras curado",
          "coats": 1,
          "packages": [
            25
          ],
          "sheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Sellado poliaspártico PIGMENTADO",
          "productId": "recubrimiento-poliaspartico-de-aplicacion-manual",
          "name": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "commercialName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "technicalName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "sourceName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
          "consumption": 0.25,
          "officialConsumption": 0.25,
          "officialLabel": "0,50 kg/m² TOTAL; 2 × 0,25",
          "coats": 2,
          "packages": [],
          "sheet": "IDP_Recubrimiento_Poliaspartico_de_Baja_Viscosidad_a3c74655-30bb-476f-ae3c-c7c4947ecf67.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/recubrimiento-poliaspartico-de-aplicacion-manual"
        }
      ],
      "commercialName": "IDP Poliaspártico sin disolventes antideslizante",
      "technicalName": "Sistema técnico de poliaspártico sin disolventes antideslizante",
      "description": "Sistema bicomponente poliaspártico pigmentado, alifático, sin disolventes de acabado antideslizante. A diferencia de los sistemas clásicos, tiene un tiempo de gelificación y curado lo suficientemente largo como para permitir la mezcla y aplicación manual manteniendo un tiempo de secado mucho más corto que los sistemas de poliuretano de dos componentes.",
      "applications": "El sistema IDP Poliaspártico sin disolventes antideslizante es una elección ideal para el revestimiento de suelos, zonas húmedas, zonas de acceso, o rampas gracias a su rápido curado.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Recubrimiento Poliaspártico de Baja Viscosidad | IDP Árido de cuarzo 0,1–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    {
      "id": "idp-floor-ep-10-v",
      "name": "IDP Revestimiento epoxi 100 % sólidos para paramentos horizontales",
      "note": "Se mantiene la prescripción expresa del piloto ysu imagen horizontal aprobada; no acabado como imprimación. Nombre aprobado 100 %sólidos conserva denominación comercial y declaración de sólidos finales del revestimiento; A95/B98 yCOVfinal 95,9 g/Lse documentan, no ausencia deCOVglobal. Color inicial RAL 7011 (Grupo 1): dotación de revestimiento 0,50 total. Para claros RAL1003/1014/2010/3002/9003(Grupo 1), mínimo 0,60 de revestimiento requiere receta propia, cubrición puedeexigir másmanos. Mezclas/ventanas, caducidades yensayos de cada componente se distinguen: primer 12 meses, revestimiento 6 meses, no intervalos uniformes. El informeAitex 26 AN0899/Bfl-s 1 yvaloresmecánicos son de producto, no certificado nuevo del conjunto con primer diferente. Sin espesor, capa de cuarzo, conductividad, clase 3/OS8, potable o servicio 80°Cdelacabado por analogía. Ficha 12 pcon anexos íntegros actuales, nombres completos, enlaces directos, fondo blanco/texto azul, sin cajas oscuras.",
      "sheet": "IDP_Revestimiento_epoxi_100_solidos_para_paramentos_horizontales_33d09a9e-ac7d-41ce-b585-58b4ac68f899.pdf",
      "systemUrl": "/products/idp-floor-ep-10-v",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "idp-epoxy-100",
          "phase": "Imprimación independiente",
          "consumption": 0.3,
          "coats": 1,
          "name": "IDP Imprimación Epoxi Universal",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "IDP Imprimación Epoxi Universal",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "officialConsumption": 0.3,
          "packages": [],
          "sheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "phase": "Capa intermedia",
          "consumption": 0.25,
          "coats": 1,
          "name": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "sourceName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Revestimiento_Epoxi_de_Altas_Prestaciones_c45d6c11-2735-44ce-9ab8-915b7e49d21f.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        },
        {
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "phase": "Acabado",
          "consumption": 0.25,
          "coats": 1,
          "name": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "sourceName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Revestimiento_Epoxi_de_Altas_Prestaciones_c45d6c11-2735-44ce-9ab8-915b7e49d21f.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "commercialName": "IDP Revestimiento epoxi 100 % sólidos para paramentos horizontales",
      "technicalName": "Sistema técnico de revestimiento epoxi 100 % sólidos para paramentos horizontales",
      "description": "Revestimiento epoxi de película fina para paramentos horizontales de hormigón preparado, con imprimación independiente 0,30 e intermedia/acabado 0,25 cada una. Selección inicial RAL 7011 (Grupo 1), interior liso. Ficha completa 12 pcon ambos componentes íntegros actualizados.",
      "applications": "Paramentos horizontales en industria general, mantenimiento, logística, almacenes y áreas técnicas, conforme a las condiciones reales del soporte y de la obra.",
      "keywords": "IDP Imprimación Epoxi Universal | IDP Revestimiento Epoxi de Altas Prestaciones"
    },
    {
      "id": "idp-floor-ep-10-w-paramentos",
      "name": "IDP Revestimiento epoxi al agua para paramentos verticales",
      "note": "Base PROPIA IDP conservada, handle/URL/SKU/variantes sin duplicado. Antigua secuencia 0,20+0,25 corregida a 0,25+0,25 por mínimo vigente 0,250 por mano. Primera es pintura del MISMOproducto, no imprimación universal 100 %sólidos. Aplicación directa limitada a hormigón preparado sano, poco absorbente, con penetración/cubrición/adherencia verificadas; si necesita otraimprimación o barrera, prescribirla antes deobra, no receta universal. Referencia históricaES07/11/2018 menciona paredes, actualES13/05/2024 superficies/interiortúneles, no atribuirlepalabra ausente. EN13/05/2024 yESdifierenventana: criteriooperativosecoapto Y≤24 hDESDEprimera, no ampliar por secado frío/húmedo. Color inicialmedio/oscuro; clarosrequieren≥0,600, otra medición. No resina autonivelante, epoxi 100 %sólidos, PUalifático, antibacteriano, contactoalimentario, potable, salalimpia o uso sanitario certificado. ClaseBfl-s 1/EN13813 del componente paraPAVIMENTOSno se transfiere a paredB-s 1, d 0. Químicos 24 h 25°Csuperficialnoinmersión. Sinárido/clase 3 en muro. Temperatura/HR/ventilaciónpropias, no humedadporcentaje o edadinventados. RAL####(Grupo 1)reglacomercial, noensayo.",
      "sheet": "IDP_Revestimiento_epoxi_al_agua_para_paramentos_verticales_b42fa85b-4011-4349-bae2-7cfe7a3a3f60.pdf",
      "systemUrl": "/products/idp-floor-ep-10-w-paramentos",
      "imageKey": "industrial",
      "layers": [
        {
          "productId": "pintura-epoxi-base-agua-de-dos-componentes-para-suelos",
          "phase": "Epoxi al agua PIGMENTADO sobre paramento VERTICAL preparado; dos manos",
          "consumption": 0.25,
          "coats": 2,
          "name": "IDP Pintura Epoxi al Agua",
          "commercialName": "IDP Pintura Epoxi al Agua",
          "technicalName": "IDP Pintura Epoxi al Agua",
          "sourceName": "IDP Pintura Epoxi al Agua",
          "officialConsumption": 0.25,
          "packages": [],
          "sheet": "IDP_Pintura_Epoxi_al_Agua_d9f1d32b-d529-4603-b45f-bd17c4e813c8.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/pintura-epoxi-base-agua-de-dos-componentes-para-suelos"
        }
      ],
      "commercialName": "IDP Tratamiento epoxi al agua para paramentos",
      "technicalName": "Sistema técnico de tratamiento epoxi al agua para paramentos",
      "description": "Película fina epoxi bicomponente AL AGUA, pigmentada satinada, para paramentos VERTICALES interiores de hormigón preparado. Dos manos de 0,25 kg/m² del mismo producto; primera corregida frente a 0,20 antiguo por mínimo vigente. Ficha completa de seis páginas con anexo íntegro.",
      "applications": "Paramentos de industria alimentaria, industria general, logística, almacenes, sanidad, laboratorios y salas limpias.",
      "keywords": "IDP Pintura Epoxi al Agua"
    },
    {
      "id": "idp-floor-ep-30-multicapa",
      "name": "IDP Multicapa epoxi texturado de 3 mm",
      "note": "Configuración de proyecto para pavimento multicapa epoxi texturado de 3 mm. Los consumos marcados como de proyecto y las prestaciones del conjunto requieren validación documental.",
      "sheet": "ficha-sistema-idp-floor-ep-30-multicapa-es.pdf",
      "systemUrl": "/products/idp-floor-ep-30-multicapa",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.2,
          "officialConsumption": 0.2,
          "officialLabel": "0,2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "applicationMethod": "aplicada uniformemente con rodillo adecuado sobre el hormigón preparado",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Espolvoreo de anclaje",
          "productId": "arido-de-cuarzo-idp",
          "name": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "sourceName": "Árido de cuarzo lavado, seco y calibrado de granulometría 0,4-0,8 mm",
          "consumption": 0.5,
          "officialConsumption": null,
          "officialLabel": "",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f07-092.pdf",
          "projectConsumption": true,
          "applicationMethod": "espolvoreado uniformemente mientras la imprimación permanezca húmeda",
          "prescriptionNote": "Retirar por barrido o aspiración el árido no adherido tras el curado.",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Capa intermedia",
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "name": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "sourceName": "IDP MasterCoat 100 con kit predosificado de filler, fibras y áridos de proyecto",
          "consumption": 1.3,
          "officialConsumption": null,
          "officialLabel": "",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-030.pdf",
          "projectConsumption": true,
          "applicationMethod": "mezclada con el kit predosificado de cargas previsto en proyecto y extendida con llana metálica lisa",
          "prescriptionNote": "El consumo corresponde a la mezcla total de proyecto; confirmar por escrito la dosificación de ligante, filler, fibras y áridos antes de la ejecución.",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        },
        {
          "phase": "Espolvoreo a saturación",
          "productId": "arido-de-cuarzo-idp",
          "name": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "sourceName": "Árido de cuarzo lavado, seco y calibrado de granulometría 0,4-0,8 mm",
          "consumption": 3,
          "officialConsumption": null,
          "officialLabel": "",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f07-092.pdf",
          "projectConsumption": true,
          "applicationMethod": "espolvoreado uniformemente mientras la capa intermedia permanezca húmeda",
          "prescriptionNote": "Retirar por barrido o aspiración el árido excedente tras el curado.",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Sellado final",
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "name": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "sourceName": "IDP MasterCoat 100 pigmentado",
          "consumption": 0.5,
          "officialConsumption": 0.5,
          "officialLabel": "0,5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-030.pdf",
          "applicationMethod": "mezclada y homogeneizada según ficha técnica y aplicada con rastra de goma",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "prescription": {
        "status": "Prescripción de proyecto condicionada a la acreditación de la configuración final.",
        "summary": "5,5 kg/m² · proyecto a validar",
        "object": "Suministro y ejecución del sistema IDP Floor EP 30 Multicapa, pavimento multicapa a base de resinas epoxi 100 % sólidos y sin disolventes, de 3 mm de espesor total nominal aproximado, para interiores en cocinas, laboratorios, clínicas o áreas comerciales, con acabado texturado.",
        "substrate": "Aplicación sobre soporte de hormigón fratasado mecánicamente o semipulido, resistente, cohesivo, limpio y con planimetría adecuada. La preparación mecánica queda fuera de la medición descrita, pero constituye una condición previa obligatoria para la adherencia del sistema.",
        "thickness": "Espesor objetivo de proyecto: 3 mm nominales aproximados; comprobarlo en obra.",
        "finish": "Acabado objetivo: texturado, continuo y pigmentado.",
        "totalConsumption": "5,5 kg/m² (valor teórico de proyecto; validar en muestra y control de espesor)",
        "performance": [
          {
            "property": "Resbaladicidad",
            "target": "Rd > 45 y clase 3 conforme al marco vigente de UNE-EN 16165 y CTE DB-SUA",
            "evidenceStatus": "Pendiente de ensayo aplicable al acabado y granulometría exactos"
          },
          {
            "property": "Reacción al fuego",
            "target": "Bfl-s1 según UNE-EN 13501-1",
            "evidenceStatus": "Pendiente de DoP o informe aplicable al sistema completo de 3 mm"
          },
          {
            "property": "Curvas sanitarias",
            "target": "Ejecución contra muros cuando lo exija el proyecto",
            "evidenceStatus": "Pendiente de detalle constructivo, radio y mortero epoxi compatible"
          }
        ],
        "closing": "Aplicar todas las capas respetando mezclado, vida útil, ventanas de repintado y curado de las fichas vigentes. Incluir limpieza de la superficie, replanteo de juntas y paños, retirada de árido excedente y limpieza final. Ejecutar las curvas sanitarias únicamente cuando estén definidas en proyecto.",
        "limitations": "No se incluyen en esta partida la preparación mecánica del soporte ni las juntas de construcción, retracción, dilatación o perímetro, aunque deberán resolverse antes o durante la ejecución según el detalle de proyecto. No declarar Rd > 45, clase 3 ni Bfl-s1 como prestaciones acreditadas hasta disponer de documentación válida para esta configuración exacta."
      },
      "commercialName": "IDP Multicapa epoxi texturado de 3 mm",
      "technicalName": "Sistema técnico de multicapa epoxi texturado de 3 mm",
      "description": "Sistema multicapa epoxi 100 % sólidos, pigmentado y texturado, definido para un espesor nominal aproximado de 3 mm mediante imprimación, cuarzo, capa intermedia y sellado final.",
      "applications": "Pavimentos interiores de cocinas, laboratorios, clínicas y áreas comerciales.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos"
    },
    {
      "id": "idp-floor-ep-30-multicapa-ab",
      "name": "IDP Autonivelante epoxi multicapa antibacteriano semimate de 3 mm",
      "note": "Configuración de proyecto para pavimento autonivelante epoxi multicapa, texturado y de 3 mm. IDP MasterCoat 100 acredita la naturaleza epoxi 100 % sólidos de la capa autonivelante y del sellado; las prestaciones antibacterianas, semimate, Rd > 45, clase 3 y Bfl-s1 requieren homologación para la configuración completa. El color de proyecto es RAL 7016 (Grupo 1), sujeto a muestra física aprobada.",
      "sheet": "ficha-sistema-idp-floor-ep-30-multicapa-ab-es.pdf",
      "systemUrl": "/products/idp-floor-ep-30-multicapa-ab",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Imprimación",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.2,
          "officialConsumption": 0.2,
          "officialLabel": "0,2 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "applicationMethod": "aplicada uniformemente con rodillo adecuado sobre el hormigón preparado",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100"
        },
        {
          "phase": "Espolvoreo de anclaje",
          "productId": "arido-de-cuarzo-idp",
          "name": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "sourceName": "Árido de cuarzo lavado, seco y calibrado de granulometría 0,4-0,8 mm",
          "consumption": 0.5,
          "officialConsumption": null,
          "officialLabel": "",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f07-092.pdf",
          "projectConsumption": true,
          "applicationMethod": "espolvoreado uniformemente mientras la imprimación permanezca húmeda",
          "prescriptionNote": "Retirar por barrido o aspiración el árido no adherido tras el curado.",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Capa autonivelante intermedia",
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "name": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "sourceName": "IDP MasterCoat 100 con kit predosificado de filler, fibras y áridos de proyecto",
          "consumption": 1.3,
          "officialConsumption": null,
          "officialLabel": "",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-030.pdf",
          "projectConsumption": true,
          "applicationMethod": "mezclada con el kit predosificado de filler, fibras y áridos previsto en proyecto y extendida como capa autonivelante con llana metálica lisa",
          "prescriptionNote": "El consumo corresponde a la mezcla total de proyecto; confirmar por escrito la dosificación de ligante, filler, fibras y áridos antes de la ejecución.",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        },
        {
          "phase": "Espolvoreo a saturación",
          "productId": "arido-de-cuarzo-idp",
          "name": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "sourceName": "Árido de cuarzo lavado, seco y calibrado de granulometría 0,4-0,8 mm",
          "consumption": 3,
          "officialConsumption": null,
          "officialLabel": "",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f07-092.pdf",
          "projectConsumption": true,
          "applicationMethod": "espolvoreado uniformemente mientras la capa intermedia permanezca húmeda",
          "prescriptionNote": "Retirar por barrido o aspiración el árido excedente tras el curado.",
          "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
          "technicalName": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/arido-de-cuarzo-idp"
        },
        {
          "phase": "Sellado final epoxi",
          "productId": "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa",
          "name": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "sourceName": "IDP MasterCoat 100",
          "consumption": 0.5,
          "officialConsumption": null,
          "officialLabel": "0,4-0,5 kg/m²",
          "coats": 1,
          "packages": [],
          "sheet": "ficha-tecnica-ft-idp-f02-030.pdf",
          "projectConsumption": true,
          "applicationMethod": "mezclado y homogeneizado según ficha técnica, pigmentado para el color de proyecto y aplicado uniformemente con rastra de goma",
          "prescriptionNote": "La base epoxi y el consumo de sellado están amparados por la ficha de IDP MasterCoat 100. El acabado antibacteriano semimate, el color RAL 7016 (Grupo 1) y las prestaciones del conjunto deberán confirmarse mediante la formulación, muestra y documentación específicas del proyecto.",
          "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
          "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa"
        }
      ],
      "prescription": {
        "status": "Prescripción de proyecto condicionada a la homologación del acabado antibacteriano semimate y a los ensayos del sistema completo.",
        "summary": "5,5 kg/m² · proyecto condicionado",
        "object": "Suministro y ejecución del sistema IDP Floor EP 30 Multicapa AB, pavimento autonivelante epoxi multicapa a base de resinas epoxi 100 % sólidos y sin disolventes, de 3 mm de espesor total nominal aproximado, para interiores en cocinas, laboratorios, clínicas, salas limpias o áreas comerciales, con acabado objetivo texturado, antibacteriano, semimate y pigmentado en RAL 7016 (Grupo 1).",
        "substrate": "Aplicación sobre soporte de hormigón fratasado mecánicamente o semipulido, resistente, cohesivo, limpio y con planimetría adecuada. La preparación mecánica queda fuera de la medición descrita, pero constituye una condición previa obligatoria para la adherencia del sistema.",
        "thickness": "Espesor objetivo de proyecto: 3 mm nominales aproximados; comprobarlo mediante muestra previa y control en obra.",
        "finish": "Acabado objetivo: texturado, continuo, semimate, antibacteriano y pigmentado en RAL 7016 (Grupo 1). La naturaleza epoxi del sellado queda identificada; el carácter antibacteriano, el rango de brillo y la conformidad cromática deberán validarse sobre muestra y documentación de la formulación final.",
        "totalConsumption": "5,5 kg/m² (valor teórico de proyecto, incluido sellado epoxi de 0,5 kg/m²; validar dosificación, masa retenida y espesor)",
        "performance": [
          {
            "property": "Actividad antibacteriana",
            "target": "Actividad antibacteriana del acabado exacto; ISO 22196 cuando así lo exija el proyecto",
            "evidenceStatus": "Pendiente de informe de ensayo aplicable al producto y a la configuración finales"
          },
          {
            "property": "Aspecto y color",
            "target": "Semimate y RAL 7016 (Grupo 1), gris antracita",
            "evidenceStatus": "Pendiente de ficha, rango de brillo y muestra física aprobada"
          },
          {
            "property": "Resbaladicidad",
            "target": "Rd > 45 y clase 3 conforme al marco vigente de UNE-EN 16165 y CTE DB-SUA",
            "evidenceStatus": "Pendiente de ensayo con la granulometría y el sellado exactos"
          },
          {
            "property": "Reacción al fuego",
            "target": "Bfl-s1 según UNE-EN 13501-1",
            "evidenceStatus": "Pendiente de DoP o informe aplicable al sistema completo de 3 mm"
          },
          {
            "property": "Curvas sanitarias",
            "target": "Ejecución contra muros cuando lo exija el proyecto",
            "evidenceStatus": "Pendiente de detalle constructivo, radio y mortero compatible"
          }
        ],
        "closing": "Aplicar todas las capas respetando mezclado, vida útil, ventanas de repintado y curado de las fichas vigentes. Incluir limpieza de la superficie, replanteo de juntas y paños, retirada de árido excedente y limpieza final. Ejecutar las curvas sanitarias únicamente cuando estén definidas en proyecto.",
        "limitations": "No se incluyen en esta partida la preparación mecánica del soporte ni las juntas de construcción, retracción, dilatación o perímetro, aunque deberán resolverse según el detalle de proyecto. IDP MasterCoat 100 queda identificado como resina epoxi 100 % sólidos para la capa autonivelante y el sellado. No declarar como acreditadas la actividad antibacteriana, el acabado semimate, Rd > 45, clase 3 o Bfl-s1 hasta disponer de documentación válida para esta configuración exacta. RAL 7016 (Grupo 1) es el color prescrito y deberá aprobarse mediante muestra física; no constituye por sí mismo una certificación técnica."
      },
      "commercialName": "IDP Autonivelante epoxi multicapa antibacteriano semimate de 3 mm",
      "technicalName": "Sistema técnico de autonivelante epoxi multicapa antibacteriano semimate de 3 mm",
      "description": "Configuración de proyecto de pavimento autonivelante epoxi multicapa, 100 % sólidos y sin disolventes, pigmentado y texturado, de 3 mm nominales, con acabado objetivo antibacteriano semimate RAL 7016 (Grupo 1). La naturaleza epoxi de la capa autonivelante y del sellado queda identificada; las prestaciones finales están condicionadas a su acreditación.",
      "applications": "Pavimentos interiores de cocinas, laboratorios, clínicas, salas limpias y áreas comerciales que requieran una superficie continua, texturada y limpiable; la aptitud específica deberá acreditarse antes de contratar o ejecutar.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos"
    },
    {
      "id": "idp-floor-epoxy-100-antipolvo",
      "name": "IDP Sellado epoxi incoloro antipolvo para hormigón",
      "note": "Configuración específica de una sola mano de IDP Imprimación Epoxi Universal como tratamiento antipolvo transparente. El consumo general del producto depende de la absorción del soporte; este sistema limita el consumo de proyecto a 0,20-0,25 kg/m² y exige un paño de prueba que confirme el sellado con un máximo absoluto de 0,25 kg/m².",
      "sheet": "ficha-sistema-idp-floor-epoxy-100-antipolvo-es.pdf",
      "systemUrl": "/products/idp-floor-epoxy-100-antipolvo",
      "imageKey": "industrial",
      "layers": [
        {
          "phase": "Tratamiento antipolvo",
          "executionLabel": "una mano",
          "productId": "idp-epoxy-100",
          "name": "Imprimación epoxi universal bicomponente para soportes secos",
          "sourceName": "IDP Imprimación Epoxi Universal",
          "consumption": 0.25,
          "officialConsumption": null,
          "officialLabel": "0,20-0,25 kg/m² · máximo 0,25 kg/m²",
          "coats": 1,
          "packages": [
            15
          ],
          "sheet": "ficha-tecnica-ft-idp-f01-010.pdf",
          "projectConsumption": true,
          "applicationMethod": "sin diluir, aplicada uniformemente a brocha o rodillo sobre el hormigón preparado",
          "prescriptionNote": "El consumo general del producto depende de la absorción del soporte; esta configuración queda limitada por proyecto a 0,25 kg/m² y exige un paño de prueba que confirme el sellado.",
          "commercialName": "IDP Imprimación Epoxi Universal",
          "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/idp-epoxy-100",
          "relationType": "capa"
        }
      ],
      "prescription": {
        "status": "Prescripción específica de proyecto vinculada a IDP Imprimación Epoxi Universal y condicionada a un paño de prueba sobre el soporte real.",
        "summary": "1 mano · 0,20-0,25 kg/m² · máximo 0,25 kg/m²",
        "object": "Suministro y aplicación del IDP Sellado epoxi incoloro antipolvo para hormigón, sistema de película fina a base de IDP Imprimación Epoxi Universal, imprimación epoxi universal bicomponente de alto contenido en sólidos, incolora o ligeramente amarillenta, aplicada sin diluir en una mano mediante brocha o rodillo sobre pavimentos interiores de hormigón, con consumo de 0,20 a 0,25 kg/m² y límite máximo de 0,25 kg/m², para sellar el poro y reducir el desprendimiento superficial de polvo.",
        "substrate": "Aplicación sobre hormigón resistente, compacto, cohesivo, regular, seco y limpio, libre de polvo, lechada, grasas, aceites, curadores, pinturas y partículas sueltas. La preparación mecánica, aspiración, reparaciones y tratamiento de juntas son condiciones previas obligatorias y quedan fuera de esta partida salvo medición expresa.",
        "thickness": "Tratamiento de película fina. No se declara espesor seco nominal; el control se realiza por consumo y uniformidad de sellado.",
        "finish": "Incoloro o ligeramente amarillento y brillante, con aspecto condicionado por el color, la textura y la absorción del hormigón. No admite selección RAL.",
        "totalConsumption": "0,20-0,25 kg/m² de IDP Imprimación Epoxi Universal, sin superar 0,25 kg/m²",
        "performance": [
          {
            "property": "Función antipolvo",
            "target": "Sellar el poro superficial y reducir el desprendimiento de polvo del hormigón",
            "evidenceStatus": "Uso técnico vinculado a IDP Imprimación Epoxi Universal; validar el resultado sobre un paño de prueba del soporte real"
          },
          {
            "property": "Consumo de proyecto",
            "target": "0,20-0,25 kg/m² en una sola mano, con máximo absoluto de 0,25 kg/m²",
            "evidenceStatus": "Límite específico de esta configuración; comprobar absorción, continuidad y ausencia de zonas secas"
          },
          {
            "property": "Prestaciones reglamentarias",
            "target": "No se atribuyen clases de resbaladicidad, reacción al fuego ni resistencia química al conjunto",
            "evidenceStatus": "Requiere ensayo o documentación específica de la configuración acabada cuando el proyecto lo exija"
          }
        ],
        "closing": "Mezclar completamente los componentes A y B y aplicar dentro de la vida útil indicada en la ficha técnica vigente. Extender de forma continua, evitando charcos, acumulaciones y zonas sin cubrir. Respetar las condiciones ambientales, el curado y la puesta en servicio indicados por el fabricante. Incluir limpieza final y protección del tratamiento hasta su curado.",
        "limitations": "Si el soporte no queda uniformemente sellado con un máximo de 0,25 kg/m², esta configuración no es apta y deberá revisarse la prescripción; no se añadirá una segunda mano de forma implícita. No es un autonivelante, recrecido, regularizador, puente de fisuras, impermeabilización ni acabado pigmentado. No corrige soportes débiles, húmedos o contaminados. La exposición UV puede modificar el tono; no prescribir en exterior sin validación técnica específica."
      },
      "commercialName": "IDP Sellado epoxi incoloro antipolvo para hormigón",
      "technicalName": "Sistema técnico de sellado epoxi incoloro antipolvo para hormigón",
      "description": "Tratamiento superficial epoxi bicomponente de película fina, incoloro o ligeramente amarillento, ejecutado en una mano para sellar pavimentos interiores de hormigón y reducir el desprendimiento superficial de polvo.",
      "applications": "Almacenes, cuartos técnicos, garajes, talleres y zonas interiores de tráfico ligero sobre hormigón resistente, seco y cohesivo.",
      "keywords": "IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos"
    },
    {
      "id": "idp-floor-sport-pintura-acrilica-poroso",
      "systemUrl": "/products/idp-floor-sport-pintura-acrilica-poroso",
      "imageKey": "sports",
      "name": "IDP Pintura acrílica para pavimento deportivo poroso",
      "layers": [
        {
          "productId": "pintura-acrilica-deportiva",
          "phase": "Primera mano de pintura acrílica; hormigón poroso sano",
          "consumption": 0.2,
          "coats": 1,
          "name": "IDP Pintura acrílica deportiva",
          "commercialName": "IDP Pintura acrílica deportiva",
          "technicalName": "IDP Pintura acrílica deportiva",
          "sourceName": "IDP Pintura acrílica deportiva",
          "officialConsumption": 0.2,
          "packages": [],
          "sheet": "IDP_Pintura_acrilica_deportiva.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/pintura-acrilica-deportiva"
        },
        {
          "productId": "pintura-acrilica-deportiva",
          "phase": "Segunda mano de pintura acrílica sobre anterior seca",
          "consumption": 0.15,
          "coats": 1,
          "name": "IDP Pintura acrílica deportiva",
          "commercialName": "IDP Pintura acrílica deportiva",
          "technicalName": "IDP Pintura acrílica deportiva",
          "sourceName": "IDP Pintura acrílica deportiva",
          "officialConsumption": 0.15,
          "packages": [],
          "sheet": "IDP_Pintura_acrilica_deportiva.pdf",
          "documentStatus": "validada",
          "productUrl": "https://idpproductos.com/products/pintura-acrilica-deportiva"
        }
      ],
      "note": "Selección inicial sobre hormigón POROSO SANO:0,350 kg/m² pintura dos manos distintas 0,200/0,150 según ficha del SISTEMA. La ficha de PRODUCTO imprime gr/m², incidencia no corregida silenciosamente: aquí se usa prescripción propia explícita en kg/m² y paño medido. Consolidación acrílica 0,100 opcional requiere aclarar base producto/preparación; NO incluida ni calculada como masa pura. Su dilución 1:2 no especifica masa/volumen; no convertir por intuición. Variante de hormigón CONTINUO con epoxi MATE de origen sin referencia exacta/dosis no activada, no equivalencia con epoxi semibrillante disponible. Pintado sobre soporte arenado no permitido sin consolidación resuelta. Apertura 20 días desdeúltimamano y aptitud, no 15 días como polimerización total. Abrasión sistema 77 mg/H22/1000 UNE48250 frente a pintura 170 mg/1000 ISO5470-1: ensayos distintos, no promedio ni mejorvaloruniversal. Sin árido/cushion/barniz/perfilador añadidos; sin garantía drenante, clase 3, ITF, fuego o prevenciónlesiones. Mantener URL/SKU/precios/variantes.",
      "sheet": "IDP_Pintura_acrilica_para_pavimento_deportivo_poroso_2fe47a08-a7cf-4813-9805-7069edb036f8.pdf",
      "description": "Pintura acrílica deportiva al agua sobre hormigón poroso sano, dos manos diferentes de 0,200 y 0,150 kg/m². Consolidación acrílica local solo si el soporte la requiere; no incluida en la medición inicial. Ficha completa de ocho páginas y dos anexos.",
      "keywords": "IDP Ligante acrílico de reparación | IDP Pintura acrílica deportiva"
    },
    {
      "id": "sistema-idp-ag-rev",
      "systemUrl": "/products/sistema-idp-ag-rev",
      "imageKey": "sports",
      "name": "IDP Protección antigrafiti reversible y sacrificable para paramentos verticales",
      "layers": [
        {
          "productId": "idp-protector-antigrafiti-reversible-y-sacrificable-para-superficies-verticales",
          "phase": "Dos manos; reparto aritmético del total",
          "consumption": 0.165,
          "coats": 2,
          "name": "IDP Protector antigrafiti reversible y sacrificable para superficies verticales",
          "commercialName": "IDP Protector antigrafiti reversible y sacrificable para superficies verticales",
          "technicalName": "IDP Protector antigrafiti reversible y sacrificable para superficies verticales",
          "sourceName": "IDP Protector antigrafiti reversible y sacrificable para superficies verticales",
          "officialConsumption": 0.165,
          "packages": [],
          "sheet": "IDP_Protector_antigrafiti_reversible_y_sacrificable_para_superficies_verticales.pdf",
          "documentStatus": "Fuente técnica09/2025; consumo oficial actual en litros",
          "productUrl": "https://idpproductos.com/products/idp-protector-antigrafiti-reversible-y-sacrificable-para-superficies-verticales",
          "quantityUnit": "L",
          "officialLabel": "0,33 L/m² TOTAL en DOS manos; reparto aritmético0,165 ×2"
        }
      ],
      "note": "Fuente técnica vigente 09/2025 y página oficial de producto comprobada el 02/11/2026: aproximadamente 0,33 L/m² EN TOTAL para DOS manos. La calculadora expresa exclusivamente litros; 0,165 × 2 es un reparto aritmético de medición, no una dotación ensayada igual por mano. Ajustar al soporte y a la prueba. Presentación nominal de origen: 25 kg, sin volumen útil ni densidad vigentes declarados; NO convertir litros en kilogramos ni deducir número de envases. No se declaran pH ni plazo de conservación vigentes. Soporte absorbente completamente mojado; no absorbente seco. Primera mano seca al tacto antes de la segunda. Tras retirar el grafiti, reponer DOS manos completas en toda la zona limpiada. Limpieza exterior con agua fría y renovación de una o dos manos aproximadamente cada tres años según condiciones; equipos con agua caliente inmediatamente tras uso y antes de pausas, airless semanalmente en uso continuo. Algunas superficies necesitan imprimación específica: alternativa INACTIVA hasta identificar producto y compatibilidad. Consultar HDS vigente y su apartado13 para residuos. Las declaraciones del producto no certifican el sistema completo.",
      "sheet": "IDP_Proteccion_antigrafiti_reversible_y_sacrificable_para_paramentos_verticales.pdf",
      "description": "Protección antigrafiti acuosa monocomponente reversible y sacrificable para paramentos verticales compatibles. Consumo orientativo TOTAL de dos manos: 0,33 L/m²; tras retirar grafiti se repone la protección completa.",
      "keywords": "IDP Protector antigrafiti reversible y sacrificable para superficies verticales"
    }
  ]
};
//# sourceMappingURL=/cdn/shop/t/7/assets/idp-system-recipes.js.map?v=82176044672262351591793619647
